export default {
    "incentive": {
        "tier": {
            "maintain": "Seviye koru",
            "stage": "Aktiflik seviyesi",
            "graduation": "Mezuniyet",
            "creatorActivity": "Geçerli yayın günü",
            "gradLow": "Düşük",
            "gradMedium": "Orta",
            "gradHigh": "Yüksek",
            "incremental": "Tamamlama kademesi",
            "regional": "Bölgesel katkı",
            "regionalEarning": "Eşik geçildi — tüm üyeler bonus kazanıyor",
            "regionalBelow": "Eşiğin altında — bonus için oranı yükseltin"
        },
        "unit": {
            "diamonds": "elmas",
            "days": "gün",
            "hours": "saat",
            "stage": "seviye"
        },
        "caption": {
            "toMaintain": "Seviyeyi korumak için {n} elmas gerekiyor",
            "toRankUp": "Yükselmek için {n} elmas gerekiyor",
            "toLevelUp": "Seviye atlamak için {n} gün ve {h} gerekiyor",
            "toLevelUpDays": "Seviye atlamak için {n} gün gerekiyor",
            "toLevelUpHours": "Seviye atlamak için {h} gerekiyor",
            "toGraduate": "Mezun olmak için {n} elmas gerekiyor",
            "toValidDays": "Geçerli yayın gününe ulaşmak için {n} gün gerekiyor",
            "toCompletion": "Sonraki kademe için {n} elmas gerekiyor",
            "toContribute": "Geçerli yayıncı olmak için {n} gün ve {h} gerekiyor",
            "toContributeDays": "Geçerli yayıncı olmak için {n} gün gerekiyor",
            "toContributeHours": "Geçerli yayıncı olmak için {h} gerekiyor",
            "contributing": "Geçerli yayıncı ✓ — kohorta katkı veriyor"
        },
        "duration": {
            "hour": "saat",
            "minute": "dakika"
        },
        "push": {
            "nudge": {
                "title": "Devam et!",
                "body": "Hedefine çok yakınsın. Biraz daha çaba ile ulaşacaksın."
            }
        }
    },
    "incentives": {
        "view": {
            "title": "Teşvik Ayrıntıları",
            "subtitle": "Hedefe yakın yayıncıları it, doğru bildirimi gönder · veri: günlük snapshot"
        },
        "tab": {
            "rankup": "Yükselme Teşviki",
            "activeness": "Aktiflik Teşviki",
            "incremental": "Kademeli Artan Gelir",
            "regionalTier1": "Bölgesel · 1. Kademe",
            "regionalTier2": "Bölgesel · 2. Kademe",
            "regionalTier3": "Bölgesel · 3. Kademe+",
            "graduation": "İ.Ü. Mezuniyeti",
            "creatorActivity": "İ.Ü. Aktifliği"
        },
        "rail": {
            "actions": "{count} aksiyon"
        },
        "segment": {
            "all": "Tümü",
            "ready": "Hemen pushla",
            "atRisk": "Korumaya yakın",
            "closeToUp": "Yükselmeye yakın"
        },
        "search": {
            "user": "Yayıncı ara…",
            "manager": "Yönetici…"
        },
        "col": {
            "creator": "Yayıncı",
            "bonus": "Tahminî bonus katkısı",
            "rate": "Oran",
            "progress": "İlerleme",
            "validDays": "Uygun Gün",
            "validHours": "Uygun Saat",
            "action": "Aksiyon"
        },
        "row": {
            "vsLastMonth": "geçen aya göre",
            "dayShort": "g",
            "hourShort": "s",
            "levelTier": "Kademe {n}",
            "levelStage": "Seviye {n}",
            "diamonds": "elmas",
            "forecastPrefix": "yükselirse",
            "condOk": "Koşullar tamam ✓",
            "condNo": "Koşul eksik",
            "ready": "HAZIR",
            "push": "Push"
        },
        "state": {
            "loading": "Yükleniyor…",
            "empty": "Gösterilecek yayıncı bulunamadı."
        },
        "footer": {
            "total": "Toplam {count} yayıncı",
            "prev": "Önceki",
            "next": "Sonraki",
            "page": "Sayfa {current} / {total}"
        },
        "bulk": {
            "selected": "{count} seçili",
            "potential": "· ~{amount} potansiyel",
            "selectReady": "Hazır olanları seç",
            "notify": "Bildirim Gönder"
        },
        "notify": {
            "title": "Bildirim Gönder",
            "recipients": "{count} alıcıya gönderilecek",
            "mode": {
                "template": "Şablon",
                "free": "Serbest mesaj"
            },
            "previewLabel": "Önizleme",
            "previewTitle": "Hedefe az kaldı 🚀",
            "preview": "Hedefe {gap} 💎 kaldı 🚀",
            "templateLabel": "Şablon",
            "templatePlaceholder": "Şablon seçin",
            "freeMessageOption": "Serbest mesaj",
            "previewHeading": "Mesaj önizlemesi",
            "previewButton": "Önizle",
            "previewLoading": "Önizleme hazırlanıyor…",
            "previewEmpty": "Gösterilecek önizleme yok.",
            "titleLabel": "Başlık",
            "titlePlaceholder": "Bildirim başlığı",
            "messageLabel": "Mesaj",
            "messagePlaceholder": "Mesajınızı yazın…",
            "channelsLabel": "Kanallar",
            "channel": {
                "push": "Push",
                "sms": "SMS",
                "inApp": "Uygulama içi"
            },
            "cancel": "Vazgeç",
            "send": "Gönder",
            "sending": "Gönderiliyor…",
            "toast": {
                "successTitle": "Bildirim gönderildi",
                "success": "{dispatched} bildirim gönderildi, {skipped} atlandı.",
                "error": "Bildirim gönderilemedi."
            }
        },
        "month": {
            "0": "Ocak",
            "1": "Şubat",
            "2": "Mart",
            "3": "Nisan",
            "4": "Mayıs",
            "5": "Haziran",
            "6": "Temmuz",
            "7": "Ağustos",
            "8": "Eylül",
            "9": "Ekim",
            "10": "Kasım",
            "11": "Aralık"
        }
    },
    "iosBanner": {
        "title": "Haymen uygulaması",
        "desc": "Daha hızlı ve akıcı bir deneyim için uygulamayı indir.",
        "cta": "İndir",
        "close": "Kapat"
    },
    "spelEditor": {
        "placeholder": {
            "default": "#user.email == 'test@example.com'"
        },
        "hint": {
            "autocomplete": "Degiskenler icin #, ozellikler icin . yazin"
        }
    },
    "notification": {
        "group_message": "Grup Mesajı",
        "new_message": "Yeni Mesaj",
        "sent_message": "Bir mesaj gönderdi"
    },
    "i18n": {
        "toast": {
            "message": {
                "deleteError": "Çeviri silinirken bir hata oluştu.",
                "saveError": "Çeviri kaydedilirken bir hata oluştu.",
                "deleted": "Çeviri başarıyla silindi.",
                "saved": "Çeviri başarıyla kaydedildi.",
                "enterCustomLocale": "Lütfen geçerli bir dil kodu giriniz.",
                "importSuccess": "Çeviriler başarıyla içe aktarıldı."
            },
            "error": {
                "invalidJson": "Lütfen geçerli bir JSON dosyası seçin.",
                "readError": "Dosya okunamadı veya JSON formatı hatalı."
            }
        },
        "view": {
            "label": {
                "editTitle": "Çeviriyi Düzenle",
                "title": "Dil Yönetimi",
                "desc": "Sistem genelindeki metinleri ve çevirileri yönetin.",
                "createTitle": "Yeni Çeviri Ekle",
                "description": "Uygulamanız için dil anahtarlarını ve çevirileri yönetin."
            },
            "action": {
                "deleteConfirm": "Bu çeviriyi silmek istediğinizden emin misiniz? Bu işlem geri alınamaz.",
                "create": "Yeni Çeviri",
                "delete": "Çeviriyi Sil",
                "bulkUpload": "Toplu Yükle"
            }
        },
        "filter": {
            "module": "Modül"
        },
        "table": {
            "label": {
                "value": "Çeviri",
                "key": "Anahtar",
                "locale": "Dil",
                "module": "Modül"
            }
        },
        "form": {
            "label": {
                "value": "Çeviri Metni",
                "locale": "Dil Seçimi",
                "module": "Modül (Opsiyonel)",
                "key": "Dil Anahtarı"
            },
            "placeholder": {
                "value": "Metni buraya girin...",
                "key": "örn: common.labels.save"
            }
        },
        "modal": {
            "action": {
                "startImport": "Yüklemeyi Başlat"
            },
            "label": {
                "bulkTitle": "Toplu Yükleme",
                "dropZone": "JSON dosyasını buraya sürükleyin veya tıklayın"
            },
            "message": {
                "bulkDesc": "Hazırladığınız i18n JSON dosyasını buraya sürükleyin veya dosyayı seçin. Sistem tüm anahtarları otomatik olarak güncelleyecektir."
            }
        }
    },
    "policy": {
        "toast": {
            "message": {
                "updateError": "Yetkiler güncellenemedi",
                "saveError": "Politika kaydedilemedi",
                "updateSuccess": "Yetkiler güncellendi",
                "deleteError": "Silinemedi",
                "roleTemplatesError": "Rol şablonları güncellenemedi",
                "saveSuccess": "Politika kaydedildi",
                "roleTemplatesSuccess": "Rol şablonları başarıyla güncellendi",
                "loadError": "Veriler yüklenemedi",
                "deleteSuccess": "Politika silindi"
            }
        },
        "view": {
            "label": {
                "title": "Rol Profili",
                "desc": "Güvenlik politikalarını, rolleri ve izin matrislerini tanımlayın ve uygulayın.",
                "saveChanges": "Değişiklikleri Kaydet",
                "description": "Bu rol için varsayılan öznitelik şablonlarını tanımlayın",
                "noTemplates": "Tanımlanmış şablon yok",
                "pageTitle": "Erişim Kontrol Politikaları",
                "attributeTemplates": "Öznitelik Şablonları",
                "deleteMessage": "Bu politikayı silmek istediğinizden emin misiniz? Bu işlem geri alınamaz.",
                "deleteTitle": "Politika Silme",
                "policies": "Politikalarda ara...",
                "permissions": "Yetkilerde ara...",
                "addTemplate": "Şablon Ekle"
            },
            "tab": {
                "policies": "Öznitelik Politikaları",
                "roles": "Rol Profilleri",
                "matrix": "Yetki Matrisi",
                "users": "Kullanıcı – Yetki"
            },
            "action": {
                "newPolicy": "Yeni Politika"
            }
        },
        "users": {
            "usersAria": "Kullanıcılar",
            "permsAria": "Kullanıcının yetkileri",
            "searchUsers": "Kullanıcı ara",
            "searchPermissions": "Yetki ara",
            "filter": {
                "manager": "Menajer",
                "creator": "Yayıncı",
                "partner": "İş ortağı",
                "withOverrides": "İstisnası olanlar"
            },
            "empty": {
                "select": "Yetkilerini görmek için soldan bir kullanıcı seçin",
                "users": "Kullanıcı bulunamadı"
            },
            "summary": "Rol: {role} · {granted} verilen, {revoked} kapatılan",
            "onlyChanged": "Yalnız istisnalar",
            "col": {
                "permission": "Yetki",
                "inRole": "Rolde",
                "forUser": "Bu kişi için"
            },
            "inRole": {
                "yes": "Var",
                "no": "Yok"
            },
            "mode": {
                "role": "Rol gibi",
                "grant": "Ver",
                "revoke": "Kapat"
            },
            "save": "Kaydet",
            "reset": "Vazgeç",
            "toast": {
                "saved": "Yetkiler kaydedildi",
                "saveError": "Yetkiler kaydedilemedi",
                "loadError": "Yetkiler yüklenemedi"
            }
        },
        "form": {
            "label": {
                "core": "Temel Yapılandırma",
                "description": "Açıklama",
                "active": "Politika Aktif",
                "subtitleNew": "Yeni erişim kuralı tanımla",
                "subtitleEdit": "Politika mantığını güncelle",
                "scope": "örn. user:create",
                "condition": "Koşul (SpEL)",
                "titleNew": "Yeni Öznitelik Politikası",
                "titleEdit": "Politikayı Düzenle",
                "priority": "Öncelik",
                "logic": "Kural Mantığı & Meta",
                "effect": "Etki",
                "saveBtn": "Yapılandırmayı Kaydet",
                "saving": "Kaydediliyor...",
                "conditionHint": "Kullanılabilir: #user, #resource"
            }
        },
        "table": {
            "column": {
                "status": "Durum",
                "scope": "Kapsam",
                "effect": "Etki",
                "role": "Rol",
                "condition": "Koşul",
                "permission": "Yetki / Kapsam",
                "priority": "Öncelik"
            }
        }
    },
    "segments": {
        "view": {
            "action": {
                "create": "Segment Oluştur"
            },
            "label": {
                "titleNew": "Yeni Segment",
                "descEdit": "Segment mantığını güncelle",
                "titleEdit": "Segmenti Düzenle",
                "title": "Segmentler",
                "desc": "Yayıncı segmentlerini yönetin ve dinamik hedefleme kuralları tanımlayın.",
                "empty": "Segment bulunamadı. Başlamak için ilk segmentini oluştur.",
                "descNew": "Yeni kullanıcı segmenti tanımla",
                "noSegments": "Bu kullanıcı hiçbir segmentte değil."
            }
        },
        "table": {
            "column": {
                "status": "Durum",
                "description": "Açıklama",
                "name": "İsim",
                "code": "Kod",
                "condition": "Koşul"
            }
        },
        "form": {
            "label": {
                "name": "örn. Altın Üyeler",
                "active": "Aktiflik Durumu",
                "description": "Bu segmenti tanımlayın...",
                "code": "örn. ALTIN_UYELER",
                "rules": "Hedefleme Kuralları",
                "rulesDesc": "Kullanıcıların bu segmente dahil olması için gerekli mantığı tanımlayın.",
                "settingsDesc": "Segment görünürlüğünü ve etkinliğini kontrol et.",
                "settings": "Ayarlar",
                "activeDesc": "Bu segmenti küresel olarak etkinleştir veya devre dışı bırak.",
                "info": "Segment Bilgileri",
                "infoDesc": "Bu segmenti tanımlamak için temel detaylar."
            }
        },
        "actions": {
            "delete": "Segmenti Sil",
            "deleteConfirm": "Bu segmenti silmek istediğinizden emin misiniz?"
        },
        "builder": {
            "label": {
                "visual": "Görsel",
                "advanced": "Gelişmiş (SpEL)",
                "noRules": "Hedefleme kuralı tanımlanmamış.",
                "rulesHint": "Aşağıdaki TÜM kurallara uyan kullanıcılar bu segmente katılacaktır.",
                "newCondition": "Yeni Koşul",
                "attribute": "Özellik",
                "operator": "Operatör",
                "value": "Değer",
                "true": "Doğru",
                "false": "Yanlış"
            },
            "placeholder": {
                "rawExpression": "#user['attr'] > val",
                "selectAttribute": "Özellik Seçin",
                "operator": "Op",
                "enterValue": "Değer Girin"
            },
            "hint": {
                "spelExample": "Ham SpEL ifadeleri yazın. Örnek:"
            },
            "action": {
                "addCondition": "Koşul Ekle"
            }
        },
        "placeholder": { "spelExpression": "SpEL ifadesi yazın, örneğin #user.status == 'ACTIVE'" }
    },
    "requests": {
        "ruleStatus": {
            "remaining": "{n} kaldı",
            "showSteps": "Hak tablosunu gör",
            "hideSteps": "Hak tablosunu gizle"
        },
        "list": {
            "requestedBy": "Talep Eden",
            "createdByLabel": "Oluşturan: {name}"
        },
        "filter": {
            "status": "Durum Filtresi",
            "type": "Talep Tipi Filtersi",
            "manager": "Yönetici Filtresi"
        },
        "history": {
            "title": "Talep Geçmişi",
            "on_behalf_of": "adına",
            "on_behalf_created": "{owner} adına {creator} tarafından oluşturuldu",
            "created_by_suffix": "tarafından oluşturuldu"
        },
        "status": {
            "approved": "Onaylandı",
            "executed": "Gerçekleşti",
            "rejected": "Reddedildi",
            "submitted": "Bekliyor",
            "reviewing": "İnceleniyor",
            "draft": "Taslak"
        },
        "table": {
            "column": {
                "fields_count": "Alan Sayısı",
                "updated_at": "Son Güncelleme",
                "createdAt": "Oluşturulma Tarihi",
                "updatedAt": "Güncellenme Tarihi",
                "type": "Talep Tipi",
                "description": "Açıklama",
                "status": "Durum",
                "code": "Kod",
                "created_by": "Oluşturan",
                "manager": "Yönetici",
                "name": "Ad",
                "id": "Talep ID",
                "auto_approve": "Otomatik onay"
            }
        },
        "view": {
            "label": {
                "update_success": "Talep türü başarıyla güncellendi",
                "desc": "Talepleri yönetin ve talep türlerini yapılandırın.",
                "created_at": "Oluşturulma Tarihi",
                "fields": "Form Alanları",
                "fields_desc": "Bu talep tipi için doldurulması gereken alanları tanımlayın.",
                "actions_desc": "Talep onaylandığında otomatik olarak tetiklenecek işlemler.",
                "new_field": "Alan Ekle",
                "required": "Zorunlu",
                "new_type": "Yeni Talep Türü",
                "title": "Talepler",
                "id": "Talep ID",
                "updated_at": "Son Güncelleme",
                "type": "Tür",
                "created_by": "Oluşturan",
                "payload": "Gönderilen Veriler",
                "create_success": "Talep türü başarıyla oluşturuldu",
                "key": "Alan Anahtarı",
                "basic_info": "Temel Bilgiler",
                "label": "Alan Etiketi",
                "basic_info_desc": "Talep tipinin adını ve benzersiz kodunu belirleyin.",
                "create_new": "Talep Oluştur",
                "select_type": "Talep Türü Seçiniz",
                "delete_success": "Talep türü başarıyla silindi",
                "metadata": "Üst Veriler",
                "no_fields_message": "Henüz alan eklenmemiş",
                "createDesc": "Yeni bir talep türü oluşturun ve yapılandırın.",
                "typesDesc": "Mevcut talep türlerini görüntüleyin ve yönetin.",
                "selectTypeDesc": "Oluşturmak istediğiniz talep türünü seçin.",
                "typesTitle": "Talep Türleri",
                "noPayload": "Form alanı yok",
                "history": "Geçmiş",
                "noHistory": "Henüz geçmiş kaydı yok"
            },
            "status": {
                "status": "Durum"
            },
            "action": {
                "actions": "Otomatik Aksiyonlar",
                "review": "İncele",
                "reject": "Reddet",
                "approve": "Onayla"
            }
        },
        "toast": {
            "message": {
                "review_success": "Talep inceleme durumuna alındı.",
                "reject_success": "Talep reddedildi.",
                "approve_confirm": "Bu talebi onaylamak istediğinizden emin misiniz?",
                "approve_success": "Talep başarıyla onaylandı ve eylemler yürütüldü.",
                "review_confirm": "Bu talebi incelemeye almak istediğinizden emin misiniz?",
                "reject_confirm": "Bu talebi reddetmek istediğinizden emin misiniz?",
                "reject_reason_prompt": "Lütfen reddetme nedenini giriniz:"
            },
            "reasonRequired": "Lütfen bir gerekçe yazın"
        },
        "form": {
            "label": {
                "name": "Ad",
                "name_placeholder": "Örn. Genel Talep",
                "code": "Kod",
                "description": "Açıklama",
                "code_placeholder": "Örn. REQ_TYPE_01",
                "type": "Tip",
                "fieldRequired": "Bu alan zorunludur",
                "fieldOptional": "Bu alan zorunlu değildir",
                "checkEligibility": "Uygunluk Sorgula",
                "checking": "Sorgulanıyor...",
                "remoteTriggerMode": "Uzaktan Doğrulama Tetikleme",
                "triggerAuto": "Otomatik (yazarken)",
                "triggerButton": "Buton ile (manuel)",
                "remoteButtonLabelKey": "Buton etiketi (i18n anahtarı)",
                "remoteCheck": "Sorgula",
                "remoteChecking": "Sorgulanıyor",
                "remoteCheckValid": "Uygun",
                "remoteCheckRetry": "Tekrar sorgula",
                "options": "Seçenekler",
                "untitledField": "Başlıksız Alan",
                "descriptionKey": "Açıklama anahtarı (i18n)",
                "fileOptions": "Dosya seçenekleri",
                "acceptedTypes": "Kabul edilen dosya türleri",
                "directory": "Depolama klasörü",
                "maxSizeMb": "En büyük boyut (MB)",
                "multipleFiles": "Birden fazla dosyaya izin ver",
                "singleFile": "Yalnız tek dosya",
                "currencyOptions": "Para birimi seçenekleri",
                "currencySymbol": "Para birimi simgesi",
                "textareaOptions": "Metin alanı seçenekleri",
                "rows": "Satır",
                "validationRules": "Doğrulama kuralları",
                "addRule": "Kural ekle",
                "rule": "Kural",
                "value": "Değer",
                "remoteUrl": "Uzak doğrulama adresi",
                "messageKey": "Mesaj anahtarı",
                "messageArgs": "Mesaj değerleri formülü",
                "usage": "Kullanım hakkı formülü"
            },
            "placeholder": {
                "labelExample": "örn. Video URL, Tam Ad, vb.",
                "keyExample": "örn. video_url",
                "options": "Seçenek 1, Seçenek 2, Seçenek 3...",
                "descriptionPlaceholder": "Açıklama girin",
                "acceptedTypes": "image/*,.pdf,.doc",
                "directory": "requests",
                "currencySymbol": "TRY, USD, Elmas…"
            },
            "hint": {
                "optionsComma": "Virgülle ayırarak birden fazla seçenek ekleyin",
                "remoteTriggerMode": "Otomatik: her karakter girişinde tetiklenir. Buton: kullanıcı kutunun içindeki butona bastığında tetiklenir (panel ve mobil).",
                "remoteButtonLabelKey": "Boş bırakılırsa \"Sorgula\" kullanılır.",
                "fileOptions": "Boş bırakırsanız 5 MB'a kadar her dosya kabul edilir.",
                "currencySymbol": "Örneğin TRY, USD, EUR veya Elmas. Birim istemiyorsanız boş bırakın.",
                "textareaRows": "Görünen satır sayısı. Varsayılan 4.",
                "remoteUrl": "Opsiyonel. Boş bırakılırsa SpEL kuralları yerleşik uç noktayı kullanır.",
                "noValidations": "Henüz doğrulama kuralı yok.",
                "messageArgs": "Opsiyonel. Mesajdaki {'{'}ad{'}'} yerlerini dolduran değerleri döndürür.",
                "usage": "Opsiyonel. Doluysa yayıncı talep açmadan kaç hakkı olduğunu ve kaçını kullandığını görür."
            }
        },
        "action": {
            "label": {
                "newAction": "Yeni Aksiyon",
                "noActions": "Henüz otomatik aksiyon tanımlanmamış.",
                "type": "Aksiyon Tipi",
                "config": "Yapılandırma (JSON)",
                "actionBadge": "AKSİYON"
            },
            "hint": {
                "configJson": "Aksiyon yapılandırma parametrelerini JSON olarak girin."
            },
            "webhook": {
                "helper_title": "Dinamik Degiskenler Rehberi",
                "section_endpoint": "Endpoint",
                "url": "Hedef URL (SpEL Ifadesi)",
                "method": "Metod",
                "body_mode": "Payload Modu",
                "headers": "HTTP Basliklar",
                "add_header": "Baslik Ekle",
                "no_headers": "Tanimli ozel baslik yok.",
                "body_mapping": "Ozel JSON Eslestirme",
                "mode_full": "Tam Form Verisi",
                "mode_mapped": "Ozel JSON Eslestirme",
                "mode_none": "Govde Yok",
                "mode_full_hint": "Form gonderiminin tamamini JSON olarak gonderir.",
                "mode_mapped_hint": "Asagida belirli alanlari ve degerleri tanimlayin."
            }
        },
        "drawer": {
            "label": {
                "editTitle": "Talep Türünü Düzenle",
                "select_type_placeholder": "Bir talep türü seçin...",
                "auto_approve": "Otomatik onay",
                "agreement": "Sözleşme / Taahhütname"
            },
            "hint": { "auto_approve": "Aktif olduğunda, bu tipteki talepler otomatik olarak onaylanır veya reddedilir.", "agreement": "Seçildiğinde, bu tipteki talepler öncesinde kullanıcıdan sözleşme kabul etmesi istenir." },
            "placeholder": { "agreement": "Sözleşme seçin (opsiyonel)" },
            "option": { "no_agreement": "Sözleşme yok" }
        },
        "select_type_to_continue": "Devam etmek için bir talep türü seçin",
        "load_types_error": "Talep tipleri yüklenemedi",
        "submit_error": "Talep gönderilemedi"
    },
    "notifications": {
        "view": {
            "status": {
                "active": "Aktif",
                "inactive": "Pasif"
            },
            "label": {
                "exclusions": "İSTİSNALAR",
                "required": "Bu alan zorunludur",
                "createTemplate": "Yeni Bildirim Taslağı Oluştur",
                "category": "kategori seçin",
                "visualizer": "CANLI ÖNİZLEME",
                "mobile": "TELEFON",
                "raw": "HTML / HAM",
                "subject": "BAŞLIK KONUSU",
                "html": "HTML GÖVDE",
                "marketing": "PAZARLAMA",
                "editDesc": "Mevcut taslak yapılandırmasını ve görsel görünümünü düzenleyin.",
                "value": "varsayılan değer",
                "desktop": "WEB SİTESİ",
                "mappings": "VARSAYILANLAR",
                "deleteTitle": "Taslağı Sil",
                "key": "anahtar adı",
                "pageTitle": "Bildirim Yönetimi",
                "editTemplate": "Bildirim Taslağını Düzenle",
                "system": "SİSTEM",
                "newTemplate": "Yeni Taslak",
                "identity": "TASLAK KİMLİĞİ",
                "title": "Bildirim Taslakları",
                "identifier": "KOD (CODE)",
                "sidebarControl": "YAN PANEL",
                "deleteMessage": "Bu işlem kalıcıdır. Bu taslağı gerçekten silmek istiyor musunuz?",
                "createDesc": "Yeni bildirim taslağınız için kimlik, mantık ve içerik yapılandırın.",
                "desc": "Bildirim şablonlarını yönetin ve yayın mesajlarını planlayın.",
                "attributes": "SİSTEM ÖZNİTELİKLERİ",
                "security": "GÜVENLİK",
                "search": "taslaklarda ara...",
                "createTitle": "Yayın Oluştur",
                "broadcasts": "Yayınlar",
                "totalRecipients": "Toplam Alıcı",
                "stats": "İstatistikler"
            },
            "modal": {
                "title": {
                    "label": "Versiyon Karşılaştırma"
                },
                "subtitle": {
                    "desc": "İki veri anlık görüntüsü arasındaki değişiklikleri görselleştirme"
                },
                "header": {
                    "attribute": "Özellik"
                },
                "state": {
                    "calculating": "Farklılıklar hesaplanıyor..."
                },
                "empty": {
                    "title": "Değişiklik algılanmadı",
                    "desc": "Seçilen versiyonlar birbirinin aynısı."
                },
                "filter": {
                    "showOnlyChanges": "Sadece farkları göster"
                },
                "summary": {
                    "rowsWithChanges": "Değişen Özellik",
                    "modified": "Değişti",
                    "added": "Eklendi"
                }
            },
            "action": {
                "discard": "Değişiklikleri At",
                "save": "Yapılandırmayı Kaydet",
                "addExclusion": "istisna ekle",
                "addMapping": "eşleştirme ekle"
            },
            "placeholder": {
                "search": "Taslaklarda ara..."
            },
            "message": {
                "gridNotAvailable": "Yayınlar için grid görünümü henüz mevcut değil."
            }
        },
        "table": {
            "column": {
                "subject": "Konu",
                "status": "Durum",
                "code": "Kod",
                "type": "Tür",
                "channel": "Kanal",
                "name": "Yayın Adı",
                "date": "Tarih"
            },
            "action": {
                "actions": "Aksiyonlar"
            }
        },
        "toast": {
            "message": {
                "updateSuccess": "Taslak güncellendi",
                "saveError": "Taslak kaydedilemedi",
                "deleteSuccess": "Taslak başarıyla silindi",
                "deleteError": "Taslak silinemedi",
                "createSuccess": "Taslak oluşturuldu"
            }
        },
        "modal": {
            "label": {
                "subtitle": "Bildirim taslağınız için kimlik, mantık ve içerik yapılandırın."
            }
        },
        "broadcast": {
            "createDesc": "Yeni yayın oluşturmak için adımları takip edin.",
            "createTitle": "Yayın Oluştur"
        },
        "templateEditor": { "channelSaved": "Kanal içeriği kaydedildi", "channelSaveError": "Kanal içeriği kaydedilemedi", "fallbackHint": "DEFAULT satırı, kanala özel satır yoksa kullanılır (fallback).", "unsaved": "Kaydedilmemiş değişiklik", "hasContent": "Bu kanal için özel içerik var", "loadingChannels": "Kanal satırları yükleniyor…", "noChannelContent": "Bu kanal için özel içerik yok, DEFAULT kullanılıyor.", "createForChannel": "Bu kanal için oluştur", "channelRowHint": "Bu sekme ayrı bir kayıttır. Değişiklikleri buradaki butonla kaydedin.", "saveChannel": "Bu kanalı kaydet", "advanced": "Gelişmiş", "exclusionsHint": "Anahtar/değer çifti eşleşen kullanıcılar bu bildirimin dışında tutulur.", "variablesHint": "Gönderim sırasında bir değişkenin değeri gelmezse burada girdiğiniz varsayılan kullanılır." }
    },
    "broadcast": {
        "wizard": {
            "step": {
                "channelsContent": "Kanallar ve İçerik",
                "targeting": "Hedefleme",
                "schedule": "Zamanlama",
                "review": "Özet"
            },
            "label": {
                "selectChannels": "Kanalları Seçin",
                "contentSource": "İçerik Kaynağı",
                "useTemplate": "Şablon Kullan",
                "customHtml": "Özel HTML",
                "subject": "Konu",
                "emailInAppContent": "E-posta / Uygulama İçi İçerik",
                "pushContent": "Push Bildirim",
                "pushTitle": "Başlık",
                "pushBody": "Mesaj",
                "smsContent": "SMS",
                "smsBody": "Mesaj",
                "targetingTitle": "Hedef Kitle",
                "allUsers": "Tüm Kullanıcılar",
                "customAudience": "Özel Kitle",
                "byRole": "Role Göre",
                "targetingExpression": "Hedefleme İfadesi",
                "audienceEstimate": "Kitle Tahmini",
                "reachDesc": "Bu yayın yaklaşık {count} kullanıcıya ulaşacak",
                "estimateUnavailable": "Kitle tahmini mevcut değil",
                "sendNow": "Şimdi Gönder",
                "scheduleLater": "Daha Sonra Zamanla",
                "immediately": "Hemen",
                "summary": "Özet",
                "name": "Ad"
            },
            "desc": {
                "preDesigned": "Önceden tasarlanmış bir şablon kullanın",
                "writeCode": "Kendi HTML kodunuzu yazın",
                "startImmediately": "Oluşturulduktan hemen sonra gönder"
            },
            "placeholder": {
                "template": "Şablon seçin...",
                "subject": "Konu girin...",
                "pushTitle": "Push başlığı girin...",
                "pushBody": "Push mesajı girin...",
                "smsBody": "SMS mesajını girin...",
                "name": "Yayın adı girin...",
                "description": "Açıklama girin..."
            },
            "message": {
                "reviewDisclaimer": "Lütfen yayınlamadan önce yukarıdaki detayları kontrol edin. Bu işlem geri alınamaz."
            },
            "action": {
                "launch": "Yayını Başlat"
            }
        }
    },
    "common": {
        "download": "İndir",
        "close": "Kapat",
        "confirmDialog": { "ok": "Onayla" },
        "pagination": {
            "showing": "{total} kayıttan {start}-{end} arası gösteriliyor",
            "perPage": "{n} / Sayfa"
        },
        "view": {
            "action": {
                "verify": "Doğrula",
                "search": "Ara",
                "clear": "Temizle",
                "cancel": "İptal",
                "close": "Kapat",
                "ok": "Tamam",
                "save": "Kaydet",
                "viewAll": "Tümünü Gör",
                "delete": "Sil",
                "edit": "Düzenle",
                "create": "Oluştur",
                "continue": "Devam Et",
                "back": "Geri Dön",
                "confirm": "Onayla",
                "update": "Güncelle",
                "refresh": "Yenile",
                "copyId": "ID Kopyala",
                "view": "Görüntüle",
                "show_less": "Daha az göster",
                "show_more": "Tümünü göster",
                "move_up": "Yukarı taşı",
                "move_down": "Aşağı taşı",
                "details": "Detayları gör",
                "remove": "Kaldır",
                "saving": "Kaydediliyor…",
                "copied": "Kopyalandı",
                "copy": "Kopyala"
            },
            "export": {
                "button": "Dışa Aktar",
                "csv": "CSV",
                "excel": "Excel",
                "failed": "Dışa aktarma başarısız",
                "empty": "Dışa aktarılacak kayıt yok"
            },
            "label": {
                "confirm_delete": "Bu öğeyi silmek istediğinizden emin misiniz?",
                "PHONE": "Telefon",
                "DATE": "Tarih",
                "FILE": "Dosya",
                "DATETIME": "Tarih ve Saat",
                "actions_title": "İşlemler",
                "noDataDesc": "Arama kriterlerinize uygun kayıt bulunamadı.",
                "DIAMONDS": "Elmaslar",
                "loading": "Yükleniyor…",
                "USER": "Kullanıcı",
                "SELECT": "Seçim",
                "yes": "Evet",
                "error": "Hata",
                "no": "Hayır",
                "success": "Başarılı",
                "LIVEDURATIONINLAST30D": "Son 30 Gün Canlı Yayın Süresi",
                "noData": "Veri bulunamadı",
                "noResults": "Sonuç bulunamadı",
                "TIME": "Saat",
                "STRING": "Metin",
                "not_implemented": "Bu özellik henüz uygulanmadı",
                "BOOLEAN": "Mantıksal",
                "CREATORNETWORKMANAGER": "Ağ Yöneticisi",
                "DIAMONDSINLAST30D": "Son 30 Gün Elmas",
                "NUMBER": "Sayı",
                "emptyDescription": "Şu anda görüntülenecek herhangi bir kayıt yok.",
                "JOINEDTIME": "Katılma Tarihi",
                "remaining": "kaldı",
                "target": "Hedef",
                "refresh": "Yenile",
                "validationError": "Lütfen zorunlu alanları doldurun.",
                "disabled": "Kapalı"
            }
        },
        "button": {
            "action": {
                "show": "Göster",
                "hide": "Gizle",
                "cancel": "İptal",
                "search": "Ara"
            }
        },
        "action": {
            "save": "Kaydet"
        },
        "active": "Aktif",
        "passive": "Pasif",
        "delete": "Sil",
        "edit": "Düzenle",
        "error": "Hata",
        "success": "Başarılı",
        "messages": {
            "loadError": "Veriler yüklenirken hata oluştu",
            "copied": "Kopyalandı",
            "error": "Bir sorun oluştu. Lütfen tekrar deneyin."
        },
        "state": {
            "inactive": "Pasif"
        },
        "status": {
            "active": "Aktif",
            "inactive": "Pasif",
            "label": {
                "error": "Hata",
                "success": "Başarılı"
            }
        },
        "table": {
            "actions": "İşlemler"
        },
        "palette": {
            "section": {
                "navigation": "Navigasyon",
                "actions": "Aksiyonlar"
            },
            "label": {
                "esc": "ESC",
                "noResults": "Sonuç bulunamadı:",
                "emptyHint": "Başka bir şey aramayı deneyin..."
            }
        },
        "month": {
            "0": "Ocak",
            "1": "Şubat",
            "2": "Mart",
            "3": "Nisan",
            "4": "Mayıs",
            "5": "Haziran",
            "6": "Temmuz",
            "7": "Ağustos",
            "8": "Eylül",
            "9": "Ekim",
            "10": "Kasım",
            "11": "Aralık"
        },
        "verify": "Doğrula",
        "back": "Geri",
        "backToLogin": "Girişe dön",
        "goHome": "Ana sayfaya git",
        "actions": { "view": "Detayları gör" },
        "drag_to_reorder": "Sıralamak için sürükleyin. İlk görsel ana görseldir.",
        "uploading": "Yükleniyor…",
        "click_or_drag_multiple": "Yüklemek için tıklayın veya dosyaları buraya sürükleyin",
        "click_or_drag": "Yüklemek için tıklayın veya dosyayı buraya sürükleyin",
        "file_too_large": "Dosya çok büyük",
        "invalid_file_type": "Bu dosya türü desteklenmiyor",
        "expiresIn": "Kalan süre:",
        "confirm": { "delete": "Silmek istediğinizden emin misiniz?" },
        "toast": { "deleted": "Silindi" },
        "label": { "active": "Aktif", "passive": "Pasif" },
        "fileLoadError": "Dosya yüklenemedi",
        "unexpectedResponse": "Sunucudan beklenmeyen yanıt alındı (HTTP {status}). API'ye ulaşılamıyor olabilir.",
        "unit": { "hourShort": "sa", "minuteShort": "dk", "atMinute": "{n}. dk" }
    },
    "announcement": {
        "view": { "label": { "title": "Duyurular", "desc": "HTML duyuru hazırla, SMS/Push/Uygulama içi gönder, okuma istatistiklerini izle" } },
        "table": { "title": "Başlık", "status": "Durum", "channels": "Kanallar", "readRate": "Okuma Oranı", "publishedAt": "Yayınlanma", "actions": "İşlemler" },
        "status": { "draft": "Taslak", "active": "Yayında", "archived": "Arşiv" },
        "channel": { "in_app": "Uygulama içi", "push": "Push", "sms": "SMS", "email": "E-posta" },
        "action": { "create": "Yeni Duyuru", "edit": "Düzenle", "publish": "Yayınla", "archive": "Arşivle", "stats": "İstatistik", "save": "Kaydet" },
        "toast": {
            "published": "Duyuru yayınlandı", "publishError": "Yayınlanamadı", "archived": "Duyuru arşivlendi",
            "archiveError": "Arşivlenemedi", "loadError": "Yüklenemedi", "titleRequired": "Başlık zorunlu",
            "noChannels": "En az bir kanal seçin", "saved": "Kaydedildi", "saveError": "Kaydedilemedi",
            "imageRequired": "Uygulama içi duyuru için görsel zorunlu", "imageUploadError": "Görsel yüklenemedi"
        },
        "error": {
            "smsMultiSegment": "SMS tek segmenti aşıyor — kullanıcı adı ve link en uzun haliyle sayılır; metni kısalt",
            "linkWithoutPage": "{link} kullanmak için Sayfa yüzeyi açık olmalı",
            "noEnabledSurface": "En az bir kanal açık olmalı",
            "homeSubjectRequired": "Ana sayfa kartı için başlık zorunlu",
            "bodyRequired": "Açık kanallar için gövde metni zorunlu",
            "emailSubjectRequired": "E-posta konusu zorunlu",
            "unknownSurface": "Bilinmeyen kanal",
            "duplicateSurface": "Aynı kanal iki kez gönderildi"
        },
        "drawer": { "createTitle": "Yeni Duyuru", "editTitle": "Duyuruyu Düzenle" },
        "field": {
            "title": "Başlık", "titlePlaceholder": "Duyuru başlığı", "channels": "Gönderim Kanalları",
            "content": "HTML İçeriği", "preview": "Canlı Önizleme", "startTime": "Başlangıç", "endTime": "Bitiş",
            "smsText": "SMS Metni", "smsPlaceholder": "Haymen yeni duyuru: {link}",
            "smsHint": "{link} yazdığın yere kişiye özel duyuru linki gelir; yazmazsan link otomatik sona eklenir.",
            "pushTitle": "Push Başlığı", "pushTitlePlaceholder": "Boş bırakırsan duyuru başlığı kullanılır",
            "pushBody": "Push Mesajı", "pushBodyPlaceholder": "Yeni duyuru yayınlandı",
            "image": "Modal Görseli", "imagePick": "Görsel Seç", "imageUploading": "Yükleniyor...",
            "imageHint": "Girişte açılan duyuru modalında gösterilir. Önerilen oran 4:5 veya 1:1, maks. 2MB."
        },
        "modal": { "cta": "İncele", "close": "Kapat" },
        "targeting": { "mode": "Hedefleme" },
        "audience": {
            "selectUsers": "Kullanıcı Seç",
            "searchLabel": "Kullanıcı ara",
            "searchPlaceholder": "İsim veya kullanıcı adı…",
            "pasteLabel": "Kullanıcı adlarını yapıştır",
            "pastePlaceholder": "Virgül veya alt satır ile ayır: user1, user2 …",
            "addFromText": "Metinden ekle",
            "unmatched": "Bulunamadı: {list}",
            "noUsers": "En az bir kullanıcı seç",
            "resolveError": "Kullanıcılar çözümlenemedi"
        },
        "stats": {
            "label": { "title": "Duyuru İstatistikleri" }, "back": "Duyurulara dön", "delivered": "Gönderildi",
            "read": "Okundu", "rate": "Okuma Oranı", "trend": "Okuma Trendi", "noData": "Henüz okuma yok",
            "modalClicked": "Modalda Tıkladı", "modalClosed": "Modalı X ile Kapattı",
            "modalSoftCloses": "Boşluğa Tıklama", "modalDismissRate": "Modal Kapatma Oranı"
        },
        "readers": { "title": "Okuyucular", "name": "Kullanıcı", "readAt": "İlk Okuma", "ip": "IP", "device": "Cihaz / Tarayıcı" },
        "archive": {
            "confirmTitle": "Duyuruyu arşivle?",
            "confirmMessage": "\"{title}\" arşivlenecek. Arşivlenen duyurunun linki artık içerik göstermez. Devam edilsin mi?"
        },
        "publish": {
            "confirmTitle": "Duyuruyu yayınla?",
            "confirmMessage": "\"{title}\" yayınlanacak ve hedeflenen yayıncılara SMS/Push ile gönderilecek. Bu işlem geri alınamaz. Devam edilsin mi?"
        }
    },
    "survey": {
        "view": { "label": { "title": "Anketler", "desc": "Yayıncılardan geri bildirim topla" } },
        "results": {
            "label": { "title": "Anket Sonuçları" },
            "back": "Anketlere dön", "delivered": "Gönderildi", "responded": "Yanıtlandı",
            "rate": "Yanıt Oranı", "anonNote": "Bu anket anonim — bireysel yanıtlar gösterilmez.",
            "average": "Ortalama", "noData": "Henüz veri yok", "byProvince": "İl bazında",
            "kanon": "5'ten az kohortlar gizli", "textNote": "Açık uçlu yanıtlar burada özetlenmez",
            "viewResponses": "Yanıt detayları"
        },
        "responses": { "title": "Bireysel yanıtlar", "anonymous": "Anonim", "empty": "Henüz yanıt yok" },
        "my": { "label": { "title": "Anketlerim", "desc": "Sana atanan anketleri doldur" }, "empty": "Bekleyen anketin yok", "fill": "Doldur", "answered": "Yanıtlandı", "upcoming": "Yakında" },
        "respond": {
            "label": { "title": "Anket" },
            "required": "Bu soru zorunlu", "thanks": "Teşekkürler!", "submitError": "Gönderilemedi, tekrar dene",
            "backToList": "Anketlerime dön", "back": "Geri", "next": "İleri", "submit": "Gönder",
            "textPlaceholder": "Yanıtını buraya yaz…"
        },
        "action": { "create": "Yeni Anket", "edit": "Düzenle", "publish": "Yayınla", "close": "Kapat", "results": "Sonuçlar", "save": "Kaydet" },
        "pager": { "prev": "Önceki", "next": "Sonraki" },
        "table": { "title": "Başlık", "status": "Durum", "target": "Hedef", "responseRate": "Yanıt Oranı", "endTime": "Bitiş", "actions": "İşlemler" },
        "empty": { "title": "Henüz anket yok" },
        "chip": { "anonymous": "Anonim", "mandatory": "Zorunlu" },
        "status": { "draft": "Taslak", "published": "Yayında", "closed": "Kapalı", "archived": "Arşiv" },
        "toast": {
            "loadError": "Yüklenemedi", "published": "Anket yayınlandı", "publishError": "Yayınlanamadı",
            "closed": "Anket kapatıldı", "closeError": "Kapatılamadı", "saved": "Kaydedildi",
            "saveError": "Kaydedilemedi", "titleRequired": "Başlık zorunlu"
        },
        "drawer": { "createTitle": "Yeni Anket", "editTitle": "Anketi Düzenle" },
        "field": {
            "title": "Başlık", "titlePlaceholder": "Anket başlığı", "description": "Açıklama",
            "anonymous": "Anonim", "mandatory": "Zorunlu (gate)", "gateMode": "Gate davranışı",
            "startTime": "Başlangıç", "endTime": "Bitiş"
        },
        "gate": {
            "nag": "Hatırlatma (kapatılabilir)", "appBlock": "Zorunlu (engelle)",
            "newSurvey": "Yeni Anket", "fill": "Doldur", "later": "Sonra",
            "mandatoryDesc": "Devam etmek için bu anketi doldurman gerekiyor.",
            "optionalDesc": "Sana yeni bir anket atandı. Birkaç dakikanı ayırır mısın?",
            "more": "+{count} anket daha bekliyor"
        },
        "builder": {
            "questions": "Sorular", "addQuestion": "Soru ekle", "untitled": "(başlıksız)", "empty": "Henüz soru yok",
            "type": "Tip", "questionText": "Soru metni", "required": "Zorunlu", "options": "Seçenekler",
            "addOption": "Seçenek ekle", "scale": "Ölçek", "branching": "Koşullu gösterim",
            "alwaysShow": "Her zaman göster", "branchValue": "değer", "preview": "Canlı önizleme",
            "condShown": "Koşullu gösterilir", "previewEmpty": "Soru ekleyince önizleme burada"
        },
        "qtype": {
            "single_choice": "Tek seçim", "multi_choice": "Çoklu seçim", "text": "Açık metin", "rating": "Puan",
            "nps": "NPS", "likert": "Likert", "matrix": "Matris", "ranking": "Sıralama", "date": "Tarih", "number": "Sayı"
        },
        "targeting": {
            "mode": "Hedefleme", "all": "Tüm yayıncılar", "segment": "Segment", "filter": "Filtre",
            "manual": "Manuel liste", "event": "Olay tetikli", "segmentCodes": "Segment kodları",
            "userIds": "Kullanıcı ID'leri", "provinceIds": "İl ID'leri", "categoryIds": "Kategori ID'leri"
        }
    },
    "users": {
        "mobile": { "tiktokId": "TikTok ID", "lastLoginIp": "Son giriş IP" },
        "taskProgress": {
            "rankUp": {
                "title": "Yükselme Teşviki",
                "headerSubtitle": "Kademeni koru ya da bir üst kademeye yüksel",
                "level": "Kademe {tier}",
                "chip": {
                    "tiers": "Kademe {from} → {to}"
                },
                "subhead": {
                    "prefix": "Şu an",
                    "suffix": "seviyesindesin — hedefini seç:"
                },
                "nextGoal": "Sıradaki hedef",
                "instead": "{value} yerine",
                "congrats": {
                    "title": "Kademeni yükselttin! 🎉",
                    "sub": "Kademe {from} → {to}",
                    "earned": "kazandın"
                },
                "start": "Başlangıç",
                "journey": {
                    "kept": "Kademeni korudun ✓",
                    "toKeep": "Kademeni korumak için {value} elmas kaldı"
                },
                "note": "İkisi birden kazanılmaz: kademende kalırsan {maintain}, yükseltirsen {upgrade} kazanırsın.",
                "badge": {
                    "rankedUp": "Yükseldin ✓",
                    "maintain": "Koru",
                    "upgrade": "Yüksel",
                    "earned": "Kazandın ✓",
                    "nextGoal": "Sıradaki hedef"
                },
                "option": {
                    "maintain": {
                        "title": "Kademe {tier}'de kal",
                        "desc": "{value} elmasa ulaşırsan kademeni korursun",
                        "done": "Kademeni korudun",
                        "doneDesc": "{value} kazanmayı garantiledin"
                    },
                    "upgrade": {
                        "title": "Kademe {tier}'a çık",
                        "desc": "{value} elmasa ulaşırsan bir üst kademeye geçersin",
                        "done": "Kademeni yükselttin",
                        "doneDesc": "Bir üst kademeye çıktın",
                        "lockedDesc": "Önce kademeni koru"
                    }
                },
                "check": {
                    "title": "Şunları tamamla",
                    "diamonds": "{value} elmas",
                    "days": "{value} gün yayın",
                    "hours": "{value} saat yayın",
                    "remainingDiamonds": "{value} kaldı",
                    "remainingDays": "{value} gün kaldı",
                    "remainingTime": "{value} kaldı",
                    "done": "✓"
                },
                "unit": {
                    "hoursShort": "sa",
                    "minutesShort": "dk"
                }
            },
            "noTaskTitle": "Bu ay için görev verisi henüz gelmedi",
            "noTaskHint": "TikTok bu ayın görevlerini henüz göndermemiş olabilir. Geçmiş verileri görmek için yukarıdaki menüden başka bir ay seçin."
        },
        "view": {
            "action": {
                "deleteUserMessage": "Bu kullanıcıyı silmek istediğinizden emin misiniz? Bu işlem geri alınamaz.",
                "deleteUser": "Kullanıcıyı Sil",
                "editUser": "Kullanıcıyı Düzenle",
                "createUser": "Kullanıcı Oluştur"
            },
            "label": {
                "pageTitle": "Yayıncı Yönetimi",
                "title": "Tüm Yayıncılar",
                "profileDescription": "Profil Açıklaması",
                "desc": "Ajans yayıncılarını, rollerini ve erişim bilgilerini tek yerden yönetin."
            },
            "status": {
                "inactive": "Pasif",
                "mfaEnabled": "2FA Aktif",
                "accountLocked": "Hesap Kilitli",
                "active": "Aktif"
            },
            "tab": {
                "managers": "Yöneticiler",
                "all": "Tüm Kullanıcılar",
                "publishers": "Creators"
            }
        },
        "table": {
            "column": {
                "role": "Rol",
                "phone": "Telefon",
                "attributes": "Öznitelikler",
                "status": "Durum",
                "user": "Kullanıcı",
                "manager": "Manager",
                "segments": "Segmentler",
                "lastLogin": "Son Giriş",
                "category": "Kategori",
                "province": "İl",
                "district": "İlçe"
            },
            "action": {
                "actions": "İşlemler"
            }
        },
        "loginPlatform": {
            "label": "Giriş Platformu",
            "mobile": "Mobil",
            "web": "Web",
            "never": "Hiç giriş yapmamış"
        },
        "filter": {
            "hasBackup": "Yedek hesabı olanlar",
            "live": "Canlı yayında",
            "group": {
                "userInfo": "Kullanıcı Bilgisi",
                "location": "Konum",
                "liveStatus": "Yayın durumu"
            }
        },
        "live": {
            "badge": "CANLI",
            "tooltip": "Canlı yayında · {minutes} dk önce kontrol edildi"
        },
        "form": {
            "label": {
                "role": "Rol",
                "accountActiveDesc": "Kullanıcı erişimini etkinleştir veya devre dışı bırak",
                "personalInfo": "Kişisel Bilgiler",
                "accountSettings": "Hesap Ayarları",
                "accessControl": "Erişim Kontrolü",
                "permissions": "İzinler (Role göre otomatik)",
                "syncWithRole": "Rolle Eşitle",
                "email": "E-posta",
                "addAttribute": "Öznitelik Ekle",
                "accountActive": "Hesap Aktif",
                "noPermissions": "İzin yok",
                "firstName": "Ad",
                "mfaEnabledDesc": "Kullanıcının 2FA özelliği açık mı? (Kalıcı)",
                "twoFactor": "MFA Zorunluluğu",
                "lastName": "Soyad",
                "syncWithRoleBtn": "Rolle Eşitle",
                "metadata": "Metadata",
                "created": "Oluşturulma",
                "contactInfo": "İletişim Bilgileri",
                "lastUpdated": "Son Güncelleme",
                "attributesTitle": "Öznitelikler (PBAC)",
                "systemAttributes": "Sistem Öznitelikleri (Salt Okunur)",
                "customAttributes": "Özel Öznitelikler",
                "selectRole": "Rol seçiniz",
                "mfaEnabled": "2FA Aktifliği",
                "attributesSynced": "Öznitelikler rol şablonuyla eşitlendi",
                "attributeValue": "Değer",
                "attributeKey": "Öznitelik Anahtarı",
                "twoFactorDesc": "Kullanıcı girişinde kod sorsun (Anlık)"
            },
            "placeholder": {
                "email": "örn. ahmet{'@'}ornek.com",
                "firstName": "örn. Ahmet",
                "lastName": "örn. Yılmaz"
            }
        },
        "toast": {
            "message": {
                "createSuccess": "Kullanıcı başarıyla oluşturuldu",
                "updateSuccess": "Kullanıcı başarıyla güncellendi",
                "saveError": "Kullanıcı kaydedilemedi. Lütfen tekrar deneyin."
            }
        },
        "linkedAccounts": {
            "title": "Bağlı Hesaplar",
            "badge": "Yedek hesap",
            "count": "{count} yedek hesap",
            "isBackupOf": "Asıl hesap",
            "backupsTitle": "Yedek Hesaplar",
            "linkButton": "Yedek Hesap Bağla",
            "makePrimary": "Asıl Yap",
            "unlink": "Bağı Çöz",
            "confirmMakePrimaryTitle": "Asıl hesap yapılsın mı?",
            "confirmMakePrimaryBody": "{name} asıl hesap olacak, mevcut asıl hesap ve diğer yedekler bu hesaba bağlanacak.",
            "confirmUnlinkTitle": "Bağ çözülsün mü?",
            "confirmUnlinkBody": "{name} bağımsız bir hesap olacak ve bu hesapla olan bağı kaldırılacak.",
            "samePhoneSuggestions": "Aynı telefon numarasına sahip hesaplar",
            "searchPlaceholder": "İsim veya kullanıcı adıyla ara...",
            "empty": "Henüz bağlı yedek hesap yok.",
            "linkedSuccess": "Yedek hesap başarıyla bağlandı.",
            "unlinkedSuccess": "Hesap bağı başarıyla çözüldü.",
            "madePrimarySuccess": "Hesap başarıyla asıl hesap yapıldı."
        },
        "stats": { "viewers": "İzleyici", "peak": "Anlık en yüksek izleyici", "newFollowers": "Yeni takipçi", "gifts": "Alınan hediye" },
        "profile": { "tab": { "taskProgress": "Görev İlerlemesi", "livestreams": "Canlı Yayınlar", "agency": "Ajans" }, "openTikTok": "TikTok Hesabına Git" }
    },
    "layout": {
        "mobile": {
            "filter": { "showAll": "Sonuçları göster", "title": "Filtreler", "clear": "Temizle", "all": "Tümü", "show": "Göster", "showResults": "{n} sonucu göster", "count": "{n} sonuç", "search": "Ara" },
            "actions": { "more": "Diğer işlemler", "exportCsv": "Dışa aktar (CSV)", "exportXlsx": "Dışa aktar (Excel)" },
            "tab": { "menu": "Menü", "chat": "Sohbet" },
            "tabbar": { "aria": "Ana gezinme" },
            "menu": { "language": "Dil", "profile": "Profilim", "account": "Hesap ayarları" },
            "shortcut": { "eligibility": "Uygunluk", "requests": "Talepler", "leads": "Adaylar", "violations": "İhlaller", "activities": "Etkinlikler", "goals": "Hedefler", "equipment": "Ekipman", "earnings": "Kazanç", "chat": "Sohbet" }
        },
        "view": {
            "action": {
                "campaigns": "Kampanyalar",
                "requestsSubtitle": "Onay ve inceleme süreçleri",
                "requests": "Talepler",
                "profileSubtitle": "Profil sayfanıza gidin",
                "logout": "Çıkış Yap",
                "inbox": "Gelen Kutusu",
                "campaignsSubtitle": "Pazarlama kampanyaları",
                "users": "Kullanıcı Yönetimi",
                "analyticsSubtitle": "Veri ve raporlama",
                "profile": "Profil",
                "logoutSubtitle": "Hesabınızdan çıkış yapın",
                "usersSubtitle": "Kullanıcıları ve rolleri yönet",
                "notifications": "Bildirimler",
                "policies": "Politikalar",
                "inboxSubtitle": "Mesajları ve uyarıları görüntüle",
                "notificationsSubtitle": "Taslakları ve yayınları yönet",
                "policiesSubtitle": "Erişim ve yetki yönetimi",
                "settings": "Ayarlar",
                "analytics": "Analiz Paneli",
                "settingsSubtitle": "Uygulama tercihleri",
                "segmentsSubtitle": "Kullanıcı segmentlerini yönet",
                "segments": "Segmentler",
                "managerMapping": "Manager Eşleştirme",
                "managerMappingSubtitle": "Manager ↔ TikTok email eşleştirmeleri",
                "goalTemplates": "Hedef Şablonları",
                "goalTemplatesSubtitle": "Hedef şablonlarını yönet",
                "myGoals": "Hedeflerim",
                "myGoalsSubtitle": "Dönem ilerlemesi ve projeksiyon",
                "managerGoals": "Yönetici Hedefleri",
                "managerGoalsSubtitle": "Tüm yöneticilerin aktif dönem ilerlemesi",
                "goalsAdmin": "Hedef Yönetimi",
                "goalsAdminSubtitle": "Şablonlar ve yönetici hedefleri"
            },
            "label": {
                "navigate": "gezin",
                "noResults": "Sonuç bulunamadı.",
                "viewAllNotifications": "Tüm bildirimleri gör",
                "select": "seç",
                "noNotifications": "Bildirim yok",
                "signOut": "Çıkış Yap",
                "close": "kapat",
                "markAllRead": "Tümünü okundu işaretle",
                "settings": "Ayarlar",
                "noNotificationsDesc": "Her şey güncel! Daha sonra tekrar kontrol edin.",
                "profile": "Profilim",
                "notifications": "Bildirimler",
                "placeholder": "Bir komut yazın veya arayın...",
                "settingsDesc": "Uygulama tercihlerinizi ve hesap ayarlarınızı yönetin."
            },
            "placeholder": {
                "search": "Ara..."
            }
        },
        "topnav": {
            "label": {
                "more": "Daha fazla"
            }
        },
        "sidebar": {
            "label": {
                "administration": "İdare",
                "myAnalytics": "Analizlerim",
                "candidates": "Yayıncı Adayları",

                "rolesPermissions": "Roller & İzinler",
                "compliance": "İhlaller",
                "system": "Ayarlar",
                "profile": "Profil",
                "panel": "Panel",
                "users": "Yayıncılar",
                "creatorAnalytics": "Ajans Genel Görünüm",
                "segments": "Segmentler",
                "website": "Web Sitesi",
                "websiteCreators": "Yayıncılar",
                "websiteContent": "İçerikler",
                "websiteApplications": "Başvurular",
                "websiteSettings": "Site Ayarları",
                "guides": "Rehber Videoları",
                "localization": "Dil Yönetimi",
                "inbox": "Gelen Kutusu",
                "notifications": "Bildirimler",
                "chat": "Canlı Sohbet",
                "communication": "İletişim",
                "support": "Destek",
                "policies": "Politikalar",
                "management": "Yönetim",
                "system_settings": "Sistem Ayarları",
                "creator_snapshots": "Yayıncı Anlık Görüntüleri",
                "violations": "Tüm İhlaller",
                "managerMapping": "Manager Eşleştirme",
                "goalTemplates": "Hedef Şablonları",
                "myGoals": "Hedeflerim",
                "managerGoals": "Yönetici Hedefleri",
                "goalsAdmin": "Hedef Yönetimi",
                "equipments": "Ekipman",
                "creators": "Yayıncılar",
                "operations": "Operasyonlar",
                "revenue": "Gelir",
                "tournament": "Turnuva",
                "data": "Veri & Raporlar",
                "collapse": "Kenar çubuğunu daralt"
            }
        },
        "bell": {
            "label": {
                "allFilter": "Tümü"
            },
            "group": {
                "chat": "Sohbet",
                "security": "Güvenlik",
                "system": "Sistem",
                "marketing": "Pazarlama",
                "info": "Bilgi",
                "other": "Diğer"
            }
        },
        "commandPalette": {
            "placeholder": "Bir komut yazın veya kullanıcı aramak için {'@'} ile başlayın...",
            "recentSearches": "Son Aramalar",
        },
        "header": {
            "profileSubtitle": "Profil sayfanıza gidin",
            "settingsSubtitle": "Uygulama ayarları"
        },
        "settings": {
            "columnOrder": "Sütun Sıralaması",
            "dragToReorder": "Sıralamak için sürükleyin"
        }
    },
    "profile": {
        "view": {
            "label": {
                "recentPayments": "Son Ödemeler",
                "videos": "Videolar",
                "repTitle": "Ajans Temsilciniz",
                "likes": "Beğeniler",
                "desc": "Kullanıcı profilinizi yönetin ve performans analizlerinizi görüntüleyin.",
                "followers": "Takipçiler",
                "monthlyEarnings": "Aylık Kazançlar"
            },
            "tab": {
                "overview": "Genel Bakış",
                "earnings": "Kazançlar",
                "security": "Güvenlik"
            }
        }
    },
    "panel": {
        "title": "Panel",
        "description": "Günün özeti ve müdahale listesi",
        "palette": { "subtitle": "Müdahale listesi ve manager karnesi" },
        "common": {
            "noData": "Veri yok",
            "loadFailed": "Panel yüklenemedi",
            "actionFailed": "İşlem başarısız oldu"
        },
        "card": {
            "cycle": {
                "title": "{month} Dönemi",
                "daysLeft": "gün kaldı",
                "payout": "Ödemeler {date} günü hesaba geçer"
            },
            "pulse": {
                "title": "Bugün Yayında",
                "ofTotal": "/ {total}",
                "sub": "Dün {yesterday}/{total} yayındaydı · haftada ort. {avg} gün yayın"
            },
            "atRisk": {
                "title": "Kaçabilecek Ödül",
                "managerTitle": "Müdahale Bekleyen",
                "sub": "{rescuable} yayıncı yetişir · {hard} tanesi zorda"
            },
            "requests": {
                "title": "Bekleyen Talep",
                "sub": "{reviewing} tanesi incelemede"
            }
        },
        "lane": {
            "risk": "Ödül Kaçıyor",
            "riskHint": "hedefi kaçırmak üzere olan yayıncılar, en değerliden başlayarak",
            "opportunity": "Az Kaldı",
            "opportunityHint": "ufak bir gayretle ekstra kazanç kapıda",
            "compliance": "Ban & İhlal",
            "complianceHint": "5 dakikada bir güncellenir",
            "empty": "Şu an her şey yolunda, bekleyen iş yok.",
            "showAll": "Tümünü göster ({n})",
            "collapse": "Daralt",
            "mutedFoot": "Sessize alınan {count} yayıncı gizli, ay bitince kendiliğinden geri gelir"
        },
        "band": {
            "ON_TRACK": "Yolunda",
            "FEASIBLE": "Yetişir",
            "HARD": "Zor Yetişir",
            "LAST_CHANCE": "Son Şans",
            "IMPOSSIBLE": "Yetişmez"
        },
        "money": {
            "atRisk": "kaçabilir",
            "opportunity": "fırsat",
            "dailyLoss": "günlük kayıp"
        },
        "signal": {
            "maintainRisk": "Kademeyi korumaya {gapDiamonds} elmas kaldı",
            "closeToUpgrade": "Kademe atlamaya {gapDiamonds} elmas kaldı",
            "nextStage": "Sonraki seviyeye {gapDays} gün, {gapHours} saat yayın kaldı",
            "nextStageDynamic": "Sonraki seviyeye {time} yayın kaldı",
            "nextStageReady": "Sonraki seviye çok yakın — küçük bir yayın yeter",
            "closeToGraduation": "Mezuniyete {gapDiamonds} elmas kaldı (hedef 80K)",
            "rookieWindow": "{validDays}/{validDaysTarget} geçerli gün · {gapDays} gün daha yayın gerek",
            "streakBreak": "{days} gündür yayın yok",
            "diamondDrop": "Elmas geliri {'%'}{pct} düştü",
            "banNew": "Yayın erişimi askıya alındı",
            "banAppealed": "İtiraz gönderildi · yanıt bekleniyor"
        },
        "detail": {
            "paceDiamonds": "günde ort. {pace} elmas, bu gidişle ~{projected}",
            "daysHours": "ay sonuna {daysLeft} gün",
            "weekly": "Son 7 gün: {weeklyDiamonds} elmas · {weeklyActiveDays} aktif gün",
            "banReason": "{policyReason}",
            "appealStatus": "İtiraz durumu: {appealStatus}"
        },
        "subtitle": {
            "rankMaintain": "Kademe {tier} · koruma",
            "rankUpgrade": "Kademe {tier} → {targetTier}",
            "activeness": "Aktiflik görevi",
            "graduation": "Mezuniyet · yeni yayıncı",
            "rookie": "Yeni yayıncı · ilk 14 gün",
            "performance": "Performans sinyali",
            "compliance": "İhlal"
        },
        "chip": {
            "tier": "Kademe {tier}",
            "tierUp": "Kademe {tier} → {targetTier}",
            "stage": "Seviye {tier} → {targetTier}",
            "maintain": "Koruma",
            "upgrade": "Yükselme",
            "activeness": "Aktiflik",
            "graduation": "Mezuniyet",
            "rookie": "Yeni Yayıncı",
            "window14": "14 Gün",
            "performance": "Performans",
            "violation": "İhlal"
        },
        "metric": {
            "dailyAvg": "Günlük ort.",
            "atThisPace": "Bu hızla ay sonu",
            "last7": "Son 7 gün",
            "activeDay": "Aktif gün"
        },
        "time": {
            "days": "{n} gün",
            "hours": "{n} saat",
            "minutes": "{n} dakika"
        },
        "act": {
            "days": "Gün",
            "hours": "Saat",
            "diamonds": "Elmas"
        },
        "compliance": {
            "stepBan": "Ban",
            "stepAppeal": "İtiraz",
            "stepResult": "Sonuç",
            "sent": "Gönderildi",
            "notAppealed": "İtiraz edilmedi!",
            "waiting": "Bekliyor"
        },
        "legend": {
            "title": "Gidişat:",
            "ghost": "taralı kısım = bu hızla ay sonunda geleceği yer",
            "note": "günlük hız = bu ayki ortalama · $ = kaçırılırsa kaybedilecek ödül",
            "noteNoMoney": "günlük hız = bu ayki ortalama"
        },
        "action": {
            "nudge": "Yayına Çağır",
            "violationDetail": "Detay",
            "appeal": "İtiraz Et",
            "muteTitle": "Bu ay için sessize al"
        },
        "mute": { "done": "{username} bu ay için sessize alındı" },
        "nudge": {
            "title": "Yayına Çağır",
            "target": "{username} adlı yayıncıya hatırlatma gönderilecek.",
            "template": "Şablon",
            "channels": "Kanallar",
            "channel": { "PUSH": "Push", "IN_APP": "Uygulama içi", "SMS": "SMS" },
            "noTemplates": "Bu liste için hazır şablon yok. Teşvik ekranından ekleyebilirsin.",
            "sent": "{username} yayına çağrıldı",
            "failed": "Bildirim gönderilemedi"
        },
        "admin": {
            "summary": {
                "title": "{month} · Ajans Kazancı",
                "lastMonthTotal": "geçen ay toplamı {last}",
                "moversTitle": "En çok oynatanlar · son 7 gün elması"
            },
            "health": {
                "graduation": "Mezun Oranı (80K+)",
                "graduationGate": "{graduated}/{assessed} yeni yayıncı · sınırlar %3 / %15",
                "rank": "Kademe Başarısı",
                "rankGate": "premium için sınır %50 · {assessed} yayıncı değerlendirildi",
                "badMonths": "Üst Üste Zayıf Ay",
                "badMonthsGate": "3 aya ulaşırsa sözleşme feshi riski",
                "atRisk": "Kaçabilecek Ödül",
                "atRiskGate": "{cases} yayıncı riskte · {rescuable} tanesi yetişir"
            },
            "managers": {
                "title": "Manager Karnesi",
                "hint": "kaçabilir dolara göre sıralı · satıra tıklayınca o manager'ın listesi açılır",
                "col": {
                    "manager": "Manager",
                    "portfolio": "Yayıncı Sayısı",
                    "diamonds": "Bu Ayki Elmas",
                    "atRisk": "Kaçabilir $",
                    "rescuable": "Yetişir",
                    "critical": "Acil İş",
                    "mom": "Geçen Aya Göre"
                },
                "drill": "listesi →"
            },
            "drill": { "title": "{name} için müdahale listesi", "close": "Kapat" },
            "mode": {
                "aria": "Panel görünümü",
                "activeMonth": "Aktif Ay",
                "overview": "Genel Görünüm"
            },
            "flow": {
                "title": "Son 7 Gün",
                "hint": "katılan, ayrılan ve ban",
                "bans": "Yeni Ban · 24 saat",
                "bansSub": "yayın erişimi askıya alınanlar",
                "leaves": "Ayrılan",
                "leavesSub": "ayrılan · hesabı kapanan · çıkarılan",
                "joins": "Katılan",
                "joinsSub": "ajansa yeni katılanlar",
                "net": "Net Değişim",
                "netSub": "katılan − ayrılan · geçen hafta {prev}"
            }
        }
    },
    "performance": {
        "creatorTopPerformers": {
            "title": "Yüksek Performans",
            "subtitle": "En iyi 10 yayıncı — bu hafta öne çıkanlar",
            "empty": "Henüz öne çıkan yayıncı yok."
        },
        "creatorAtRisk": {
            "title": "Dikkat Edilmesi Gerekenler",
            "subtitle": "En riskli 10 yayıncı — yayın boşluğu, kademe düşüşü",
            "empty": "Risk altında yayıncı yok."
        },
        "openDrawer": "Performansı Görüntüle",
        "drawer": {
            "title": "Yayıncı Performansı",
            "subtitle": "Son 30 günün özeti",
            "empty": "Bu yayıncı için performans verisi yok.",
            "loadFailed": "Performans verisi yüklenemedi"
        },
        "section": {
            "daily": "Günlük Nabız",
            "weekly": "Haftalık Eğilim",
            "monthly": "Aylık Karşılaştırma",
            "risk": "Risk İşaretleri",
            "trend30d": "Son 30 Gün Elmas Eğilimi"
        },
        "metric": {
            "todayDiamonds": "Bugünkü Elmas",
            "todayBroadcasts": "Yayın Durumu",
            "todayDuration": "Bugün Yayın Süresi",
            "weeklyTotal": "Haftalık Toplam",
            "weeklyActiveDays": "Haftalık Aktif Gün",
            "weeklyAvgDaily": "Günlük Ortalama (7g)",
            "monthlyProjection": "Ay Sonu Tahmini",
            "tier": "Kademe Durumu",
            "targetCompletion": "Hedef Tamamlama",
            "streakBreak": "Yayın Boşluğu",
            "tierDowngradeRisk": "Kademe Düşüş Riski",
            "personalBest": "Bu Haftanın Rekoru"
        },
        "deltaLabel": {
            "vsYesterday": "Düne göre",
            "vsLastWeek": "Geçen haftaya göre",
            "vsLastMonth": "Geçen aya göre"
        },
        "value": {
            "streamedToday": "Bugün Yayın Açtı",
            "notStreamedToday": "Bugün Yayın Yok",
            "streakActive": "Aktif",
            "streakBreakDays": "{days} gün",
            "atRisk": "Riskli",
            "safe": "Güvende",
            "exceeded": "Aşıldı"
        },
        "tierTrend": {
            "UP": "Yükseldi",
            "FLAT": "Aynı",
            "DOWN": "Düştü",
            "UNKNOWN": "Bilinmiyor"
        },
        "risk": {
            "streakBreak": "{days} gündür yayın yok",
            "tierDowngrade": "Bu hızla ay sonunda kademe düşebilir",
            "personalBest": "Bu haftaki en yüksek günlük kazanç"
        },
        "shortSignal": {
            "streak": "{days}g",
            "activeToday": "Bugün aktif",
            "tierUp": "Kademe yükseldi",
            "tierRisk": "Kademe riski"
        },
        "unit": {
            "diamonds": "Elmas",
            "hours": "saat",
            "week": "hafta"
        }
    },
    "inbox": {
        "view": {
            "label": {
                "title": "BİLDİRİMLER",
                "desc": "Bildirimlerinizi görüntüleyin.",
                "noMessages": "Bildirim bulunamadı",
                "selectMessage": "Okumak için bir bildirim seçin",
                "unread": "okunmamış"
            },
            "placeholder": {
                "search": "Bildirimlerde ara..."
            },
            "action": {
                "refresh": "Yenile"
            }
        }
    },
    "chat": {
        "message": {
            "edit": "Düzelt",
            "unsend": "Geri al",
            "edited": "düzenlendi",
            "unsent": "Bu mesaj geri alındı",
            "editing": "Mesajı düzenle",
            "cancelEdit": "Düzenlemeyi iptal et",
            "editFailed": "Mesaj düzeltilemedi",
            "unsendFailed": "Mesaj geri alınamadı",
            "unsendTitle": "Mesaj geri alınsın mı?",
            "unsendConfirm": "Mesaj herkesten kaldırılır, yerinde \"Bu mesaj geri alındı\" yazar. Ekleri de silinir."
        },
        "receipt": {
            "readBy": "Okuyanlar",
            "nobody": "Henüz okuyan yok",
            "unreadCount": "{n} kişi henüz okumadı"
        },
        "managerSeat": {
            "persona": "Yöneticin",
            "assignedBadge": "Atanmış",
            "startButton": "Yöneticinle Konuş",
            "inboxTitle": "Takım Gelen Kutusu",
            "activeShort": "Aktif"
        },
        "view": {
            "label": {
                "title": "MESAJLAR",
                "desc": "Ağınızla sohbet edin.",
                "noMessages": "Sohbet bulunamadı",
                "noMessagesYet": "Henüz mesaj yok",
                "seenBy": "{count} kişi gördü",
                "readBy": "Görülen:",
                "seen": "Görüldü",
                "loadingMore": "Daha fazla yükleniyor…",
                "today": "Bugün",
                "yesterday": "Dün",
                "typingShort": "yazıyor…",
                "searchInChat": "Sohbette ara…",
                "searchCount": "{count} sonuç",
                "reconnecting": "Bağlantı yeniden kuruluyor…",
                "sending": "Gönderiliyor…",
                "sendFailed": "Gönderilemedi",
                "noUserFound": "Kullanıcı bulunamadı",
                "menu": "Menü"
            },
            "action": {
                "newChat": "Yeni Sohbet",
                "createGroup": "Yeni Grup",
                "reply": "Yanıtla",
                "search": "Ara",
                "attach": "Ekle",
                "photo": "Fotoğraf",
                "emoji": "Emoji",
                "retry": "Yeniden dene"
            },
            "filter": {
                "all": "Tümü",
                "unread": "Okunmamış",
                "creators": "Yayıncılar",
                "groups": "Gruplar"
            },
            "placeholder": {
                "search": "Sohbetlerde ara...",
                "searchUser": "Kişi ara — yeni sohbet başlat…"
            },
            "message": {
                "notConnected": "Bağlantı yok — mesaj gönderilemedi, lütfen tekrar deneyin."
            }
        },
        "status": {
            "activeNow": "Şimdi Aktif",
            "offline": "Çevrimdışı"
        },
        "modal": {
            "createGroup": {
                "title": "Yeni Grup Oluştur",
                "description": "Ekibiniz veya arkadaşlarınız için yeni bir sohbet grubu tanımlayın.",
                "selectedCount": "{count} kişi seçildi",
                "label": {
                    "groupName": "Grup Adı",
                    "addMembers": "Üyeleri Ekle (Opsiyonel)"
                },
                "placeholder": {
                    "groupName": "Grup adını giriniz...",
                    "search": "Eklenecek kullanıcıları ara..."
                },
                "action": {
                    "create": "Grubu Oluştur"
                }
            },
            "addMembers": {
                "title": "Grup Üyeleri Ekle",
                "description": "Bu gruba yeni katılımcılar davet edin.",
                "label": {
                    "search": "Kullanıcı Ara"
                },
                "placeholder": {
                    "search": "İsim veya e-posta ile ara..."
                },
                "action": {
                    "add": "Üyeleri Ekle"
                }
            }
        }
    },
    "errors": {
        "view": {
            "label": {
                "generic": "Bir hata oluştu.",
                "invalidOtp": "Geçersiz kod. Lütfen tekrar deneyin."
            }
        },
        "forbidden": { "title": "Erişim engellendi", "message": "Bu sayfayı görüntüleme yetkiniz yok." }
    },
    "auth": {
        "view": {
            "label": {
                "welcome": "Tekrar Hoşgeldiniz",
                "signingIn": "Giriş Yapılıyor...",
                "facebook": "Facebook ile Giriş Yap",
                "generic": "Giriş başarısız",
                "apple": "Apple ile Giriş Yap",
                "tiktok": "TikTok ile Giriş Yap",
                "otpInstruction": "Lütfen doğrulama uygulamanızdaki 6 haneli kodu giriniz.",
                "copyright": "© 2026 Haymen Agency. Tüm hakları saklıdır.",
                "logoutSuccess": "Başarıyla çıkış yapıldı",
                "signIn": "Giriş Yap",
                "orContinue": "VEYA ŞUNUNLA DEVAM ET",
                "google": "Google ile Giriş Yap",
                "sessionExpired": "Oturumunuzun süresi doldu, lütfen tekrar giriş yapın.",
                "forgotPassword": "Şifremi Unuttum?",
                "rememberMe": "Beni Hatırla",
                "terms": "Şartlar",
                "privacy": "Gizlilik",
                "support": "Destek"
            },
            "placeholder": {
                "password": "Şifre",
                "email": "E-posta, Kullanıcı Adı veya ID",
                "otp": "000 000",
                "newPassword": "Yeni şifre",
                "confirmPassword": "Şifreyi tekrar girin"
            }
        },
        "setPassword": { "title": "Şifreni belirle", "desc": "{name} için hesabın hazır. Giriş yapmak üzere bir şifre belirle.", "descPlain": "Hesabın hazır. Giriş yapmak üzere bir şifre belirle.", "submit": "Şifreyi kaydet", "invalid": "Bu davet bağlantısı geçersiz ya da süresi dolmuş. Yöneticinden yeni bir davet iste.", "success": "Şifren belirlendi. Giriş sayfasına yönlendiriliyorsun…", "goLogin": "Giriş sayfasına git" }, "forgotPassword": { "sent": "Sıfırlama kodu e-posta adresinize gönderildi", "step1": { "title": "Şifrenizi sıfırlayın", "desc": "E-posta adresinizi girin, size bir doğrulama kodu gönderelim." }, "step2": { "title": "Doğrulama kodu", "desc": "Şu adrese gönderdiğimiz 6 haneli kodu girin:" }, "step3": { "title": "Yeni şifre", "desc": "Yeni ve güçlü bir şifre belirleyin." }, "success": { "title": "Şifre güncellendi", "desc": "Şifreniz sıfırlandı. Giriş sayfasına yönlendiriliyorsunuz…" }, "sendCode": "Kodu gönder", "verifyCode": "Kodu doğrula", "reset": "Şifreyi sıfırla" }
    },
    "settings": {
        "title": "Ayarlar",
        "subtitle": "Uygulama tercihlerinizi ve hesap ayarlarınızı yönetin",
        "tabs": {
            "profile": "Profil",
            "security": "Güvenlik",
            "notifications": "Bildirimler"
        },
        "notifications": {
            "title": "Bildirim Tercihleri",
            "subtitle": "Hangi kanallardan hangi bildirimleri almak istediğinizi seçin. Devre dışı bıraktıklarınız size gönderilmez.",
            "loading": "Yükleniyor…",
            "empty": "Tanımlı bildirim bulunamadı.",
            "save": "Kaydet",
            "saving": "Kaydediliyor…",
            "section": {
                "system": "Sistem Bildirimleri",
                "requestTypes": "Talep Türleri",
                "requestTypes_sub": "Bir talep türünü kapatırsanız o türle ilgili tüm aşamaların bildirimleri (oluşturma, onay, red, durum değişikliği, not eklenmesi) susturulur."
            },
            "requestTypes": {
                "empty": "Aktif talep türü tanımlı değil.",
                "description": "Bu talep türünün tüm aşamalarındaki bildirimleri kapsar."
            },
            "column": {
                "notification": "Bildirim",
                "requestType": "Talep Türü"
            },
            "channels": {
                "IN_APP": "Uygulama İçi",
                "PUSH": "Push",
                "EMAIL": "E-posta",
                "SMS": "SMS"
            },
            "codes": {
                "REQUEST_CREATED": "Yeni talep oluşturuldu",
                "REQUEST_CREATED_FOR_OWNER": "Talebiniz oluşturuldu",
                "REQUEST_APPROVED": "Talep onaylandı",
                "REQUEST_REJECTED": "Talep reddedildi",
                "REQUEST_REVIEWING": "Talep incelemede",
                "REQUEST_STATUS_CHANGED": "Talep durumu değişti",
                "REQUEST_NOTE_ADDED": "Talebe not eklendi",
                "USER_CREATED": "Yeni kullanıcı oluşturuldu",
                "VIOLATION_CREATED": "İhlal kaydı oluşturuldu",
                "VIOLATION_CREATED_FOR_OWNER": "Hakkınızda ihlal kaydı oluşturuldu",
                "VIOLATION_WITHDRAWN": "İhlal geri çekildi",
                "VIOLATION_ENDED": "İhlal sonlandırıldı",
                "VIOLATION_APPEAL_APPROVED": "İhlal itirazı kabul edildi",
                "VIOLATION_APPEAL_REJECTED": "İhlal itirazı reddedildi",
                "WATCHLIST_STATUS_AVAILABLE": "Bir kullanıcı uygun hale geldi",
                "WATCHLIST_STATUS_UNAVAILABLE": "Bir kullanıcı artık uygun değil"
            },
            "descriptions": {
                "REQUEST_CREATED": "Sorumlu olduğunuz bir kullanıcı yeni bir talep oluşturduğunda gönderilir.",
                "REQUEST_CREATED_FOR_OWNER": "Kendi oluşturduğunuz talep sisteme kaydedildiğinde gönderilir.",
                "REQUEST_APPROVED": "Sahibi olduğunuz bir talep onaylandığında gönderilir.",
                "REQUEST_REJECTED": "Sahibi olduğunuz bir talep reddedildiğinde gönderilir.",
                "REQUEST_REVIEWING": "Sahibi olduğunuz talep incelemeye alındığında gönderilir.",
                "REQUEST_STATUS_CHANGED": "Sahibi olduğunuz bir talebin durumu yukarıdaki özel durumlar dışında değiştiğinde gönderilir.",
                "REQUEST_NOTE_ADDED": "Sahibi olduğunuz bir talebe yeni bir not eklendiğinde gönderilir.",
                "USER_CREATED": "Sorumlu olduğunuz yeni bir kullanıcı sisteme eklendiğinde gönderilir.",
                "VIOLATION_CREATED": "Sorumlu olduğunuz bir kullanıcı için ihlal kaydı oluşturulduğunda gönderilir.",
                "VIOLATION_CREATED_FOR_OWNER": "Hakkınızda yeni bir ihlal kaydı oluşturulduğunda gönderilir.",
                "VIOLATION_WITHDRAWN": "Hakkınızdaki bir ihlal geri çekildiğinde gönderilir.",
                "VIOLATION_ENDED": "Hakkınızdaki bir ihlal sona erdiğinde gönderilir.",
                "VIOLATION_APPEAL_APPROVED": "İhlal itirazınız kabul edildiğinde gönderilir.",
                "VIOLATION_APPEAL_REJECTED": "İhlal itirazınız reddedildiğinde gönderilir.",
                "WATCHLIST_STATUS_AVAILABLE": "Uygunluk izleme listesindeki bir kullanıcı uygun hale geldiğinde gönderilir.",
                "WATCHLIST_STATUS_UNAVAILABLE": "Uygunluk izleme listesindeki bir kullanıcı artık uygun değilse gönderilir."
            },
            "toast": {
                "load_failed": "Bildirim tercihleri yüklenemedi",
                "save_success": "Bildirim tercihleri kaydedildi",
                "save_failed": "Bildirim tercihleri kaydedilemedi"
            }
        },
        "profile": {
            "title": "Profil Bilgileri",
            "subtitle": "Kişisel bilgilerinizi ve şifrenizi güncelleyin",
            "firstname": "Ad",
            "lastname": "Soyad",
            "dateOfBirth": "Doğum Tarihi",
            "phoneNumber": "Telefon Numarası",
            "phonePlaceholder": "+90 5XX XXX XX XX",
            "changePassword": "Şifre Değiştir",
            "newPassword": "Yeni Şifre",
            "confirmPassword": "Yeni Şifre Tekrar",
            "passwordPlaceholder": "En az 6 karakter",
            "confirmPasswordPlaceholder": "Şifrenizi tekrar girin",
            "success": "Profil başarıyla güncellendi",
            "phoneVerified": "Doğrulandı",
            "phoneNotVerified": "Doğrulanmadı",
            "verifyNow": "Şimdi Doğrula",
            "verifyPhone": "Telefonu Doğrula",
            "verifyPhoneDesc": "Lütfen telefonunuza gönderilen 6 haneli kodu giriniz.",
            "verifyEmail": "E-postayı Doğrula",
            "verifyEmailDesc": "Lütfen e-posta adresinize gönderilen 6 haneli kodu giriniz.",
            "enterOtp": "Kodu Girin",
            "otpSent": "Doğrulama kodu telefonunuza gönderildi.",
            "resendOtp": "Tekrar Gönder",
            "verifySuccess": "Doğrulama başarılı",
            "verifyError": "Geçersiz doğrulama kodu",
            "error": {
                "required": "Ad ve Soyad alanları zorunludur",
                "passwordMin": "Şifre en az 6 karakter olmalıdır",
                "passwordMismatch": "Şifreler eşleşmiyor",
                "under18": "18 yaşından küçükler kayıt olamaz",
                "generic": "Profil güncellenirken bir hata oluştu"
            },
            "verified": "Doğrulandı"
        },
        "view": {
            "label": {
                "title": "İki Faktörlü Doğrulama",
                "dragToReorder": "Sıralamak için sürükleyin",
                "description": "Hesabınızı iki faktörlü doğrulama ile güvenceye alın",
                "descriptionGoogle": "Hesabınızı Google Authenticator ile güvenceye alın",
                "descriptionSms": "Hesabınızı SMS doğrulaması ile güvenceye alın",
                "instruction": "Uygulamanızdaki 6 haneli kodu giriniz",
                "columnOrder": "Sütun Sıralaması",
                "enabled": "İki faktörlü doğrulama hesabınızda etkinleştirildi.",
                "enable": "2FA Etkinleştir",
                "secretLabel": "GİZLİ ANAHTAR:",
                "benefit": "Hesabınızı yetkisiz erişimlere karşı koruyun.",
                "methodSelection": "Doğrulama Yöntemi Seçin",
                "googleAuth": "Google Authenticator",
                "smsAuth": "SMS Doğrulama",
                "googleAuthDesc": "Kimlik doğrulama uygulaması ile güvenli kodlar üretin.",
                "smsAuthDesc": "Doğrulama kodlarını SMS olarak telefonunuza alın.",
                "passkeyLoading": "Cihazınızda onaylayın…"
            }
        },
        "tokens": { "revoke_session_title": "Kullanıcının oturumu kapatılsın mı?", "revoke_all_title": "Acil durum: herkesin oturumunu kapat", "config": { "description": "Aktif oturumları görün ve güvenlik işlemleri yapın." }, "emergency_desc": "Tüm kullanıcıların oturumunu tek seferde kapatır. Dikkatli kullanın." },
        "twoFactor": { "disable": "İki adımlı doğrulamayı kapat", "verifyAndEnable": "Doğrula ve aç", "continueToDashboard": "Panele devam et" }
    },
    "selfAnalytics": {
        "tabTitle": "Yayın ve Gelir Analizim",
        "title": "Analizlerim",
        "subtitle": "Verilerin 12 saatte bir güncellenir · Saatler Türkiye saatiyle",
        "loadFailed": "Analiz yüklenemedi",
        "footnote": "Kıyaslar yalnız kendi geçmişinle yapılır. Elmas verileri TikTok görev döngüsünden gelir.",
        "tab": { "live": "Canlı Yayın Analizi", "revenue": "Gelir Analizi" },
        "live": {
            "weeklyDiamonds": "Bu hafta elmas",
            "weeklyDuration": "Yayın süresi",
            "activeDays": "Aktif gün",
            "streak": "Seri",
            "days": "gün",
            "goldenHour": "Altın saatin",
            "goldenHourHint": "{hour} civarında açtığın yayınlar ortalamanın üzerinde kazandırıyor.",
            "records": "Kişisel rekorların",
            "recordDiamonds": "En çok elmas",
            "recordViewers": "Tepe izleyici",
            "recordLongest": "En uzun yayın",
            "recordFollowers": "Bir yayında yeni takipçi",
            "pkImpact": "PK etkisi",
            "normal": "Normal",
            "sessions": "yayın",
            "pkHint": "PK maçların saatte {'%'}{pct} {dir} kazandırıyor.",
            "more": "fazla",
            "less": "az",
            "engagement": "İzleyici katılımı",
            "watchRetention": "İzleyicide kalma",
            "gifterRate": "Hediye gönderen izleyici",
            "commentRate": "Yorum yapan izleyici",
            "newFollowersPerSession": "Yayın başına yeni takipçi",
            "engagementWindow": "Son 90 gün · {n} yayın",
            "whenYouStream": "Ne zaman yayındasın",
            "recentSessions": "Son yayınların",
            "record": "Rekor",
            "noSessions": "Henüz yayın verisi yok.",
            "heartbeat": {
                "title": "Yayının kalp atışı",
                "metric": "Dakikada elmas",
                "gift": "Büyük hediye",
                "viewers": "İzleyici",
                "gifters": "Hediye gönderen",
                "bigGifts": "Büyük hediye anları",
                "noData": "Bu yayın için dakika verisi yok (yalnız son günlerdeki yayınlarda bulunur)."
            }
        },
        "revenue": {
            "cycle": "döngüsü",
            "daysLeft": "{n} gün kaldı",
            "diamonds": "elmas",
            "target": "Hedef",
            "projection": "Ay sonu tahmini",
            "tier": "Gelir kademen",
            "tierUp": "Lig atladın!",
            "tierRisk": "Kademe düşme riski",
            "lastMonth": "Geçen ay",
            "monthly": "Aylık elmas",
            "bestMonth": "En iyi ay",
            "earnings": "Bonus kazançların",
            "paid": "ÖDENDİ",
            "projected": "TAHMİNİ",
            "noEarnings": "Henüz bonus kaydı yok.",
            "taskBreakdown": "Görev bazında elmas",
            "taskType": {
                "RANK_UP": "Kademe (Rank-Up)",
                "ACTIVENESS": "Aktiflik",
                "COMMISSION": "Komisyon",
                "INCREMENTAL_REVENUE": "Artan Gelir"
            },
            "type": {},
            "validity": "Geçerlilik hedeflerin",
            "validDays": "Geçerli gün",
            "validHours": "Geçerli saat",
            "noValidity": "Bu döngüde tanımlı hedef yok."
        }
    },
    "analytics": {
        "title": "Ajans Genel Görünüm",
        "description": "Bir yayıncının tüm tarihsel ve anlamsal verisi",
        "loadFailed": "Analiz yüklenemedi",
        "footnote": "Veri kaynakları: yayın oturumları (12 saatte bir), görev anlık görüntüleri (30 dk), kazanç kalemleri (dağıtımla). SES yayını ayrımı TikTok veri kaynağı eklendiğinde açılır. Saat kırılımları Türkiye saatiyle.",
        "search": {
            "placeholder": "Yayıncı ara (kullanıcı adı)…",
            "addCompare": "Kıyas için yayıncı ekle…"
        },
        "empty": {
            "title": "Bir yayıncı seç",
            "sub": "Aramadan yayıncı seçince tüm tarihsel analiz burada açılır; 2-3 yayıncı seçersen kıyas görünümüne geçer."
        },
        "agency": {
            "title": "Ajans Geneli",
            "sub": "Bugüne kadar gelire katkı veren {n} tekil yayıncı (ayrılanlar dahil)",
            "topRevenue": "En Çok Gelir · İlk 5",
            "topSessions": "En Çok Yayın Süresi · İlk 5",
            "topRisers": "Yükselenler · İlk 5",
            "topFallers": "Düşenler · İlk 5",
            "topEmpty": "Henüz veri yok",
            "more": "Tümünü gör",
            "topDeparted": "Ayrılanlar · Kayıp Gelir",
            "section": {
                "perf": "Performans ve trend",
                "wallet": "Cüzdan · finans"
            },
            "topDebt": "Ajansın Borçlu Olduğu · İlk 5",
            "topReceivable": "En Çok Eksideki · İlk 5",
            "searchPlaceholder": "Yayıncı ara…",
            "countLabel": "{n} yayıncı",
            "hoursVal": "{n} sa",
            "diamondsVal": "{n}",
            "hoursDetail": "{s} yayın · {d} gün",
            "info": {
                "topSessions": "Toplam yayın SÜRESİNE göre sıralanır (yayın sayısı yanıltır: çok sayıda kısa yayın, az sayıda uzun yayından geride kalabilir). Yayın ve gün sayısı satırın ayrıntısında.",
                "topRisers": "Son kapalı ay geliri − sistemdeki İLK kapalı ayının geliri. Girişten beri net büyüme; içinde bulunulan ay sayılmaz.",
                "topFallers": "Son kapalı ay geliri − kendi ZİRVE ayının geliri. Zirvesinden ne kadar düşmüş; içinde bulunulan ay sayılmaz.",
                "topDeparted": "Ayrılan yayıncının zirve aylık geliri = kaybedilen aylık gelir. Yükselen/Düşen listelerine dahil edilmezler.",
                "topDebt": "Cüzdan bakiyesi ARTIDA olan yayıncılar — ajansın onlara ödemesi gereken tutar. Yalnız aktif yayıncılar; bekleyen (pending) bakiye dahil değildir.",
                "topReceivable": "Cüzdan bakiyesi EKSİDE olan yayıncılar — onların ajansa borcu. Yalnız aktif yayıncılar; bekleyen (pending) bakiye dahil değildir."
            },
            "heatTitle": "En çok ne zaman yayın açılıyor? (gün × saat, TR saati)",
            "heatBusiest": "En yoğun dilim: {at}"
        },
        "day": { "mon": "Pzt", "tue": "Sal", "wed": "Çar", "thu": "Per", "fri": "Cum", "sat": "Cmt", "sun": "Paz" },
        "heat": { "low": "az", "high": "çok" },
        "id": {
            "tier": "Kademe {t}",
            "manager": "Manager: {m}",
            "joined": "Katılım: {d} · {days} gün",
            "sessions": "{n} yayın",
            "active": "Aktif",
            "inactive": "Pasif"
        },
        "verdict": {
            "class": { "RISING": "YÜKSELEN YAYINCI", "STABLE": "STABİL YAYINCI", "FALLING": "DÜŞÜŞTE" },
            "trend": "Gelir eğilimi: son kapalı aya göre {pct}",
            "consistency": "Tutarlılık: haftada ort. {days} gün yayın",
            "risk": "Risk: son 90 günde {n} ihlal",
            "reco": {
                "RISING": "Desteklenmeli: momentum korunmalı, kademe hedefine itilmeli",
                "STABLE": "İzlenmeli: küçük hedeflerle ivme kazandırılabilir",
                "FALLING": "İlgilenilmeli: düşüşün nedeni konuşulmalı, plan çıkarılmalı"
            }
        },
        "type": {
            "ACTIVENESS": "Aylık Kazanç (Aktiflik)",
            "RANK_UP": "Kademe Bonusu",
            "INCREMENTAL_REVENUE": "Kademeli Artan Gelir",
            "COMMISSION": "Komisyon",
            "ROOKIE_MILESTONE": "Rookie & Destek",
            "OTHER": "Diğer"
        },
        "badge": { "record": "REKOR", "low": "DİP" },
        "session": { "duration": "Süre", "diamonds": "Elmas", "peak": "Tepe izleyici" },
        "revenue": {
            "title": "Gelir",
            "hint": "ajansa getirdiği kazanç · elmas + USD",
            "total": "Toplam Gelir",
            "totalSuffix": "elmas · {usd}",
            "totalSub": "sisteme girişten beri",
            "monthlyAvg": "Aylık Ortalama",
            "monthlyAvgSub": "kapalı aylar üzerinden",
            "bestMonth": "En İyi Ay",
            "worstMonth": "En Zayıf Ay",
            "monthlyChart": "Aylık Gelir Dağılımı",
            "partialNote": "* içinde bulunulan ay devam ediyor",
            "byType": "Gelir Tipi Dağılımı",
            "byHour": "Saat Dilimine Göre Gelir · yayın başlangıç saatine göre elmas",
            "peakWindow": "{h}:00 çevresindeki 3 saat gelirin {'%'}{pct}'i",
            "pkTitle": "PK vs Normal Yayın Verimi",
            "pkLabel": "PK yayını",
            "normalLabel": "Normal",
            "pkNote": "{count} PK yayını ({'%'}{share})",
            "pkNoData": "PK verisi henüz yok — yayın oturumlarına PK bilgisi veri kaynağından gelince burada görünecek",
            "sesPlaceholder": "SES yayını ayrımı — TikTok veri kaynağı eklendiğinde üçüncü seri olarak görünecek",
            "bestSession": "En Yüksek Gelirli Yayın",
            "worstSession": "En Düşük Gelirli Yayın"
        },
        "expense": {
            "title": "Gider",
            "hint": "ajansın yayıncıya ödediği",
            "total": "Toplam Ödenen",
            "totalSub": "aylık kazanç + bonus + destek",
            "bestMonth": "En Yüksek Ay",
            "worstMonth": "En Düşük Ay",
            "ratio": "Gider / Gelir Oranı",
            "kept": "Ajansta kalan",
            "paid": "Ödenen"
        },
        "broadcast": {
            "title": "Yayın Analizi",
            "hint": "oturum serisinden · 12 saatte bir güncellenir",
            "totalHours": "Toplam Yayın Süresi",
            "hoursSuffix": "saat",
            "sessions": "{n} yayında",
            "avg": "Ortalama Yayın",
            "avgSub": "oturum başına",
            "frequency": "Yayın Sıklığı",
            "freqSuffix": "gün/hafta",
            "freqSub": "katılımdan bugüne",
            "longest": "En Uzun Aralıksız",
            "heatTitle": "Gün × Saat Yoğunluğu · yayında geçen saat",
            "busiest": "En yoğun: {at}",
            "monthlyChart": "Aylık Yayın Süresi (saat)",
            "mostViewed": "En Çok İzlenen",
            "leastViewed": "En Az İzlenen",
            "peakBadge": "TEPE {n}"
        },
        "cmp": {
            "lead": "Önde",
            "g": { "revenue": "Gelir", "broadcast": "Yayın", "efficiency": "Verim" },
            "score": "Genel skor",
            "totalRevenue": "Toplam gelir (USD)",
            "trend": "Aylık gelir eğilimi",
            "monthlyAvg": "Aylık ortalama",
            "expenseRatio": "Gider / gelir oranı",
            "totalHours": "Toplam yayın süresi",
            "frequency": "Yayın sıklığı (gün/hafta)",
            "diamondsPerHour": "Elmas / saat",
            "pk": "PK oranı · verimi",
            "recommendation": "Öneri",
            "tier": "Kademe {t}",
            "footnote": "Yeşil hücre = metrikte önde olan · gider/gelir oranında düşük olan kazanır"
        },
        "view": {
            "label": {
                "monthly": "Aylık",
                "weekly": "Haftalık",
                "subtitle": "Sistem aktivitesi ve performans özeti.",
                "productivity": "Üretkenlik Puanı",
                "daily": "Günlük",
                "title": "Analiz Paneli",
                "desc": "Sistem aktivitesi ve performans özeti."
            }
        },
        "heartbeat": { "ariaLabel": "Dakika bazında yayın serisi" }
    },
    "roles": {
        "admin": "Yönetici",
        "manager": "Menajer",
        "creators": "Yayıncı",
        "partner": "İş ortağı",
        "view": {
            "label": {
                "title": "Rol Yönetimi"
            }
        }
    },
    "notificationTemplates": {
        "view": {
            "label": {
                "title": "Şablonlar"
            }
        }
    },
    "matrix": {
        "view": {
            "label": {
                "title": "İzin Matrisi"
            }
        }
    },
    "commandPalette": {
        "view": {
            "action": {
                "analytics": "Analiz Paneli",
                "analyticsSubtitle": "Veri ve raporlama",
                "campaigns": "Kampanyalar",
                "campaignsSubtitle": "Pazarlama kampanyaları",
                "inbox": "Gelen Kutusu",
                "inboxSubtitle": "Mesajları ve uyarıları görüntüle",
                "logout": "Çıkış Yap",
                "logoutSubtitle": "Hesabınızdan çıkış yapın",
                "notifications": "Bildirimler",
                "notificationsSubtitle": "Taslakları ve yayınları yönet",
                "policies": "Politikalar",
                "policiesSubtitle": "Erişim ve yetki yönetimi",
                "profile": "Profil",
                "profileSubtitle": "Profil sayfanıza gidin",
                "requests": "Talepler",
                "requestsSubtitle": "Onay ve inceleme süreçleri",
                "segments": "Segmentler",
                "segmentsSubtitle": "Kullanıcı segmentlerini yönet",
                "settings": "Ayarlar",
                "settingsSubtitle": "Uygulama yapılandırması",
                "users": "Kullanıcı Yönetimi",
                "usersSubtitle": "Kullanıcıları ve rolleri yönet"
            },
            "label": {
                "close": "kapatmak için",
                "navigate": "gezinmek için",
                "noResults": "Sonuç bulunamadı.",
                "placeholder": "Bir komut yazın veya arayın...",
                "select": "seçmek için"
            }
        }
    },
    "attr": {
        "user": {
            "profile": {
                "city": "Şehir",
                "lastIp": "Son IP Adresi",
                "deviceInfo": "Cihaz Bilgileri"
            }
        }
    },
    "user.task": "Görev Detayları",
    "user.task.header.title": "Görev Bilgileri",
    "user.task.incremental.title": "Artımlı Gelir Görevi",
    "user.task.activeness.title": "Aktivite Görevi",
    "user.task.remaining.days": "{days} gün kaldı",
    "user.task.status.completed": "Tamamlandı",
    "user.task.unit.diamonds": " Elmas",
    "user.task.unit.days": " Gün",
    "user.task.unit.hours": " Saat",
    "user.task.commission.title": "Komisyon Görevi",
    "user.task.rank_up.title": "Kademe Atlama Görevi",
    "user.profile.tiktokUsername": "TikTok Kullanıcı Adı",
    "user.profile.publicName": "Görünen Ad",
    "user.profile.instagram": "Instagram",
    "user.profile.followers": "Takipçi",
    "user.profile.likes": "Beğeni",
    "user.profile.videoCount": "Video Sayısı",
    "user.profile.lastLive": "Son Yayın",
    "user.profile.bio": "Biyografi",
    "user.agency.managerEmail": "Menajer E-postası",
    "user.agency.language": "Dil",
    "user.agency.invitationType": "Davet Türü",
    "user.agency.graduationStatus": "Mezuniyet Durumu",
    "user.agency.baselineRevenueTargetInDiamond": "Başlangıç Elmas Hedefi",
    "user.agency.manageStartDate": "Yönetim Başlangıç Tarihi",
    "user.agency.manageEndDate": "Yönetim Bitiş Tarihi",
    "user.livestreams.timing.startTime": "Tarih",
    "user.livestreams.ongoing.badge": "Canlı",
    "user.livestreams.ongoing.soFar": "şu ana kadar",
    "user.livestreams.ongoing.note": "Yayın sürüyor, bitince değerler güncellenecek.",
    "user.livestreams.timing.durationSeconds": "Süre",
    "user.livestreams.performance.label": "Performans",
    "user.livestreams.performance.viewers": "İzleyici",
    "user.livestreams.performance.peak": "Zirve",
    "user.livestreams.performance.impressions": "Gösterim",
    "user.livestreams.engagement.label": "Etkileşim",
    "user.livestreams.engagement.followers": "Takipçi",
    "user.livestreams.engagement.gifts": "Hediye",
    "user.livestreams.engagement.senders": "Gönderen",
    "user.livestreams.revenue.diamonds": "Gelir",
    "user.livestreams.features.label": "Özellikler",
    "task.activeness": "Aktivite Görevi",
    "task.commission": "Komisyon Görevi",
    "task.incremental_revenue": "Artımlı Gelir Görevi",
    "task.rank_up": "Kademe Atlama Görevi",
    "task.rookie_milestone": "Acemi Kilometre Taşı Bonusu",
    "taskProgress.title": "Görev İlerlemesi",
    "taskProgress.earnings": "Kazançlar",
    "taskProgress.earnings.projected": "Tahmini",
    "taskProgress.earnings.confirmed": "Onaylanan",
    "taskProgress.earnings.credited": "Yatırılan",
    "taskProgress.earnings.total": "Toplam Kazanç",
    "taskProgress.earnings.breakdown": "Kazanç Dağılımı",
    "taskProgress.stage": "Aşama",
    "taskProgress.stage.current": "Mevcut",
    "taskProgress.stage.completed": "Tamamlandı",
    "taskProgress.stage.upcoming": "Gelecek",
    "taskProgress.stage.reward": "Ödül",
    "taskProgress.metrics.totalDiamonds": "Toplam Elmas",
    "taskProgress.metrics.incrementalDiamonds": "Artımlı Elmas",
    "taskProgress.metrics.broadcastDays": "Yayın Günü",
    "taskProgress.metrics.broadcastDuration": "Yayın Süresi",
    "taskProgress.metrics.rewardIncome": "Kazanç",
    "taskProgress.noData": "Bu dönem için görev verisi bulunamadı.",
    "wallet.title": "Cüzdan",
    "wallet.availableBalance": "Kullanılabilir Bakiye",
    "wallet.partner.totalWithdrawn": "Toplam çekilen",
    "wallet.partner.requestWithdrawal": "Çekim talebi",
    "wallet.enums.transactionType.EARNING_CREDIT.PARTNER_PAYOUT": "İş ortağı payı",
    "wallet.totalPaid": "Toplam Ödenen",
    "wallet.available": "Kullanılabilir Bakiye",
    "wallet.pending": "Bekleyen Bakiye",
    "wallet.totalEarned": "Toplam Kazanç",
    "wallet.totalWithdrawn": "Toplam Çekim",
    "wallet.addDiamond": "Elmas Yükle",
    "wallet.diamondCreditSuccess": "Elmas başarıyla yüklendi",
    "wallet.transactions.title": "Hesap Hareketleri",
    "wallet.transactions.column.date": "Tarih",
    "wallet.transactions.column.type": "İşlem Tipi",
    "wallet.transactions.column.amount": "Tutar",
    "wallet.transactions.column.balanceAfter": "Bakiye",
    "wallet.transactions.column.referenceType": "Referans",
    "wallet.transactions.column.description": "Açıklama",
    "wallet.transactions.noData": "Hesap hareketi bulunamadı.",
    "wallet.enums.transactionType.EARNING_CREDIT": "Kazanç Aktarımı",
    "wallet.enums.transactionType.WITHDRAWAL": "Çekim",
    "wallet.enums.transactionType.ADJUSTMENT": "Düzeltme",
    "wallet.enums.transactionType.REWARD": "Ödül",
    "wallet.enums.transactionType.SUPPORT_GIFT": "Destek Elması",
    "wallet.enums.transactionType.EQUIPMENT_PURCHASE": "Ekipman Tahsisi",
    "wallet.enums.transactionType.EQUIPMENT_RETURN": "Ekipman İadesi",
    "wallet.enums.transactionType.LEGACY_EARNING": "Eski Sistem Kazancı",
    "wallet.enums.transactionType.LEGACY_PAYOUT": "Eski Sistem Ödemesi",
    "equipment": {
        "drawer": {
            "title": {
                "detail": "Ekipman Detayı"
            }
        },
        "catalog": { "error": { "load": "Ekipman verileri yüklenemedi.", "shipmentAddressRequired": "Lütfen teslimat adresini girin.", "submit": "Talep oluşturulamadı." }, "toast": { "requested": "Ekipman talebin başarıyla oluşturuldu." }, "title": "Ekipman Kataloğu", "section": { "catalog": "Katalog", "requests": "Taleplerim", "assignments": "Bana Atananlar" }, "description": "Ekipmanları incele, talep oluştur ve mevcut zimmetlerini takip et.", "search": "Ürün, marka veya kategori ara...", "empty": "Şu anda talep edilebilir ekipman bulunmuyor.", "productLink": "Ürün linki", "action": { "detail": "Detay", "request": "Talep Et" }, "requests": { "empty": "Henüz ekipman talebin bulunmuyor.", "unit": "adet" }, "assignments": { "empty": "Aktif ekipman zimmetin bulunmuyor.", "active": "Aktif adet" }, "requestDialog": { "title": "Ekipman Talebi", "description": "Talep bilgilerini girip kaydedin.", "section": { "product": "Ürün Özeti", "request": "Talep Bilgileri" }, "quantity": "Adet", "shipmentAddress": "Teslimat Adresi", "shipmentAddressPlaceholder": "Gönderim adresini yazın...", "note": "Not", "notePlaceholder": "Opsiyonel açıklama...", "confirm": "Talep Oluştur" }, "detail": { "description": "Katalogdaki ürünün tüm görsellerini ve detaylarını inceleyebilirsin." } },
        "agreement": { "error": { "load": "Sözleşme bilgisi yüklenemedi.", "accept": "Sözleşme kabul edilemedi." }, "title": "Ekipman Taahhütnamesi", "description": "Devam etmeden önce lütfen aşağıdaki sözleşmeyi okuyun ve kabul edin.", "version": "Versiyon", "checkbox": "Sözleşmeyi okudum ve kabul ediyorum", "action": { "accept": "Kabul Et ve Devam Et" } },
        "category": { "drawer": { "title": { "edit": "Kategori Düzenle", "create": "Yeni Kategori" } }, "toast": { "saved": "Kategori kaydedildi" } },
        "label": { "count": "Ekipman Sayısı" },
        "page": { "title": "Ekipman Yönetimi", "description": "Ajans demirbaş ve ekipman yönetimi" }
    },
    "interaction": {
        "enums": {
            "type": {
                "CALL": "Arama",
                "NOTE": "Not",
                "MESSAGE": "Mesaj",
                "MEETING": "Toplantı",
                "SYSTEM": "Sistem",
                "AGENCY_REMOVAL": "Ajanstan Çıkarılacak"
            },
            "outcome": {
                "ANSWERED": "Cevap verildi",
                "NO_ANSWER": "Cevap yok",
                "BUSY": "Meşgul",
                "LEFT_VOICEMAIL": "Sesli mesaj bırakıldı",
                "CALLBACK_SCHEDULED": "Geri arama planlandı"
            }
        }
    },
    "wallet.enums.referenceType.MANAGER_SUPPORT": "Ajans Desteği",
    "wallet.supportGift.button.title": "Destek Elması Yükle",
    "wallet.supportGift.drawer.title": "Destek Elması",
    "wallet.supportGift.drawer.description": "Bakiyeyi etkilemeden destek elması kaydı oluştur.",
    "wallet.supportGift.drawer.descriptionFor": "{name} için bakiyeyi etkilemeden destek elması kaydı oluştur.",
    "wallet.supportGift.field.amount": "Elmas Miktarı",
    "wallet.supportGift.field.amountPlaceholder": "Örn: 23.500 💎",
    "wallet.supportGift.field.note": "Not (opsiyonel)",
    "wallet.supportGift.field.notePlaceholder": "Örn: 12 Mayıs canlı yayın desteği",
    "wallet.supportGift.action.save": "Kaydet",
    "wallet.supportGift.balanceInfo": "Bu kayıt yayıncının bakiyesini etkilemez, yalnızca hesap hareketlerinde görünür.",
    "wallet.supportGift.offBalanceNote": "(bakiye etkilenmedi)",
    "wallet.supportGift.toast.success": "Destek elması kaydedildi.",
    "wallet.supportGift.toast.error": "Destek elması kaydedilemedi.",
    "wallet.enums.referenceType.MONTHLY_EARNING_CREDIT": "Aylık Kazanç",
    "wallet.enums.referenceType.TASK_COMPLETION": "Görev Tamamlama",
    "wallet.enums.referenceType.ADMIN_ADJUSTMENT": "Yönetici Düzeltmesi",
    "wallet.enums.referenceType.BONUS": "Bonus",
    "wallet.enums.referenceType.DIAMOND_REQUEST": "Elmas Talebi",
    "wallet.enums.referenceType.REQUEST": "Talep İşlemi",
    "wallet.enums.referenceType.REFERRAL_EARNING_CREDIT": "Referans Kazancı",
    "wallet.enums.referenceType.BIRTHDAY_BONUS": "Doğum Günü Bonusu",
    "wallet.enums.referenceType.EQUIPMENT_REQUEST": "Ekipman Talebi",
    "wallet.enums.referenceType.EQUIPMENT_ASSIGNMENT": "Ekipman Atama",
    "wallet.enums.referenceType.AGENCY_ACTIVITY": "Ajans Etkinliği",
    "wallet.description.monthlyEarningCredit": "Aylık Kazanç Aktarımı",
    "wallet.description.requestCredit": "Talep Onay - Elmas Yükleme",
    "wallet.description.requestDebit": "Talep Onay - Elmas Çekim",
    "wallet.description.adminAdjustment": "Yönetici Düzeltmesi",
    "wallet.description.birthdayBonus": "Doğum Günü Bonusu",
    "wallet.description.purchase.equipment": "Tahsis Edilen Ekipman Bedeli",
    "wallet.description.return.equipment": "İade Edilen Ekipman Bedeli",
    "wallet.description.agencyActivityReward": "Ajans Etkinliği Ödülü",
    "agencyActivities": {
        "view": {
            "label": {
                "title": "Ajans Etkinlikleri",
                "description": "TikTok ajans etkinliklerini ve performans verilerini takip edin.",
                "ongoing": "Devam Eden Etkinlikler",
                "completed": "Sonlanmış Etkinlikler",
                "cancelled": "İptal Edilenler"
            }
        },
        "info": {
            "empty": "Bu etkinlik için teknik detay bulunamadı.",
            "label": {
                "avgDiamonds": "Üye Başına Ortalama Elmas"
            },
            "section": {
                "stats": "Performans Özeti",
                "prompt": "Etkinlik Açıklaması"
            }
        },
        "ranking": {
            "title": "Katılımcı Sıralaması",
            "desc": "Etkinlikteki en güncel katılımcı performansları ve sıralamaları.",
            "table": {
                "column": {
                    "rank": "Sıra",
                    "host": "Yayıncı",
                    "diamonds": "Elmas",
                    "pk": "PK (Kazanılan/Toplam)",
                    "duration": "Yayın Süresi",
                    "tasks": "Tamamlanan Görev",
                    "progress": "İlerleme"
                }
            }
        },
        "filter": {
            "allTypes": "Tüm Tipler"
        },
        "type": {
            "PK_BRACKET": "Maç Mücadelesi",
            "RANK_LIST": "Lider Tablosu",
            "TASK": "Görev Etkinliği",
            "OTHER": "Diğer"
        },
        "status": {
            "upcoming": "Yaklaşıyor",
            "ongoing": "Devam Ediyor",
            "settling": "Sonlanıyor",
            "completed": "Sonlandı",
            "cancelled": "İptal Edildi"
        },
        "button": {
            "scrapeNow": "Şimdi Senkronize Et",
            "scraping": "Senkronize ediliyor..."
        },
        "list": {
            "title": "Etkinlikler ({count})",
            "empty": "Etkinlik bulunamadı."
        },
        "detail": {
            "empty": "Detay için bir etkinlik seçin.",
            "unsupportedType": "Bu etkinlik tipinin detayı henüz desteklenmiyor.",
            "openInTikTok": "TikTok'ta Aç",
            "stat": {
                "members": "Üye Sayısı",
                "totalDiamonds": "Toplam Elmas",
                "start": "Başlangıç",
                "end": "Bitiş",
                "pkPairs": "PK Eşleşmeleri"
            }
        },
        "toast": {
            "listError": "Etkinlik listesi yüklenemedi.",
            "detailError": "Etkinlik detayı yüklenemedi.",
            "scrapeStarted": "Senkronizasyon başlatıldı.",
            "scrapeError": "Senkronizasyon başlatılamadı."
        },
        "bracket": {
            "desc": "Maç mücadelesi şeması ve yayıncı performansları.",
            "tab": {
                "schema": "Şema",
                "participants": "Yayıncılar"
            },
            "roundLabel": "Tur {num}",
            "stat": {
                "rounds": "Tur",
                "pairs": "Maç",
                "completed": "Tamamlanan",
                "participants": "Yayıncı",
                "champion": "Şampiyon"
            },
            "pair": {
                "completed": "Sona erdi",
                "live": "Canlı",
                "scheduled": "Maç yok",
                "tbd": "Onaylanacak"
            },
            "round": {
                "final": "Final",
                "semifinal": "Yarı final",
                "quarterfinal": "Çeyrek final",
                "notStarted": "Başlamadı",
                "live": "Devam ediyor",
                "ended": "Sona erdi"
            },
            "empty": {
                "rounds": "Henüz tur tanımlanmamış.",
                "pairs": "Bu turda eşleşme yok."
            },
            "col": {
                "host": "Yayıncı",
                "manager": "Yönetici",
                "group": "Grup",
                "diamond": "Elmas",
                "pkCount": "PK",
                "winCount": "Galibiyet",
                "winRate": "Galibiyet Oranı",
                "highestRound": "En Yüksek Tur",
                "champion": "Şampiyon"
            }
        },
        "table": {
            "column": {
                "name": "Etkinlik Adı",
                "rank": "Sıra",
                "score": "Elmas/Skor",
                "status": "Durum",
                "startTime": "Başlangıç",
                "endTime": "Bitiş",
                "totalDiamonds": "Toplam Elmas",
                "memberCount": "Üye Sayısı",
                "type": "Tür",
                "actions": "İşlemler"
            },
            "action": {
                "ranking": "Sıralama",
                "info": "Etkinlik Detayları",
                "bracket": "Fikstür"
            }
        },
        "transfer": {
            "action": {
                "button": "Kazanç Aktar",
                "submit": "Aktar ({count})"
            },
            "drawer": {
                "title": "Kazanç Aktar",
                "description": "Etkinliğe katılan yayıncılara elmas bazlı kazanç aktarın.",
                "descriptionFor": "\"{name}\" etkinliğine katılan yayıncılara kazanç aktarın."
            },
            "search": {
                "placeholder": "Yayıncı ara (ad veya kullanıcı adı)..."
            },
            "list": {
                "loading": "Katılımcılar yükleniyor...",
                "empty": "Bu etkinlikte gösterilecek katılımcı yok."
            },
            "badge": {
                "unmatched": "Eşleşmemiş — aktarım yapılamaz",
                "alreadyTransferred": "Zaten aktarıldı",
                "alreadyTransferredAmount": "Zaten aktarıldı ({amount} 💎)"
            },
            "field": {
                "diamondsPlaceholder": "Elmas miktarı"
            },
            "info": {
                "conversion": "Girdiğiniz elmas miktarı sunucuda USD'ye çevrilerek cüzdana eklenir."
            },
            "confirm": {
                "title": "Emin misiniz?",
                "message": "Seçilen {count} yayıncıya kazanç aktarılacak. Bu işlem geri alınamaz.",
                "confirmText": "Aktar"
            },
            "toast": {
                "success": "{count} yayıncıya kazanç aktarıldı.",
                "alreadyTransferred": "{count} yayıncıya zaten aktarım yapılmıştı, atlandı.",
                "skipped": "{count} kalem geçersizdi ve atlandı.",
                "loadError": "Katılımcılar yüklenemedi.",
                "error": "Kazanç aktarımı başarısız oldu."
            }
        },
        "ranklist": {
            "empty": "Bu etkinlikte yayıncı yok.",
            "filter": {
                "agent": "Yönetici",
                "agentPlaceholder": "manager@haymen.com.tr",
                "group": "Grup",
                "groupPlaceholder": "Grup adı",
                "apply": "Uygula",
                "clear": "Temizle",
                "total": "Toplam {count} yayıncı"
            },
            "col": {
                "rank": "Sıra",
                "host": "Yayıncı",
                "manager": "Yönetici",
                "group": "Grup",
                "diamond": "Elmas",
                "score": "Skor",
                "pkCount": "PK",
                "liveDuration": "Yayın Süresi"
            },
            "pagination": {
                "prev": "Önceki",
                "next": "Sonraki",
                "page": "Sayfa {current} / {total}"
            }
        }
    },
    "violations": {
        "view": {
            "label": {
                "title": "İhlaller",
                "description": "TikTok yayıncı ihlallerini ve ceza kayıtlarını takip edin.",
                "all": "Tüm İhlaller"
            }
        },
        "table": {
            "column": {
                "anchor": "Yayıncı",
                "punishTime": "Ceza Tarihi",
                "penaltyEndTime": "Bitiş Tarihi",
                "penaltyDuration": "Ceza Süresi",
                "punishType": "Ceza Türü",
                "currentStatus": "Mevcut Durum",
                "punishStatus": "Ceza Durumu",
                "appealStatus": "İtiraz Durumu",
                "content": "İhlal İçeriği",
                "actions": "İşlemler"
            },
            "action": {
                "info": "İhlal Detayları"
            }
        },
        "info": {
            "title": "İhlal Detayları",
            "section": {
                "violation": "İhlal Bilgileri",
                "video": "Video Detayları",
                "appeal": "İtiraz Bilgileri"
            },
            "label": {
                "context": "İhlal Bağlamı",
                "reason": "İhlal Nedeni",
                "rejectionReason": "Red Nedeni",
                "canAppeal": "İtiraz Edilebilir"
            }
        },
        "enums": {
            "punishType": {
                "LIVE_ACCESS_SUSPENDED": "Canlı Yayın Erişimi Askıya Alındı",
                "MULTI_GUEST_SUSPENDED": "Çoklu Konuk Askıya Alındı",
                "ACCOUNT_SUSPENDED": "Hesap Askıya Alındı",
                "UNKNOWN": "Bilinmeyen",
                "GIFT_ACCESS_SUSPENDED": "Hediye gönderme askıya alındı",
                "NR_GIFT_ACCESS_SUSPENDED": "CANLI Yayın görünürlüğü kısıtlandı + Hediye verme askıya alındı",
                "GIFT_ACCESS_SUSPENDED_ROOM_LEVEL": "Hediye gönderme askıya alındı (Tekli CANLI Yayın)",
                "NR_GIFT_ACCESS_SUSPENDED_ROOM_LEVEL": "CANLI Yayın görünürlüğü kısıtlandı + Hediye verme kısıtlandı (Tekli CANLI Yayın)"
            },
            "currentStatus": {
                "IN_EFFECT": "Yürürlükte",
                "WITHDRAWN": "Geri Çekildi",
                "ENDED": "Sona Erdi",
                "UNKNOWN": "Bilinmeyen"
            },
            "appealStatus": {
                "NOT_APPEALED": "İtiraz Edilmedi",
                "APPROVED": "Onaylandı",
                "NOT_APPROVED_OPEN": "Onaylanmadı, incelemeye açık",
                "INQUIRY_ONGOING": "Yayıncı Ağı incelemesi devam ediyor",
                "NOT_APPROVED": "Onaylanmadı",
                "UNKNOWN": "Bilinmeyen",
                "NOT_APPEALED_OPEN": "İtirazda bulunulmadı, sorguya açık",
                "APPEAL_ONGOING_OPEN": "İnceleniyor, sorguya açık"
            },
            "punishStatus": {
                "ACTIVE": "Aktif",
                "APPEALED": "İtiraz Edildi",
                "APPEAL_REJECTED": "İtiraz Reddedildi",
                "APPEAL_ACCEPTED": "İtiraz Kabul Edildi",
                "UNKNOWN": "Bilinmiyor",
                "null": "Ceza Yok"
            },
            "clipStatus": {
                "AVAILABLE": "Mevcut",
                "EXPIRED": "Süresi Doldu",
                "RESTRICTED": "Kısıtlı",
                "UNKNOWN": "Bilinmeyen"
            },
            "duration": {
                "week": "Hafta",
                "day": "Gün",
                "hour": "Saat",
                "minute": "Dakika"
            }
        }
    },
    "completeProfile": {
        "title": "Profilinizi Tamamlayın",
        "subtitle": "Devam etmek için bilgilerinizi girin",
        "recoveryTitle": "Bilgilerinizi Kısaca Yenileyelim",
        "recoverySubtitle": "Bu adımı sadece bir kez göstereceğiz",
        "recoveryNoticeTitle": "Özür dileriz",
        "recoveryNoticeText": "Hesap bilgilerinizden bazılarını tekrar doğrulamamız gerekiyor. Lütfen ad ve soyad bilginizi yeniden girin. İsterseniz e-posta adresinizi de güncelleyebilirsiniz.",
        "recoveryRealNameNote": "Lütfen ad ve soyad alanlarına resmi kayıtlarda kullandığınız gerçek bilgilerinizi girin. Bu bilgiler ileride ekipman gönderimi gibi operasyonel süreçlerde kullanılacaktır.",
        "recoverySubmit": "Bilgilerimi Güncelle",
        "firstname": "Ad",
        "lastname": "Soyad",
        "email": "E-posta",
        "emailPlaceholder": "E-posta adresinizi girin",
        "dateOfBirth": "Doğum Tarihi",
        "phoneNumber": "Telefon Numarası",
        "phonePlaceholder": "+90 5XX XXX XX XX",
        "province": "Şehir",
        "provincePlaceholder": "Şehir seçin",
        "district": "İlçe",
        "districtPlaceholder": "İlçe seçin",
        "streamCategory": "Yayın Kategorisi",
        "streamCategoryPlaceholder": "Yayın kategorinizi seçin",
        "optional": "opsiyonel",
        "submit": "Devam Et",
        "setPassword": "Şifrenizi Belirleyin",
        "password": "Şifre",
        "confirmPassword": "Şifre Tekrar",
        "passwordPlaceholder": "En az 6 karakter",
        "confirmPasswordPlaceholder": "Şifrenizi tekrar girin",
        "error": {
            "required": "Lütfen zorunlu alanları doldurun",
            "generic": "Bir hata oluştu, lütfen tekrar deneyin",
            "passwordMin": "Şifre en az 6 karakter olmalıdır",
            "passwordMismatch": "Şifreler eşleşmiyor",
            "under18": "18 yaşından küçükler kayıt olamaz",
            "invalidEmail": "Geçerli bir e-posta adresi girin"
        },
        "user": {
            "attr": {
                "livestreams": {
                    "timing": {
                        "starttime": "Başlangıç Zamanı",
                        "durationseconds": "Süre"
                    },
                    "performance": {
                        "label": "Performans",
                        "viewers": "İzleyiciler",
                        "peak": "Zirve",
                        "impressions": "Gösterim"
                    },
                    "engagement": {
                        "label": "Etkileşim",
                        "followers": "Takipçiler",
                        "gifts": "Hediyeler",
                        "senders": "Gönderenler"
                    },
                    "revenue": {
                        "diamonds": "Kazanç (Elmas)"
                    },
                    "features": {
                        "label": "Özellikler"
                    }
                }
            }
        }
    },
    "interactions": {
        "title": "Yayıncı Notları",
        "loading": "Yükleniyor...",
        "empty": "Henüz etkileşim kaydı bulunmuyor.",
        "type": {
            "call": "Arama",
            "note": "Not",
            "message": "Mesaj",
            "meeting": "Toplantı",
            "system": "Sistem"
        },
        "outcome": {
            "answered": "Cevaplandı",
            "noAnswer": "Cevap Yok",
            "busy": "Meşgul",
            "leftVoicemail": "Sesli Mesaj Bırakıldı",
            "callbackScheduled": "Geri Arama Planlandı"
        },
        "actions": {
            "create": "Yeni Not Ekle",
            "edit": "Düzenle",
            "delete": "Sil",
            "pin": "Sabitle",
            "unpin": "Sabitlemeyi Kaldır"
        },
        "section": {
            "recent": "Son Notlar"
        },
        "confirm": {
            "delete": "Bu etkileşim kaydını silmek istediğinize emin misiniz?"
        },
        "drawer": {
            "createTitle": "Yeni Not",
            "editTitle": "Notu Düzenle",
            "description": "Yayıncı ile ilgili not, arama, toplantı veya mesaj kaydı ekleyin."
        },
        "form": {
            "type": "Tip",
            "outcome": "Sonuç",
            "selectOutcome": "Sonuç seçin",
            "content": "İçerik",
            "contentPlaceholder": "Etkileşim detaylarını yazın...",
            "attachments": "Ekler",
            "addFile": "Dosya Ekle",
            "uploading": "Yükleniyor...",
            "pinned": "Sabitlenmiş olarak işaretle",
            "cancel": "İptal",
            "create": "Oluştur",
            "update": "Güncelle",
            "saving": "Kaydediliyor..."
        },
        "validation": {
            "contentRequired": "İçerik alanı zorunludur.",
            "outcomeRequired": "Arama tipi için sonuç seçimi zorunludur.",
            "maxAttachments": "En fazla 10 dosya eklenebilir."
        },
        "toast": {
            "created": "Etkileşim kaydı oluşturuldu.",
            "updated": "Etkileşim kaydı güncellendi.",
            "deleted": "Etkileşim kaydı silindi.",
            "pinned": "Etkileşim sabitlendi.",
            "unpinned": "Sabitleme kaldırıldı.",
            "loadError": "Etkileşimler yüklenirken hata oluştu.",
            "saveError": "Kaydetme sırasında hata oluştu.",
            "updateError": "Güncelleme sırasında hata oluştu.",
            "deleteError": "Silme sırasında hata oluştu.",
            "uploadError": "Dosya yükleme sırasında hata oluştu."
        }
    },
    "user": {
        "status": {
            "active": "Aktif",
            "suspended": "Askıda",
            "banned": "Yasaklı",
            "account_closed": "Hesap Kapatıldı",
            "quit": "Ayrıldı",
            "modal": {
                "title": "Yayıncı Durumunu Değiştir",
                "currentStatus": "Mevcut Durum",
                "newStatus": "Yeni Durum",
                "reason": "Sebep",
                "reasonPlaceholder": "Durum değişikliği sebebini yazın...",
                "cancel": "İptal",
                "confirm": "Onayla",
                "saving": "Kaydediliyor..."
            },
            "validation": {
                "reasonRequired": "Sebep alanı zorunludur.",
                "sameStatus": "Yeni durum mevcut durumla aynı olamaz."
            },
            "toast": {
                "changed": "Kullanıcı durumu başarıyla güncellendi.",
                "changeError": "Durum değiştirme sırasında hata oluştu."
            }
        }
    },
    "quickInfo": {
        "phone": "Telefon",
        "lastLogin": "Son Giriş",
        "ipAddress": "IP Adresi",
        "lastBroadcast": "Son Canlı Yayın",
        "banStatus": "Ban Durumu",
        "banned": "Banlı",
        "active": "Aktif",
        "banEnd": "Bitiş"
    },
    "eligibility": {
        "mobile": { "today": "Bugün", "yesterday": "Dün", "okCount": "{n} uygun", "badCount": "{n} uygun değil", "records": "{n} kayıt", "loadMore": "Daha fazla yükle", "checkN": "{n} hesabı kontrol et" },
        "title": "Uygunluk Kontrolü",
        "description": "İçerik üreticilerinin ajansa uygunluğunu kontrol edin",
        "usernamesLabel": "Kullanıcı Adları",
        "placeholder": "Kullanıcı adlarını virgülle veya satır başına girin...\nÖrn: baran.buyuk, other_user",
        "hint": "Virgülle veya satır başına ayırarak en fazla 30 kullanıcı adı girebilirsiniz. Sonuçlar TikTok Backstage üzerinden kontrol edilir.",
        "check": "Kontrol Et",
        "history": "Tarihçe",
        "historyDate": "Tarih",
        "historyEmpty": "Henüz bir sorgu yapılmamış.",
        "newCheck": "Yeni Kontrol",
        "available": "Uygun",
        "unavailable": "Uygun Değil",
        "error": "Kontrol sırasında bir hata oluştu.",
        "checkComplete": "{count} kullanıcı kontrol edildi.",
        "table": {
            "username": "Kullanıcı Adı",
            "status": "Durum",
            "nickname": "İsim",
            "reason": "Sebep",
            "tier": "Davetiye Türü",
            "source": "Kaynak",
            "queriedBy": "Sorgulayan"
        },
        "source": {
            "ELIGIBILITY_CHECK": "Uygunluk Kontrolü",
            "REFERRAL_VALIDATION": "Referans Talebi"
        },
        "watchlist": {
            "tab": {
                "title": "İzleme Listesi"
            },
            "add": {
                "title": "Yayıncı Ekle",
                "username": "Kullanıcı adı",
                "phoneNumber": "Telefon numarası",
                "button": "+ Ekle",
                "success": "Kullanıcı izleme listesine eklendi",
                "duplicate": "Bu kullanıcı zaten listede"
            },
            "table": {
                "username": "Kullanıcı Adı",
                "phoneNumber": "Telefon",
                "status": "Durum",
                "reason": "Sebep",
                "lastChecked": "Son Kontrol",
                "statusChanged": "Durum Değişikliği",
                "addedBy": "Ekleyen",
                "actions": "İşlemler"
            },
            "summary": {
                "total": "izleniyor",
                "available": "uygun",
                "unavailable": "uygun değil",
                "pending": "bekliyor"
            },
            "checkNow": {
                "label": "Şimdi Kontrol Et",
                "progress": "{checked}/{total} kontrol edildi",
                "success": "Kontrol tamamlandı",
                "error": "Kontrol başarısız",
                "cooldown": "Lütfen 5 dakika bekleyin"
            },
            "remove": {
                "confirm": "Emin misiniz?"
            },
            "empty": {
                "title": "İzleme Listesi Boş",
                "description": "Henüz kimse izlenmiyor. İlk kullanıcıyı ekleyin."
            },
            "error": {
                "loadFailed": "Liste yüklenemedi. Tekrar dene."
            }
        }
    },
    "earningsDistribution": {
        "view": {
            "title": "Kazanç Dağıtımı",
            "selectMonth": "Ay Seçin",
            "totalEarnings": "Toplam Kazanç",
            "totalCreators": "Yayıncı Sayısı",
            "projected": "Tahmini",
            "confirmed": "Onaylandı",
            "credited": "Aktarıldı"
        },
        "table": {
            "column": {
                "creator": "Yayıncı",
                "total": "Toplam",
                "status": "Durum",
                "type": "Kazanç Tipi",
                "amount": "Tutar",
                "days": "Gün",
                "hours": "Saat",
                "agencyShare": "Ajans Payı",
                "creatorShare": "Yayıncı Payı",
                "diamonds": "Elmas"
            }
        },
        "action": {
            "confirm": "Onayla",
            "credit": "Cüzdana Aktar",
            "selectAll": "Tümünü Seç",
            "editAmount": "Tutarı Düzenle"
        },
        "dialog": {
            "confirmTitle": "Kazançları Onayla",
            "confirmMessage": "{count} yayıncının kazançları onaylanacak.",
            "creditTitle": "Cüzdana Aktar",
            "creditMessage": "{count} yayıncıya toplam {amount} aktarılacak. Onaylıyor musunuz?"
        },
        "toast": {
            "confirmSuccess": "Kazançlar başarıyla onaylandı.",
            "creditSuccess": "Kazançlar başarıyla cüzdana aktarıldı.",
            "updateSuccess": "Tutar güncellendi.",
            "fetchError": "Kazançlar yüklenemedi",
            "updateError": "Kazançlar güncellenemedi",
            "confirmError": "Kazançlar onaylanamadı",
            "creditError": "Kazançlar cüzdanlara aktarılamadı"
        },
        "earningType": {
            "ACTIVENESS": "Aktiflik",
            "COMMISSION": "Komisyon",
            "INCREMENTAL_REVENUE": "Artan Gelir",
            "RANK_BONUS": "Seviye Bonusu",
            "ROOKIE_MILESTONE": "Yeni Üye Bonusu",
            "REFERRAL": "Referans Komisyonu"
        },
        "noData": "Seçilen ay için kazanç verisi bulunamadı.",
        "filter": {
            "all": "Tümü",
            "byStatus": "Duruma Göre",
            "byType": "Kazanç Tipine Göre"
        }
    },
    "referrals": {
        "title": "Referanslar",
        "table": {
            "column": {
                "referredUsername": "Referans Olunan",
                "status": "Durum",
                "activatedAt": "Aktif Olma Tarihi",
                "totalEarnings": "Toplam Kazanç",
                "createdAt": "Oluşturulma Tarihi"
            }
        },
        "status": {
            "PENDING": "Beklemede",
            "ACTIVE": "Aktif",
            "EXPIRED": "Süresi Dolmuş",
            "CANCELLED": "İptal Edildi"
        },
        "noData": "Bu kullanıcının referans kaydı bulunamadı.",
        "cancel": "İptal Et",
        "cancelConfirm": "Bu referansı iptal etmek istediğinize emin misiniz?",
        "cancelSuccess": "Referans başarıyla iptal edildi.",
        "tab": "Referanslar"
    },
    "birthday": {
        "toast": {
            "title": "Doğum Günün Kutlu Olsun!",
            "message": "Hesabına {diamonds} elmas yüklendi!"
        }
    },
    "managerMapping": {
        "view": {
            "label": {
                "title": "Manager Eşleştirme",
                "desc": "Sistem manager kullanıcılarını TikTok manager email adresleriyle eşleştirin."
            },
            "toast": { "mapSuccess": "Yönetici eşleştirildi", "unmapSuccess": "Yönetici eşleştirmesi kaldırıldı" }
        },
        "tab": {
            "mapped": "Eşleşenler",
            "unmapped": "Eşleşmemiş Manager",
            "orphan": "Orphan TikTok Email"
        },
        "label": {
            "manager": "Manager",
            "tiktokManagerEmail": "TikTok Manager Email",
            "mappedAt": "Eşleşme Tarihi",
            "mappedBy": "Eşleştiren",
            "creatorCount": "{count} creator",
            "selectTiktokEmail": "TikTok email seç",
            "noMapped": "Henüz eşleştirme yok.",
            "noUnmapped": "Eşleştirilmemiş manager yok.",
            "noOrphan": "Orphan TikTok email yok.",
            "orphanWarning": "Sistemde bu email'e karşılık gelen manager yok. Önce manager kullanıcısını oluşturun."
        },
        "action": {
            "unmap": "Eşleştirmeyi kaldır",
            "mapNow": "Eşleştir",
            "unmapConfirmText": "Bu eşleştirmeyi kaldırmak istediğinize emin misiniz?"
        },
        "toast": {
            "mapSuccess": "Eşleştirme başarıyla oluşturuldu.",
            "unmapSuccess": "Eşleştirme başarıyla kaldırıldı."
        }
    },
    "goals": {
        "template": {
            "view": {
                "title": "Hedef Şablonları",
                "desc": "Aylık, üç aylık ve yıllık hedef şablonlarını yönet",
                "create": "Yeni Şablon",
                "empty": "Henüz şablon eklenmemiş",
                "deleteTitle": "Şablonu Sil",
                "deleteConfirm": "Bu şablonu kalıcı olarak silmek istediğinize emin misiniz?",
                "deleteSuccess": "Şablon silindi",
                "manageAssignments": "Atamaları yönet"
            },
            "label": {
                "code": "Kod",
                "name": "Ad",
                "description": "Açıklama",
                "audience": "Hedef Kitle",
                "metric": "Metrik",
                "period": "Periyot",
                "targetValue": "Hedef Değer",
                "active": "Aktif",
                "activeDesc": "Şablon aktif olduğunda ilgili dönemde instance üretilir",
                "startDate": "Başlangıç",
                "endDate": "Bitiş",
                "spelExpression": "SpEL İfadesi",
                "targetingType": "Hedefleme Tipi",
                "segmentCode": "Segment Kodu",
                "assignments": "Atamalar"
            },
            "audience": {
                "MANAGER": "Manager",
                "CREATOR": "Yayıncı"
            },
            "metric": {
                "NEW_BROADCASTER_COUNT": "Yeni Yayıncı Sayısı",
                "SUBORDINATE_LIVE_HOURS": "Ekip Yayın Saati",
                "SUBORDINATE_DIAMOND_SUM": "Ekip Elmas Toplamı",
                "CREATOR_DIAMOND_SUM": "Yayıncı Elması",
                "CREATOR_LIVE_HOURS": "Yayıncı Yayın Saati",
                "CUSTOM_SPEL": "Özel SpEL"
            },
            "period": {
                "MONTHLY": "Aylık",
                "QUARTERLY": "Üç Aylık",
                "YEARLY": "Yıllık"
            },
            "targeting": {
                "ALL": "Tümü",
                "SEGMENT": "Segment",
                "MANUAL": "Manuel"
            },
            "drawer": {
                "createTitle": "Yeni Şablon",
                "editTitle": "Şablonu Düzenle",
                "desc": "Hedef şablonunu yapılandır",
                "basicInfo": "Temel Bilgiler",
                "metricConfig": "Metrik Yapılandırma",
                "periodTarget": "Periyot ve Hedef",
                "targeting": "Hedefleme",
                "monthlyDistribution": "Aylık Dağılım",
                "monthlyDistributionDesc": "12 ay toplam 1.0 olmalı. Boş bırakılırsa eşit dağıtılır.",
                "sum": "Toplam",
                "spelRequired": "CUSTOM_SPEL için SpEL ifadesi gereklidir",
                "segmentRequired": "SEGMENT hedefleme için segment kodu gereklidir",
                "createSuccess": "Şablon oluşturuldu",
                "updateSuccess": "Şablon güncellendi",
                "distributionSumError": "Aylık paylar toplamı 1 olmalı. Şu anki toplam: {sum}."
            }
        },
        "instance": {
            "view": {
                "title": "Hedeflerim",
                "subtitle": "Bu dönemdeki hedeflerin ve tahmini kapanış değerlerin",
                "currentPeriod": "Aktif Dönem",
                "history": "Geçmiş",
                "empty": "Bu döneme ait hedef bulunmuyor."
            },
            "label": {
                "progress": "İlerleme",
                "dayPct": "Gün oranı",
                "projection": "Tahmini dönem sonu",
                "expectedPct": "Gün bazlı beklenen: {'%'}{pct}",
                "template": "Şablon",
                "period": "Dönem",
                "status": "Durum"
            },
            "status": {
                "ACTIVE": "Aktif",
                "COMPLETED": "Tamamlandı",
                "MISSED": "Kaçırıldı",
                "EXPIRED": "Süresi Doldu"
            }
        },
        "assignment": {
            "label": {
                "assigneeType": "Atama Tipi",
                "user": "Kullanıcı",
                "segment": "Segment",
                "override": "Hedef Geçersiz Kılma",
                "baseTarget": "Şablon Hedefi",
                "baseTargetSource": "Şablon hedefinden",
                "effectiveTarget": "Geçerli Hedef",
                "active": "Aktif",
                "startDate": "Başlangıç",
                "endDate": "Bitiş",
                "selected": "Seçili",
                "overridden": "Özel hedef"
            },
            "assigneeType": {
                "ALL": "Tümü",
                "USER": "Kullanıcı",
                "SEGMENT": "Segment"
            },
            "drawer": {
                "title": "Atamalar — {name}",
                "desc": "Bu şablonu kullanıcılara, segmentlere veya tümüne ata",
                "addNew": "Yeni Atama Ekle",
                "existing": "Mevcut Atamalar",
                "empty": "Henüz atama yok. Yukarıdan ekle.",
                "emptyTitle": "Henüz atama yok",
                "emptyDesc": "Bu şablon kimseye atanmadı. Yöneticilere, segmentlere veya tüm hedef kitleye atayarak başla.",
                "firstCTA": "İlk atamayı oluştur",
                "allHint": "Bu şablon, {role} rolündeki tüm kullanıcılara otomatik atanacak.",
                "activeHint": "Pasif atamalar için instance üretilmez",
                "add": "Ata",
                "searchUser": "Kullanıcı ara…",
                "overridePlaceholder": "Boş bırakılırsa şablon hedefi kullanılır",
                "selectAssignee": "Lütfen bir atama hedefi seçin",
                "invalidOverride": "Geçersiz hedef değeri",
                "noTemplate": "Şablon bilgisi bulunamadı",
                "createSuccess": "Atama oluşturuldu",
                "deleteSuccess": "Atama silindi",
                "deleteTitle": "Atamayı Sil",
                "deleteConfirm": "Bu atamayı silmek istediğinize emin misiniz?"
            }
        },
        "managerGoals": {
            "view": {
                "title": "Yönetici Hedefleri",
                "subtitle": "Tüm yöneticilerin aktif dönemdeki hedef ilerlemesi",
                "empty": "Sistemde aktif yönetici bulunmuyor.",
                "noGoals": "Aktif hedef yok"
            },
            "label": {
                "newTarget": "Yeni hedef değeri",
                "invalidTarget": "Geçerli bir pozitif hedef giriniz.",
                "overrideSuccess": "Hedef güncellendi ve yeniden hesaplandı.",
                "recomputeSuccess": "Yeniden hesaplandı.",
                "manager": "Yönetici",
                "goalCount": "Hedef Sayısı",
                "goals": "hedef",
                "onTrack": "yolunda"
            },
            "action": {
                "override": "Hedef Değiştir",
                "recompute": "Yeniden Hesapla"
            },
            "override": {
                "title": "Hedef Değerini Güncelle"
            }
        }
    },
    "report": {
        "list": {
            "title": "Raporlar",
            "subtitle": "Yetkilendirildiğiniz raporlara buradan ulaşabilirsiniz.",
            "empty": "Görüntülenebilecek bir rapor yok.",
            "loadFailed": "Raporlar yüklenemedi"
        },
        "runner": {
            "title": "Rapor Çalıştır",
            "subtitle": "Filtreleri seçin, raporu çalıştırın.",
            "run": "Çalıştır",
            "running": "Çalıştırılıyor…",
            "exportCsv": "CSV İndir",
            "exporting": "İndiriliyor…",
            "exportFailed": "Dışa aktarma başarısız",
            "runFailed": "Rapor çalıştırılamadı",
            "schemaFailed": "Rapor şeması yüklenemedi",
            "noResults": "Filtrelere uyan kayıt bulunamadı.",
            "dateRangeStart": "Başlangıç tarihi",
            "dateRangeEnd": "Bitiş tarihi"
        },
        "wallet-transactions": {
            "name": "Yayıncı Hesap Hareketleri",
            "desc": "Yayıncıların cüzdan hareketlerini (kazanç, çekim, destek elması vs.) listeler.",
            "param": {
                "dateRange": "Tarih Aralığı",
                "managerIds": "Yönetici",
                "types": "İşlem Tipleri"
            },
            "column": {
                "username": "Yayıncı",
                "managerName": "Yönetici",
                "type": "Tip",
                "amount": "Tutar",
                "balanceAfter": "Sonraki Bakiye",
                "description": "Açıklama",
                "createdAt": "Tarih"
            }
        },
        "equipment-assignments": {
            "name": "Yayıncı Ekipman Raporu",
            "desc": "Yayıncılara verilen ekipmanları, miktarlarını ve teslim/iade tarihlerini listeler.",
            "param": {
                "dateRange": "Verilme Tarihi",
                "equipmentIds": "Ekipman",
                "managerIds": "Yönetici",
                "status": {
                    "option": {
                        "ACTIVE": "Aktif",
                        "RETURNED": "İade Edildi",
                        "ALL": "Hepsi"
                    }
                }
            },
            "column": {
                "username": "Yayıncı",
                "managerName": "Yönetici",
                "equipmentName": "Ekipman",
                "assignedQuantity": "Verilen",
                "returnedQuantity": "İade Edilen",
                "assignedAt": "Verilme",
                "returnedAt": "İade",
                "notes": "Not"
            }
        },
        "creator-interactions": {
            "name": "Yayıncı Not Hareketleri",
            "desc": "Yayıncılara eklenen not, mesaj, çağrı ve toplantı kayıtlarını listeler.",
            "param": {
                "dateRange": "Tarih Aralığı",
                "managerIds": "Yönetici",
                "types": "Tipler"
            },
            "column": {
                "username": "Yayıncı",
                "managerName": "Yönetici",
                "type": "Tip",
                "content": "İçerik",
                "outcome": "Sonuç",
                "createdByName": "Ekleyen",
                "createdAt": "Tarih"
            }
        },
        "preset": {
            "all": "Hepsi",
            "today": "Bugün",
            "last7": "Son 7 gün",
            "last30": "Son 30 gün",
            "thisMonth": "Bu ay",
            "custom": "Özel Aralık"
        }
    },
    "creatorLead": {
        "tabs": {
            "official": "TikTok Resmi Adayları",
            "found": "Bulunan İçerik Üreticisi Adayları",
            "outreach": "Gönderimler",
            "applications": "Site Başvuruları"
        },
        "scout": {
            "hasContactFilter": "İletişim bilgisi var",
            "title": "Scout Adayları",
            "lastSync": "Son eşitleme",
            "searchPlaceholder": "Kullanıcı adı ara…",
            "empty": "Bu aşamada aday yok. Veriler TikTok Backstage'den 6 saatte bir eşitlenir.",
            "unavailable": "Hesap erişilemez",
            "stage": {
                "1": "İncelenecek",
                "2": "İletişime geçildi",
                "3": "Davet edildi",
                "4": "İlgilenmiyorum"
            },
            "sort": {
                "liveTimes": "Yayın gününe göre",
                "diamonds": "Elmasa göre",
                "followers": "Takipçiye göre",
                "lastSeen": "Son görülmeye göre",
                "newest": "En yeni"
            },
            "table": {
                "contact": "İletişim",
                "phone": "Telefon",
                "avgWatch": "Ort. izleyici (30g)",
                "liveDuration30d": "Yayın süresi (30g)",
                "liveTimes30d": "Yayın günü (30g)",
                "diamonds30d": "Elmas (30g)",
                "creator": "Yayıncı",
                "followers": "Takipçi",
                "likes": "Beğeni",
                "videos": "Video",
                "addedAt": "Havuza girişi",
                "invitedAt": "Davet tarihi",
                "expiresAt": "Süre bitişi",
                "flags": "Durum"
            },
            "flag": {
                "joined": "Ajansa katıldı",
                "applied": "Başvurdu",
                "marked": "İşaretli"
            }
        },
        "view": {
            "title": "Yayıncı Adayları",
            "subtitle": "CSV ile yayıncı yükle, uygunluk durumlarını izle, davet öncesi profilleri zenginleştir."
        },
        "upload": {
            "title": "CSV dosyasını sürükle veya tıkla",
            "hint": "Sütun: username (veya farmos formatı: userId, uniqueId, league, rank, score)",
            "button": "CSV Yükle",
            "uploading": "Yükleniyor…",
            "inserted": "Eklendi",
            "updated": "Güncellendi",
            "skipped": "Atlandı",
            "errors": "Hatalı",
            "total": "Toplam"
        },
        "filter": {
            "searchPlaceholder": "Kullanıcı adı veya nick ile ara…",
            "allStatus": "Tüm Durumlar",
            "allTier": "Tüm Kademeler",
            "allManagers": "Tüm Yöneticiler",
            "unassigned": "Atanmamış",
            "allLeagues": "Tüm Ligler",
            "allMessageStatus": "Tüm Mesaj Durumları",
            "pastLiveCountPlaceholder": "Min. Yayın Sayısı",
            "totalLiveLikesPlaceholder": "Min. Toplam Beğeni",
            "avgDurationPlaceholder": "Min. Ortalama Yayın Süresi",
            "clearAll": "Filtreleri Temizle",
            "clearAllTitle": "Tüm filtreleri ve sıralamayı sıfırla",
            "addFilter": "Filtre ekle",
            "removeFilter": "Filtreyi kaldır",
            "clearOne": "Temizle",
            "noneApplied": "Tümü",
            "noFilterMatches": "Eşleşen filtre yok",
            "unassignedDescription": "Yöneticisi atanmamış içerik üreticisi adayları",
            "watchlisted": "İzleme Listesinde",
            "watchlistedDescription": "Sadece izleme listesindeki adaylar",
            "aiAnalyzed": "AI ile Analiz Edildi",
            "aiAnalyzedDescription": "AI analizinden geçmiş adaylar",
            "messaged": "Mesaj Atıldı",
            "messagedDescription": "Gönderim denenmiş adaylar (ulaşsın ya da ulaşmasın)",
            "activeCount": "{count} Filtre",
            "totalResults": "{count} sonuç",
            "commandHint": "İsim, nick, yönetici… veya 'lig:premier 10M+' yaz",
            "searchPlain": "Kullanıcı adı veya nick ara…",
            "group": {
                "creator": "Yayıncı",
                "performance": "Performans",
                "communication": "İletişim",
                "view": "Görünüm"
            },
            "sort": "Sıralama",
            "preset": {
                "invitable": "Davet Edilebilir"
            },
            "pastLiveCount": {
                "all": "Tüm Yayın Sayıları"
            },
            "totalLiveLikes": {
                "all": "Tüm Beğeni Aralıkları",
                "10k": "10 bin+",
                "100k": "100 bin+",
                "1m": "1 milyon+",
                "10m": "10 milyon+",
                "100m": "100 milyon+"
            },
            "avgDuration": {
                "all": "Tüm Süre Aralıkları",
                "30m": "30 dakika+",
                "1h": "1 saat+",
                "2h": "2 saat+",
                "4h": "4 saat+",
                "6h": "6 saat+"
            }
        },
        "sort": {
            "label": "Sıralama",
            "newest": "En Yeni Önce",
            "oldest": "En Eski Önce",
            "followerDesc": "Takipçi (Yüksek)",
            "rankAsc": "Lig Sırası (1→N)",
            "scoreDesc": "Skor (Yüksek)"
        },
        "action": {
            "assign": "Yönetici Ata",
            "unassign": "Atamayı Kaldır"
        },
        "table": {
            "username": "Kullanıcı",
            "reason": "Alt neden",
            "status": "Durum",
            "tier": "Davet Türü",
            "followers": "Takipçi",
            "likes": "Beğeni",
            "videos": "Video",
            "league": "Lig",
            "rank": "Sıra",
            "score": "Skor",
            "manager": "Yönetici",
            "messageStatus": "Mesaj Durumu",
            "pastLiveCount": "Canlı Yayın Sayısı",
            "totalLiveLikes": "Canlı Yayın Beğeni Sayısı",
            "avgDuration": "Ortalama Canlı Yayın Süresi",
            "fansClub": "Fan Club",
            "lastLive": "Son Canlı",
            "lastChecked": "Son Uygunluk Sorgulama Tarihi",
            "imported": "İçe Aktarıldı",
            "source": "Kaynak",
            "potential": "Potansiyel",
            "potentialTooltip": "Lig, uygunluk ve yayın aktivitesine göre hesaplanan gelir potansiyeli (0-100).",
            "watchlisted": "İzleme",
            "watchlistedTooltip": "İzleme listesine eklenmiş aday",
            "aiAnalyzed": "AI",
            "aiAnalyzedTooltip": "AI analizinden geçmiş aday",
            "messaged": "Mesaj",
            "messagedTooltip": "Gönderim denenmiş aday — sonuç için mesaj durumuna bak",
            "empty": "Kayıt bulunamadı."
        },
        "messageStatus": {
            "NOT_CONTACTED": "İletişime Geçilmedi",
            "QUEUED": "Sırada",
            "SENT": "Gönderildi",
            "REPLIED": "Yanıtladı",
            "CONVERTED": "Dönüştü",
            "OPTED_OUT": "Vazgeçti",
            "BOUNCED": "Ulaşmadı (tekrar dene)",
            "DM_CLOSED": "DM Kapalı",
            "UNREACHABLE": "Ulaşılamaz",
            "OWNED_BY_OTHER_MANAGER": "Başka Yöneticide"
        },
        "sendOutcome": {
            "SENT_REQUEST": "İstek gönderildi",
            "DELIVERED": "Ulaştı",
            "SENT": "Gönderildi",
            "BOUND_OTHER_AGENT": "Başka yöneticide",
            "BOUND_OTHER_AGENCY": "Başka ajansta",
            "BANNED": "Banlı",
            "NOT_QUALIFIED": "Yeterlilik yok",
            "NOT_ELIGIBLE": "Uygunluk yok",
            "GATE_UNVERIFIED": "Doğrulanamadı (tekrar dene)",
            "RECEIVER_CLOSED": "DM kapalı",
            "USER_NOT_FOUND": "Bulunamadı",
            "SEND_REJECTED": "Reddedildi",
            "ENGINE_ERROR": "Gönderim hatası"
        },
        "reason": {
            "AVAILABLE": "Davet edilebilir",
            "NOT_FOUND": "Bulunamadı",
            "REGION_MISMATCH": "Desteklenmeyen bölge",
            "INELIGIBLE": "Uygun değil",
            "NOT_ACCESS_LIVE": "Canlı yayın erişimi yok",
            "UNAVAILABLE": "Kullanılamıyor",
            "INVITATIONTYPE_NOT_AVAILABLE": "Davet türü kullanılamıyor",
            "QUOTA_LIMIT": "Davet kotası dolu",
            "UNKNOWN": "Belirtilmemiş",
            "FOLLOWERS_TOO_MUCH": "Takipçi sınırının üzerinde",
            "ALREADY_SIGNED": "Başka bir ajansta",
            "OTHER_REASONS": "Diğer nedenler",
            "DECLINED_BY_SUMA": "Çoklu hesap riski",
            "DECLINED_BY_LOCATION": "Desteklenmeyen bölge",
            "DECLINED_BY_CONTENT": "Uygunsuz içerik",
            "DECLINED_BY_HISTORY": "Geçmiş içerik yetersiz",
            "DECLINED_BY_BRIC": "Çoklu hesap riski",
            "IN_INVITE_PROCESS": "Davet süreci devam ediyor",
            "CONTENT_VIOLATION": "Yayın içeriği topluluk kurallarına aykırı",
            "IDENTITY_INELIGIBLE": "Kimlik şartlarını karşılamıyor",
            "LIVE_DATA_NOT_MEET_REQUIREMENT": "Yayın verisi davet şartlarını karşılamıyor",
            "JOIN_QUALIFICATION_FROZEN": "Katılım hakkı dondurulmuş",
            "ACCOUNT_PERFORMANCE_QUALIFY_FAILED": "Güvenlik standardını karşılamıyor"
        },
        "status": {
            "UNCHECKED": "Beklemede",
            "ELIGIBLE": "Davet edilebilir",
            "NEEDS_TRIAL": "Deneme yayını gerekli",
            "INVITED_PENDING": "Bekleyen davet",
            "IN_OTHER_AGENCY": "Başka ajansta",
            "INVITE_DISABLED": "Davet kapalı",
            "MULTI_ACCOUNT": "Çoklu hesap uyumsuz",
            "NOT_FOUND": "Bulunamadı",
            "OTHER": "Diğer",
            "ERROR": "Hata"
        },
        "tier": {
            "NORMAL": "Klasik",
            "ELITE": "Premium (eski)",
            "SUPER_ELITE": "Normal",
            "EXCLUSIVE": "Elit",
            "PREMIUM": "Yüksek takipçi",
            "CUSTOM": "Premium"
        },
        "pagination": {
            "summary": "{from}-{to} / {total} kayıt"
        },
        "toast": {
            "uploadOk": "{inserted} eklendi, {updated} güncellendi, {skipped} atlandı.",
            "uploadError": "Yükleme başarısız.",
            "loadError": "Liste yüklenemedi.",
            "notCsv": "Sadece .csv dosyası yükleyebilirsin.",
            "assignOk": "{'@'}{username} → {manager}",
            "unassignOk": "{'@'}{username} atamadan kaldırıldı.",
            "assignError": "Atama başarısız.",
            "messageStatusOk": "Mesaj durumu güncellendi: {status}"
        },
        "savedViews": {
            "add": "Görünüm",
            "addTitle": "Bu filtre kombinasyonunu kaydet",
            "savePromptName": "Görünüm adı:",
            "saved": "{name} görünümü kaydedildi.",
            "deleteConfirm": "{name} görünümü silinsin mi?",
            "unsaved": "Kaydedilmemiş değişiklikler"
        },
        "bulk": {
            "button": {
                "send": "Toplu Mesaj Gönder"
            },
            "drawer": {
                "title": "Seçili Adaylara Mesaj Gönder",
                "subtitle": "{count} yayıncı seçildi. Varsayılan metni kullan veya kişisel mesaj yaz."
            },
            "defaultText": {
                "label": "Varsayılan Mesaj",
                "placeholder": "Selam, nasılsınız",
                "hint": "Boş bırakılan satırlar bu metni alır."
            },
            "customText": {
                "placeholder": "Bu yayıncı için özelleştir (boş: \"{default}\")"
            },
            "noManager": "Atanmış yönetici yok — bu yayıncılar gönderim sırasında atlanacak",
            "noFlowMapping": "Bu yöneticinin TikTok hesap eşleştirmesi yok — gönderilmeyecek",
            "account": {
                "label": "Gönderen hesap",
                "hint": "Mesajlar seçtiğiniz TikTok hesabından gider; aday mesajı o hesaptan görür.",
                "default": "Varsayılan ajans hesabı",
                "needsLogin": "giriş gerekli",
                "notReady": "Bu hesabın oturumu henüz doğrulanmadı. İlk gönderimde giriş/doğrulama gerekebilir."
            },
            "gate": {
                "sendable": "{count} uygun — gönderilecek",
                "blocked": "{count} engellendi",
                "blockedHead": "{count} aday engellendi — uygunluk gönderim anında yeniden sorulur"
            },
            "send": {
                "button": "{count} kişiye gönder",
                "summary": "{valid} geçerli / {total} seçili",
                "startedToast": "Gönderim başlatıldı. {count} kişiye sıraya alındı, {skipped} atlandı. Sonuçlar aday durumuna yansıyacak.",
                "preCheckRunning": "Uygunluk kontrolü yapılıyor...",
                "removedLeads": "{count} kişi uygunluk durumu değiştiği için listeden çıkarıldı"
            },
            "eligibility": {
                "button": "Toplu Uygunluk Sorgula",
                "modal": {
                    "title": "Toplu Uygunluk Sorgulaması",
                    "checking": "Sorgulanıyor...",
                    "summary": "Toplam {total} kişi sorgulandı",
                    "eligible": "Uygun",
                    "ineligible": "Uygun Değil",
                    "changed": "{count} kişinin durumu değişti"
                }
            },
            "noSelection": "Önce en az bir yayıncı seç.",
            "selectedSuffix": "kayıt seçildi",
            "overLimit": "Bu işlem için en fazla {max} kayıt seçilebilir.",
            "clearSelection": "Seçimi Temizle",
            "cancelSelection": "Seçimi İptal Et",
            "selectPage": "Sayfayı Seç",
            "unselectPage": "Sayfa Seçimini Kaldır"
        },
        "messaging": {
            "title": "Adaylara Mesaj Gönder",
            "subtitle": "Seçtiğin TikTok hesabıyla adaylara toplu mesaj gönder — her mesaj öncesi uygunluk yeniden sorulur.",
            "soon": "Bu bölüm bir sonraki adımda gelecek.",
            "continue": "Devam et",
            "agent": {
                "roleOfficial": "Resmî",
                "roleManager": "Yönetici"
            },
            "allBlocked": "Seçtiğin adayların tümü yeniden gönderime kapalı (başka ajans / uygun değil / DM kapalı).",
            "someBlocked": "{blocked} aday yeniden gönderime kapalı, atlandı. {eligible} adaya devam ediliyor.",
            "template": {
                "label": "Mesaj şablonu",
                "none": "Şablon seç…",
                "new": "Yeni",
                "edit": "Şablonu düzenle",
                "delete": "Şablonu sil",
                "namePh": "Şablon adı (ör. Lexa Davet – Kısa)",
                "bodyPh": "Mesaj metni…",
                "required": "Şablon adı ve metni zorunlu.",
                "saved": "Şablon kaydedildi.",
                "deleted": "Şablon silindi."
            },
            "account": {
                "sender": "gönderen hesap",
                "change": "Değiştir",
                "lede": "Hangi hesapla mesaj göndereceksin?",
                "hint": "Mesajlar seçtiğin hesabın TikTok kimliğiyle gider; aday mesajı o hesaptan görür.",
                "defaultDesc": "Ajansın veri çekiminde kullandığı ana hesap",
                "ready": "Oturum hazır",
                "needsLogin": "Giriş gerekli",
                "newLogin": "Yeni hesapla giriş",
                "pickFirst": "Önce bir hesap seç.",
                "relogin": "Yeniden giriş",
                "emailPh": "ad{'@'}haymen.com.tr",
                "passwordPh": "TikTok şifresi",
                "loginBtn": "Giriş yap",
                "loggingIn": "Giriş yapılıyor…",
                "loginHint": "İlk girişte TikTok cihaz doğrulaması isteyebilir. Şifre şifreli saklanır, panelde gösterilmez.",
                "formRequired": "E-posta ve şifre gerekli.",
                "loginOk": "Giriş başarılı, hesap hazır.",
                "loginFail": "Giriş başarısız — bilgileri kontrol edip tekrar dene.",
                "pool": "Uygunluk havuzu",
                "poolHint": "Uygunluk kontrolleri (panel kontrolü ve mesaj gönderimindeki uygunluk kapısı) havuzdaki hesaplar arasında sırayla dağıtılır; risk kapısına takılan hesap bir süre dışarıda kalır. Hiçbiri işaretli değilse kontroller eskisi gibi varsayılan/gönderen hesaptan yapılır.",
                "poolOn": "Havuzda",
                "poolNeedsLogin": "Havuza girmesi için hesabın oturumu hazır olmalı.",
                "poolAdded": "Hesap uygunluk havuzuna alındı.",
                "poolRemoved": "Hesap uygunluk havuzundan çıkarıldı.",
                "twoFactor": {
                    "title": "İki adımlı doğrulama",
                    "pickLede": "TikTok bu hesap için doğrulama kodu istiyor. Kodun nereye gönderileceğini seç.",
                    "sms": "SMS ile kod",
                    "email": "E-posta ile kod",
                    "sending": "Kod gönderiliyor…",
                    "codeLede": "{target} adresine gönderilen kodu gir. Kod birkaç dakika geçerlidir.",
                    "codeLedeGeneric": "TikTok'un gönderdiği doğrulama kodunu gir.",
                    "codePh": "Doğrulama kodu",
                    "confirm": "Doğrula",
                    "verifying": "Doğrulanıyor…",
                    "resend": "Kod gelmedi mi? Başka yolla ya da yeniden gönder",
                    "codeRequired": "Gelen kodu gir."
                },
                "errors": {
                    "bad_credentials": "TikTok e-posta ya da şifreyi kabul etmedi (hesap bulunamadı veya şifre yanlış).",
                    "two_factor_code_rejected": "Kod kabul edilmedi. Kontrol edip tekrar dene.",
                    "two_factor_expired": "Doğrulama süresi doldu. Yeniden giriş yap.",
                    "two_factor_required": "TikTok doğrulama kodu istiyor. Panelden yeniden giriş yap.",
                    "login_cooldown": "Çok fazla başarısız deneme. Biraz sonra tekrar dene.",
                    "timeout": "TikTok zamanında yanıt vermedi. Tekrar dene."
                }
            },
            "step": {
                "account": "Hesap",
                "leads": "Adaylarım",
                "send": "Uygunluk ve gönderim",
                "inbox": "Gelen kutusu"
            },
            "leads": {
                "onlyMine": "Yalnız bana atananlar",
                "count": "{n} aday",
                "selectAll": "Tümünü seç",
                "clearAll": "Seçimi temizle",
                "selected": "{n} seçili",
                "next": "Uygunluk ve gönderim",
                "empty": "Mesaj atılabilir atanmış aday yok.",
                "colCandidate": "Aday",
                "colFollowers": "Takipçi",
                "colLives": "Yayın",
                "colPotential": "Potansiyel",
                "colEligibility": "Uygunluk",
                "colTier": "Kademe",
                "colMsgStatus": "Mesaj durumu",
                "total": "{n} aday",
                "search": "Aday ara (kullanıcı adı / takma ad)",
                "selectPage": "Sayfayı seç",
                "loadMore": "Daha fazla yükle"
            },
            "gate": {
                "warn": "Başka ajansa bağlı yayıncıya mesaj atmak ayartma ihlalidir. Uygunluk her aday için gönderim anında TikTok'a yeniden sorulur; doğrulanamayan da gönderilmez.",
                "selected": "Seçilen",
                "sendable": "Uygun — gönderilecek",
                "blocked": "Engellendi",
                "blockedHead": "{n} aday engellendi",
                "pace": "Mesajlar arası 4–8 sn bekleme uygulanır.",
                "progress": "{done}/{total} aday sorgulandı",
                "retry": "Tekrar dene",
                "notStarted": "Uygunluk sorgusu başlatılmadı.",
                "send": "{n} uygun adaya gönder"
            },
            "inbox": {
                "title": "Gelen kutusu",
                "sent": "Gönderim başladı. Yanıtlar buraya düşecek; şimdilik aday listesindeki durumdan takip edebilirsin.",
                "more": "Yeni gönderim",
                "refresh": "Yenile",
                "empty": "Henüz konuşma yok.",
                "noMessages": "Bu konuşmada mesaj yok.",
                "pick": "Soldan bir konuşma seç.",
                "replyPh": "Yanıt yaz…",
                "reply": "Gönder",
                "sending": "Gönderiliyor…",
                "replySent": "Yanıt gönderildi.",
                "replyBlocked": "Gönderilemedi: {reason}",
                "replyFail": "Yanıt gönderilemedi.",
                "loadFail": "Gelen kutusu yüklenemedi (oturum/okuma canlıda ayarlanacak).",
                "agentLede": "Hangi hesabın gelen kutusuna bakacaksın?",
                "pickAgentFirst": "Kutusu görüntülenecek hesabı seç."
            },
            "sender": { "title": "Hangi hesaptan gönderilsin?", "desc": "Mesajlar seçtiğin ajans hesabının kimliğiyle gider. Bir hesap seç, adayların uygunluğu seçimle birlikte sorgulanır.", "pickFirst": "Gönderen hesabı seçince adayların uygunluğu sorgulanır." }
        },
        "ai": {
            "button": {
                "analyze": "AI ile Analiz Et"
            },
            "modal": {
                "title": "AI Yayıncı Adayı Analizi",
                "analyzing": "Yapay zeka analizi yapıyor...",
                "summary": "Toplam {total} içerik üreticisi adayı analiz edildi",
                "remaining": "Bugün için kalan analiz hakkı: {count}",
                "remainingLabel": "Kalan Hak",
                "subtitleSetup": "Havuzdan en iyi adayları seçtir",
                "subtitleAnalyzing": "{count} aday AI ile değerlendiriliyor",
                "subtitleDone": "{count} en iyi aday seçildi",
                "leadsInflight": "{count} aday işleniyor",
                "empty": "Analiz sonucu bulunamadı."
            },
            "setup": {
                "title": "AI Aday Seçimi",
                "desc": "Sistemdeki en iyi potansiyele sahip adaylardan bir havuz oluşturup AI'a en iyilerini seçtirir.",
                "poolSize": "Havuz Boyutu",
                "poolHint": "AI'a gönderilecek aday sayısı. Büyük havuz = daha iyi seçim, daha yavaş/pahalı.",
                "topK": "Seçilecek Aday Sayısı",
                "topKHint": "AI havuzdan kaç adayı önersin.",
                "summary": "{pool} adaydan en iyi {top}'i seçilecek",
                "start": "Analizi Başlat",
                "topKTooLarge": "Seçilecek aday sayısı havuz boyutundan büyük olamaz."
            },
            "phase": {
                "gather": "Yayın ve etkileşim verileri toplanıyor",
                "cross": "Lig ve uygunluk verisi çapraz okunuyor",
                "score": "Potansiyel puan hesaplanıyor",
                "rank": "Sonuçlar derecelendiriliyor"
            },
            "history": {
                "title": "AI Yayıncı Adayı Analiz Geçmişi",
                "subtitle": "Daha önce yaptığın AI analizlerini görüntüle.",
                "empty": "Henüz AI analizi yapılmamış.",
                "col": {
                    "createdAt": "Başlangıç",
                    "initiatedBy": "Başlatan",
                    "totalLeads": "Yayıncı Adayı Sayısı",
                    "status": "Durum",
                    "finishedAt": "Bitiş",
                    "duration": "Süre"
                },
                "status": {
                    "QUEUED": "Sırada",
                    "RUNNING": "Çalışıyor",
                    "COMPLETED": "Tamamlandı",
                    "FAILED": "Başarısız"
                }
            },
            "tier": {
                "HIGH": "Yüksek Potansiyel",
                "MID": "Orta Potansiyel",
                "LOW": "Düşük Potansiyel"
            },
            "recommendation": {
                "INVITE_NOW": "Hemen Davet Et",
                "WATCH": "İzle",
                "SKIP": "Atla"
            }
        },
        "watchlist": {
            "button": {
                "add": "İzleme Listesine Ekle"
            },
            "added": "{count} aday izleme listesine eklendi.",
            "alreadyAll": "Seçilen tüm adaylar zaten izleme listesinde."
        },
        "outreachJobs": {
            "title": "Gönderimler",
            "subtitle": "Toplu mesaj gönderimlerini aday aday canlı izle — durum, alt neden ve zaman.",
            "live": "Canlı",
            "refresh": "Yenile",
            "empty": "Henüz gönderim yok. Adayları seçip \"Adaylara Mesaj Gönder\" ile başlat.",
            "pickOne": "Soldan bir gönderim seç.",
            "loadMore": "Daha fazla",
            "noItems": "Bu filtrede aday yok.",
            "startedBy": "{name} başlattı",
            "filter": {
                "all": "Tümü"
            },
            "tile": {
                "total": "Toplam",
                "pending": "Sırada",
                "sent": "Gönderildi",
                "blocked": "Engellendi",
                "failed": "Hata",
                "skipped": "Atlandı"
            },
            "jobStatus": {
                "PENDING": "Bekliyor",
                "RUNNING": "Gönderiliyor",
                "COMPLETED": "Tamamlandı",
                "PARTIAL": "Kısmen tamamlandı",
                "FAILED": "Başarısız",
                "INTERRUPTED": "Kesildi"
            },
            "itemStatus": {
                "PENDING": "Sırada",
                "SENT": "Gönderildi",
                "FAILED": "Hata",
                "BLOCKED_NOT_ELIGIBLE": "Engellendi",
                "SKIPPED_PRE": "Atlandı"
            },
            "reason": {
                "ineligible_state": "Zaten iletişimde (durum uygun değil)",
                "send_blocked": "Önceki gönderim engellendi (DM kapalı / ulaşılamaz)",
                "owned_by_other_manager": "Başka yöneticiye bağlı — yalnız sahibi hesap yazabilir",
                "lead_not_found": "Kayıt bulunamadı",
                "missing_text": "Mesaj metni boş",
                "no_result": "Gönderim servisi sonuç döndürmedi",
                "engine_error": "Otomasyon servisinde hata",
                "handler_error": "Otomasyon servisinde hata",
                "banned": "Hesap banlı",
                "no_invite_benefit": "Başka ajansa bağlı (davet hakkı yok)",
                "not_eligible": "Uygun değil",
                "not_found": "Uygunluk sorgusunda bulunamadı",
                "eligibility_error": "Uygunluk doğrulanamadı (ağ) — tekrar denenebilir",
                "eligibility_unverified": "Uygunluk doğrulanamadı (oturum) — tekrar denenebilir",
                "receiver_permission_off": "Alıcı DM'lerini kapatmış",
                "bound_to_another_manager": "Başka yöneticiye bağlı",
                "not_qualified": "Ajans yeterliliği yok",
                "user_not_found": "TikTok'ta kullanıcı bulunamadı",
                "not_delivered": "TikTok reddetti"
            }
        },
        "outreachJob": {
            "view": {
                "title": "Gönderim Geçmişi",
                "subtitle": "Toplu mesaj gönderimlerini ve sonuçlarını burada takip et."
            },
            "filter": {
                "mineOnly": "Sadece Benim Gönderimlerim"
            },
            "autoRefresh": {
                "on": "Yenileme Açık",
                "off": "Yenileme Kapalı",
                "active": "Aktif iş var, sayfa 5 sn'de bir yenileniyor",
                "idle": "Tüm işler tamamlandı, otomatik yenileme duraklatıldı"
            },
            "column": {
                "createdAt": "Başlangıç",
                "finishedAt": "Bitiş",
                "initiatedBy": "Başlatan",
                "total": "Toplam",
                "sent": "Gönderildi",
                "failed": "Başarısız",
                "skipped": "Atlandı",
                "status": "Durum"
            },
            "status": {
                "PENDING": "Bekliyor",
                "RUNNING": "Devam ediyor",
                "COMPLETED": "Tamamlandı",
                "PARTIAL": "Kısmen başarılı",
                "FAILED": "Başarısız",
                "INTERRUPTED": "Kesintiye uğradı"
            },
            "detail": {
                "title": "Gönderim Detayı",
                "itemsHeader": "Yayıncılar ({count})"
            },
            "item": {
                "status": {
                    "SENT": "Gönderildi",
                    "FAILED": "Başarısız",
                    "SKIPPED_PRE": "Atlandı",
                    "PENDING": "Bekliyor"
                },
                "reason": {
                    "no_manager": "Yönetici atanmamış",
                    "no_flow_mapping": "Yönetici TikTok eşleştirmesi yok",
                    "ineligible_state": "Yayıncı artık uygun değil",
                    "lead_not_found": "Kayıt bulunamadı",
                    "missing_text": "Mesaj metni boş",
                    "missing_handle": "Kullanıcı adı boş",
                    "engine_error": "Otomasyon servisinde hata",
                    "engine_timeout": "Otomasyon servisi yanıt vermedi",
                    "tiktok_silent_reject": "TikTok tarafından sessizce reddedildi",
                    "receiver_permission_off": "Alıcı mesaj alma iznini kapatmış",
                    "unknown_reject": "Reddedildi (sebep belirsiz)",
                    "bound_to_other_seat": "Başka bir yöneticiye bağlı",
                    "not_agency_eligible": "Ajans daveti için uygun değil",
                    "user_not_found": "TikTok'ta kullanıcı bulunamadı"
                }
            },
            "empty": "Henüz toplu gönderim yapılmadı."
        }
    },
    "filter": {
        "addFilter": "Filtre ekle",
        "removeFilter": "Filtreyi kaldır",
        "clearAll": "Filtreleri Temizle",
        "clearOne": "Temizle",
        "noneApplied": "Tümü",
        "noFilterMatches": "Eşleşen filtre yok",
        "searchPlaceholder": "Filtre ara…",
        "searchPlain": "Ara…",
        "sortLabel": "Sırala",
        "activeCount": "{count} Filtre",
        "totalResults": "{count} sonuç",
        "savedViews": {
            "all": "Tümü",
            "add": "Görünüm",
            "savePromptName": "Görünüm adı:",
            "saved": "{name} görünümü kaydedildi.",
            "deleteConfirm": "{name} görünümü silinsin mi?",
            "unsaved": "Kaydedilmemiş değişiklikler"
        }
    },
    "scrape": {
        "trigger": {
            "view": {
                "title": "Manuel Veri Çekme",
                "subtitle": "Belirli bir ay ve istenirse seçili kullanıcılar için TikTok verisini manuel olarak çekin."
            },
            "label": {
                "cycleMonth": "Dönem (Ay)",
                "cycleCurrent": "Mevcut Ay",
                "usernames": "Kullanıcı Adları",
                "userCount": "{n} kullanıcı",
                "allCreators": "Tüm aktif yayıncılar",
                "months": "Tarihsel Derinlik (Ay)",
                "backfillMonths": "Son {n} döngü (backfill)",
                "summary": "Tetiklenecek",
                "tail": "Tetikleyici arka planda çalışıyor. İlerleme için backend log'larını izleyebilirsiniz."
            },
            "hint": {
                "cycleMonth": "Boş bırakırsanız mevcut ay seçilir.",
                "usernames": "Boşluk, virgül veya yeni satırla ayırın. Boş bırakılırsa tüm aktif yayıncılar scrape edilir.",
                "months": "1 = normal çekim (mevcut döngü). N>1 = tek seferlik tarihsel backfill: yayıncı başına en yeni N settle döngüsü çekilir.",
                "monthsDisabled": "Belirli bir dönem seçiliyken tarihsel derinlik kullanılamaz."
            },
            "placeholder": {
                "usernames": "ozgenizresmii\nnurhoca11\ndemettiktok"
            },
            "action": {
                "run": "Scrape'i Başlat"
            },
            "toast": {
                "accepted": "Scrape başlatıldı: {id}",
                "acceptedTitle": "Tetiklendi",
                "failed": "Tetikleme başarısız"
            }
        }
    },
    "tournament": {
        "view": {
            "label": {
                "title": "Turnuva Yönetimi",
                "desc": "TikTok LIVE Kupası bracket'ları, fikstür ve tur sonuçlarını yönetin."
            }
        },
        "list": {
            "label": {
                "title": "Turnuvalar",
                "bracket": "Bracket"
            }
        },
        "detail": {
            "label": {
                "empty": "Soldan bir turnuva seçin",
                "startDate": "Başlangıç",
                "rounds": "tur",
                "participants": "katılımcı"
            }
        },
        "tab": {
            "bracket": "Bracket",
            "schedule": "Takvim",
            "fixture": "Fikstür",
            "participants": "Katılımcılar"
        },
        "status": {
            "notStarted": "Başlamadı",
            "inProgress": "Devam Ediyor",
            "completed": "Tamamlandı"
        },
        "matchStatus": {
            "scheduled": "Planlandı",
            "inProgress": "Devam Ediyor",
            "completed": "Tamamlandı",
            "forfeitA": "A Hükmen",
            "forfeitB": "B Hükmen",
            "doubleForfeit": "Çift Hükmen"
        },
        "round": {
            "round": "Tur {n}",
            "final": "FİNAL",
            "semifinal": "Yarı Final",
            "quarterfinal": "Çeyrek Final"
        },
        "bracket": {
            "label": {
                "tbd": "Beklemede"
            }
        },
        "fixture": {
            "filter": {
                "allRounds": "Tüm Turlar",
                "allStatus": "Tüm Durumlar"
            },
            "col": {
                "matchCode": "Maç Kodu",
                "round": "Tur",
                "date": "Tarih",
                "time": "Saat",
                "sideA": "Taraf A",
                "sideB": "Taraf B",
                "status": "Durum",
                "winner": "Kazanan",
                "actions": "İşlem"
            },
            "action": {
                "setResult": "Sonuç Gir",
                "edit": "Düzenle"
            }
        },
        "participants": {
            "col": {
                "rank": "Sıra",
                "tier": "Seviye",
                "username": "Kullanıcı",
                "name": "Görünen İsim",
                "manager": "Yönetici",
                "score": "Skor",
                "expected12d": "Beklenen Elmas (12g)",
                "actions": "İşlem"
            },
            "action": {
                "swap": "Yayıncıyı Değiştir"
            }
        },
        "schedule": {
            "title": "Schedule Parametreleri: {code}",
            "label": {
                "intro": "Aşağıdaki değerleri TikTok şablon ayarlarına birebir gir. Sistem bu parametrelere göre tüm tur tarihlerini otomatik hesaplar.",
                "startAt": "Turnuva Başlama Zamanı",
                "duration": "Tur Süresi",
                "interval": "Turlar Arası Aralık",
                "matches": "maç",
                "played": "oynandı",
                "preview": "Tur Önizlemesi"
            },
            "hint": {
                "startAt": "TikTok'taki 'Turnuva başlama zamanı' ile aynı olmalı (Europe/Istanbul).",
                "duration": "TikTok'taki 'Her tur kaç dakika' alanı.",
                "interval": "TikTok'taki 'Turlar arası aralık' (gün/saat/dakika)."
            },
            "unit": {
                "days": "gün",
                "hours": "saat",
                "minutes": "dakika"
            },
            "action": {
                "edit": "Düzenle",
                "save": "Parametreleri Kaydet"
            },
            "toast": {
                "saved": "Parametreler güncellendi, tur takvimi yeniden hesaplandı",
                "saveError": "Parametreler kaydedilemedi",
                "invalidDuration": "Tur süresi en az 1 dakika olmalı"
            }
        },
        "pairing": {
            "title": "Eşleşmeyi Değiştir: {code}",
            "label": {
                "intro": "Bu maçtaki bir tarafı, aynı bracket'taki başka bir yayıncı ile yer değiştirir. İki maç da güncellenir, yayıncı sayısı değişmez.",
                "currentMatch": "Bu Maç",
                "swapWith": "Şununla Yer Değiştir",
                "opponent": "Rakip",
                "noCandidates": "Aynı bracket'ta uygun aday yok",
                "preview": "Önizleme"
            },
            "placeholder": {
                "search": "Kullanıcı adı veya isim ile ara..."
            },
            "hint": {
                "pickSide": "Hangi tarafı değiştirmek istiyorsun?",
                "search": "{n} aday yayıncı"
            },
            "action": {
                "openTitle": "Bu maçtaki eşleşmeyi değiştir",
                "confirm": "Yer Değiştir"
            },
            "toast": {
                "selectTarget": "Yer değiştirilecek yayıncıyı seç",
                "swapped": "Eşleşmeler güncellendi",
                "swapError": "Yer değiştirme başarısız"
            }
        },
        "swap": {
            "title": "Yayıncıyı Değiştir",
            "label": {
                "current": "Mevcut Yayıncı",
                "searchReplacement": "Yerine Geçecek Yayıncıyı Ara",
                "noResults": "Sonuç bulunamadı",
                "sameAsCurrent": "Mevcut yayıncı"
            },
            "placeholder": {
                "search": "Kullanıcı adı veya isim..."
            },
            "hint": {
                "search": "En az 2 karakter girin. Sadece CREATORS rolündeki kullanıcılar listelenir."
            },
            "warning": "Sadece daha oynanmamış maçlardaki rakipleri güncellenir. Tamamlanmış maçlar değişmez.",
            "action": {
                "confirm": "Değiştir"
            },
            "toast": {
                "selectUser": "Lütfen bir yayıncı seçin",
                "swapped": "Yayıncı değiştirildi, ilgili maçlar güncellendi",
                "swapError": "Değiştirme başarısız"
            }
        },
        "cascade": {
            "title": "Yayıncıyı Sistemden Çıkart + Cascade Promote",
            "mode": {
                "auto": "Otomatik",
                "manual": "Manuel Seç"
            },
            "label": {
                "intro": "Bu yayıncı tüm turnuvalardan çıkarılır, yerine seçtiğin yayıncı geçer. Eğer yeni yayıncı zaten başka turnuvalarda ise, o boşlukları otomatik en yüksek skorlu YEDEK yayıncılar doldurur.",
                "introAuto": "Bu yayıncı tüm turnuvalardan çıkarılır. Her boşalan slot'a sistem otomatik olarak yedek havuzdan en yüksek skorlu yayıncıyı atar. Sen seçim yapmazsın.",
                "introManual": "Bu yayıncı tüm turnuvalardan çıkarılır, yerine senin seçtiğin yayıncı geçer. Eğer yeni yayıncı zaten başka turnuvalarda ise, o boşlukları otomatik en yüksek skorlu YEDEK yayıncılar doldurur.",
                "previewAuto": "Otomatik mod: {count} slot için sistem yedek havuzdan otomatik atama yapacak.",
                "outgoing": "Sistemden Çıkacak Yayıncı",
                "searchIncoming": "Yerine Geçecek Yayıncıyı Ara",
                "tournamentCount": "turnuvada",
                "previewWarning": "Bu işlem {count} slotta değişiklik yapacak. Tamamlanmış maçlar değişmez.",
                "completed": "Cascade tamamlandı: {total} adım, {slots} slot etkilendi.",
                "vacantSlot": "BOŞ (yedek havuzu tükendi)"
            },
            "placeholder": {
                "search": "Kullanıcı adı veya isim..."
            },
            "hint": {
                "search": "En az 2 karakter girin."
            },
            "action": {
                "openTitle": "Yayıncıyı çıkart + cascade promote",
                "execute": "İşlemi Uygula",
                "replace": "Değiştir",
                "promote": "Cascade",
                "vacant": "Boş"
            },
            "toast": {
                "selectUser": "Yerine geçecek yayıncıyı seç",
                "done": "Cascade tamamlandı ({steps} adım)",
                "error": "Cascade işlemi başarısız"
            }
        },
        "allParticipants": {
            "view": {
                "label": {
                    "title": "Tüm Katılımcılar",
                    "desc": "Tüm turnuvalardaki yayıncılar (unique). Bir yayıncı birden fazla turnuvada olabilir."
                }
            },
            "label": {
                "allTiers": "Tüm Seviyeler",
                "uniqueBroadcasters": "Unique Yayıncı",
                "multiTournament": "Çoklu Turnuvada",
                "totalEnrollments": "Toplam Kayıt",
                "empty": "Filtrelere uygun katılımcı yok."
            },
            "placeholder": {
                "search": "Kullanıcı adı, isim veya yönetici ile ara..."
            },
            "col": {
                "tournaments": "Turnuvalar",
                "tournamentCount": "Sayı"
            },
            "toast": {
                "loadError": "Katılımcı listesi yüklenemedi"
            }
        },
        "managerSchedule": {
            "view": {
                "label": {
                    "title": "Maç Takvimim",
                    "desc": "Yöneticisi olduğunuz yayıncıların tüm turnuva maçları, gün gün."
                }
            },
            "label": {
                "manager": "Yönetici E-posta",
                "totalMatches": "Toplam Maç",
                "broadcasters": "Yayıncı Sayısı",
                "activeDays": "Aktif Gün",
                "matchesShort": "maç",
                "empty": "Bu yöneticiye bağlı yayıncıların turnuva maçı yok.",
                "enterEmail": "Bir yönetici e-postası girin.",
                "allManagers": "Tüm Yöneticiler",
                "vs": "VS"
            },
            "placeholder": {
                "manager": "manager@haymen.com.tr",
                "adminFilter": "Tüm yöneticiler (filtrelemek için e-posta girin)"
            },
            "toast": {
                "loadError": "Takvim yüklenemedi"
            }
        },
        "result": {
            "title": "Maç Sonucu: {code}",
            "label": {
                "sideA": "Taraf A",
                "sideB": "Taraf B",
                "status": "Durum",
                "winner": "Kazanan",
                "sideADiamonds": "A Elması",
                "sideBDiamonds": "B Elması"
            },
            "hint": {
                "forfeitA": "A yayın açmadı → B otomatik üst tura yükselir",
                "forfeitB": "B yayın açmadı → A otomatik üst tura yükselir",
                "doubleForfeit": "İki taraf da yayın açmadı → her ikisi de elenir"
            },
            "action": {
                "save": "Sonucu Kaydet"
            },
            "toast": {
                "winnerRequired": "Kazanan seçilmelidir",
                "saved": "Sonuç kaydedildi ve sonraki tura otomatik aktarıldı",
                "saveError": "Sonuç kaydedilemedi"
            }
        },
        "toast": {
            "loadError": "Turnuva verisi yüklenemedi"
        }
    },
    "guides": {
        "title": "Rehber Videoları",
        "hint": "Uygulama içi \"Nasıl kullanılır\" listesi. Sıra sürüklenerek değişir; yerleşim bir videonun listeye ek olarak ilk açılışta mı yoksa belirli bir ekranın \"?\" düğmesinde mi göründüğünü belirler.",
        "new": "Video ekle",
        "edit": "Düzenle",
        "empty": "Henüz rehber videosu yok. İlk videoyu yükleyerek başla.",
        "draftNote": "Taslak",
        "stats": "Son 7 gün: {views} izleme · {'%'}{rate} tamamlanma",
        "rowStats": "{views} izleyen · {completed} tamamlayan",
        "chips": {
            "all": "Tümü",
            "published": "Yayında",
            "draft": "Taslak",
            "creators": "Yayıncı",
            "managers": "Yönetici"
        },
        "columns": {
            "cover": "Kapak",
            "video": "Video",
            "placement": "Yerleşim",
            "target": "Hedef",
            "published": "Yayın"
        },
        "placement": {
            "list": "Rehber",
            "onboarding": "İlk açılış",
            "screen": "Ekran: {screen}",
            "listLong": "Rehber listesi",
            "onboardingLong": "İlk açılış",
            "screenLong": "Ekran içi yardım",
            "hint": "Birden fazla seçilebilir. \"İlk açılış\" tek bir videoda açık olabilir; seçersen mevcut olandan alınır."
        },
        "roles": {
            "CREATORS": "Yayıncı",
            "MANAGER": "Yönetici"
        },
        "screens": {
            "create_request": "Talep oluştur",
            "task_progress": "Görev ilerlemesi",
            "wallet": "Cüzdan",
            "violations": "İhlaller",
            "equipment": "Ekipman talebi",
            "profile": "Profil",
            "inbox": "Gelen kutusu",
            "home": "Ana sayfa",
            "search": "Arama (yönetici)"
        },
        "drawer": {
            "newTitle": "Video ekle",
            "subtitle": "Rehber Videoları",
            "file": "Video dosyası",
            "fileHint": "MP4 (H.264), dikey ya da yatay. Önerilen üst sınır 100 MB; süre ve kapak otomatik okunur.",
            "noFile": "Henüz video seçilmedi.",
            "pick": "Video seç",
            "replace": "Videoyu değiştir",
            "cover": "Kapak yükle",
            "uploading": "Yükleniyor…",
            "uploaded": "Yüklendi · kapak 2. saniyeden alındı; dilersen değiştir.",
            "titleTr": "Başlık · TR",
            "titleEn": "Başlık · EN",
            "descTr": "Açıklama · TR",
            "descEn": "Açıklama · EN",
            "placement": "Yerleşim",
            "screen": "Bağlı ekran",
            "screenPick": "Ekran seç",
            "screenHint": "Seçilen ekranın sağ üst \"?\" düğmesi bu videoyu açar. Her ekrana tek video bağlanır.",
            "target": "Hedef",
            "published": "Yayında",
            "delete": "Videoyu sil",
            "deleteConfirm": "Silmeyi onayla"
        },
        "toast": {
            "loadError": "Rehber videoları yüklenemedi",
            "saved": "Video kaydedildi",
            "saveError": "Video kaydedilemedi",
            "deleted": "Video silindi",
            "uploadError": "Dosya yüklenemedi",
            "hevc": "Bu video HEVC (H.265). iPhone oynatır ama bazı Android cihazlar oynatmaz; mümkünse H.264 olarak dışa aktarıp yeniden yükleyin.",
            "faststart": "Video mobil oynatma için yeniden düzenlendi (moov öne alındı).",
            "videoType": "Yalnız MP4 dosyası yüklenebilir"
        }
    },
    "site": {
        "view": {
            "label": {
                "title": "Web Sitesi",
                "description": "Ajans web sitesindeki yayıncı vitrinini yönetin"
            }
        },
        "creators": {
            "title": "Yayıncı vitrini",
            "hint": "Burada gördüğün yayıncılar sitenin Yayıncılar sayfasında yayında. Kategori yayın kategorisinden, takipçi sayısı günlük senkrondan gelir; görseli hazır olmayan yayıncı sitede çıkmaz.",
            "search": "Vitrinde ara",
            "all": "Tümü",
            "pendingOnly": "Görseli bekleyenler",
            "column": {
                "creator": "Yayıncı",
                "category": "Kategori",
                "followers": "Takipçi",
                "sort": "Sıra"
            },
            "stat": {
                "published": "Yayında",
                "ready": "Görseli hazır",
                "pending": "Görsel bekliyor · saatte 60",
                "hidden": "Gizli (anahtarı kapalı)",
                "noCategory": "Kategorisi yok · filtreye girmez",
                "synced": "Son takipçi senkronu"
            },
            "noCategory": "Kategori yok",
            "noCategoryShort": "Kategori yok",
            "hiddenTag": "Gizli",
            "avatarReady": "Görsel hazır",
            "avatarPending": "Görsel bekleniyor",
            "avatarQueued": "kuyruğa alındı",
            "avatarNextRun": "saatlik turda alınır",
            "dragHint": "Sıralamak için sürükle",
            "orderNote": "Sıra: numaralı kartlar önce, kalanlar takipçiye göre. Kartı sürükleyip bırakınca sıra numarası alır. Anahtarı kapalı kartlar sitede görünmez, bilgileri durur.",
            "order": { "label": "Sitedeki sıralama", "followers": "Takipçi sayısına göre", "manual": "Elle sıralama", "noteFollowers": "Sıra: takipçisi en çok olan önce. Takipçi sayıları TikTok'tan otomatik güncellenir. Anahtarı kapalı kartlar sitede görünmez, bilgileri durur.", "toastFollowers": "Site artık yayıncıları takipçi sayısına göre listeliyor", "toastManual": "Site artık elle verdiğiniz sırayı kullanıyor" },
            "empty": "Vitrinde henüz yayıncı yok. Ajans yayıncıları arasından ekle.",
            "emptyFiltered": "Bu filtreye uyan yayıncı yok",
            "action": {
                "add": "Yayıncı ekle",
                "openSite": "Sitede gör",
                "edit": "Düzenle",
                "show": "Sitede göster",
                "hide": "Siteden gizle",
                "refreshAvatar": "TikTok'tan yenile",
                "uploadAvatar": "Kendi görselini yükle"
            },
            "add": {
                "title": "Yayıncı ekle",
                "hint": "Ajans yayıncıları arasından seç. Eklenen yayıncının büyük görseli otomatik alınır; görsel hazır olana kadar sitede görünmez.",
                "search": "Kullanıcı adı veya görünen ad",
                "empty": "Eşleşen aday yok",
                "endingSoon": "Sözleşme {date} tarihinde bitiyor",
                "selected": "seçildi",
                "orderLater": "· sıralarını sonra kartlardan verirsin",
                "submit": "Vitrine ekle ({n})"
            },
            "edit": {
                "published": "Sitede yayında",
                "publishedHint": "Kapatınca kart sitede anında kaybolur, bilgiler durur.",
                "sortPlaceholder": "Boş = takipçiye göre",
                "sortError": "0 ile 9999 arası bir tam sayı",
                "displayName": "Görünen ad",
                "categoryHint": "Kategori: {category} — yayın kategorisinden gelir, yayıncı profilinden değiştirilir.",
                "extraTitle": "Ek bilgiler (sitede kart açılınca)",
                "bioTr": "Kısa tanıtım · TR",
                "bioEn": "Kısa tanıtım · EN",
                "bioEnPlaceholder": "Boş bırakılırsa sitede Türkçe metin gösterilir",
                "tags": "Etiketler",
                "tagPlaceholder": "+ etiket, Enter",
                "previewHint": "Sitedeki kartın önizlemesi. Görsel profil sayfasından alınan 1080×1080 kopyadır.",
                "customAvatar": "panelden yüklendi",
                "avatarPolling": "Görsel hazırlanıyor, hazır olunca burada ve listede otomatik görünecek…",
                "remove": "Vitrinden kaldır",
                "removeConfirm": "Emin misin? Kart bilgisi ve görsel silinir"
            },
            "toast": {
                "loadError": "Yayıncı listesi yüklenemedi",
                "updated": "{'@'}{username} güncellendi",
                "shown": "{'@'}{username} sitede yayında",
                "hidden": "{'@'}{username} siteden gizlendi",
                "reordered": "Sıra kaydedildi",
                "added": "{n} yayıncı vitrine eklendi; görselleri geliyor",
                "removed": "{'@'}{username} vitrinden kaldırıldı",
                "updateError": "Güncelleme başarısız",
                "avatarQueued": "{'@'}{username} için görsel işi kuyruğa alındı; birkaç dakika içinde hazır olur",
                "avatarReady": "{'@'}{username} görseli hazır; liste güncellendi",
                "avatarQueueError": "Görsel işi kuyruğa alınamadı",
                "avatarUploaded": "Görsel yüklendi",
                "avatarUploadError": "Görsel yüklenemedi (yalnız resim, en fazla 10 MB)"
            }
        },
        "content": {
            "title": "İçerikler",
            "hint": "Sitedeki ekip, ödül, akademi ve SSS içerikleri. Sıra sürükleyerek; anahtarı kapalı kayıt sitede görünmez, bilgisi durur. Site 5 dakika içinde günceller.",
            "tabs": { "team": "Ekip", "awards": "Ödüller", "courses": "Akademi", "faq": "SSS" },
            "published": "Sitede yayında",
            "hiddenTag": "gizli",
            "editing": "Düzenleniyor…",
            "empty": "Henüz kayıt yok.",
            "dragHint": "Sıralamak için sürükle",
            "plainText": "Düz metin; satır sonları korunur, bağlantı ve biçimlendirme yok.",
            "enPlaceholder": "Boş bırakılırsa sitede Türkçe metin gösterilir",
            "delete": "Sil",
            "deleteConfirm": "Emin misin? Geri alınamaz",
            "image": { "empty": "Görsel yok", "upload": "Görsel yükle", "replace": "Görseli değiştir", "remove": "Kaldır", "uploading": "Yükleniyor…" },
            "team": {
                "label": "Ekip üyesi", "new": "Üye ekle", "name": "Ad Soyad", "role": "Unvan",
                "imageHint": "4:5 oran, en az 800×1000. MinIO'ya yüklenir, site herkese açık uçtan çeker.",
                "certificates": "Sertifikalar", "certTitle": "Sertifika başlığı", "certMeta": "Alt bilgi (kurum · yer · tarih)",
                "certDescription": "Açıklama", "certAdd": "+ Sertifika ekle", "certRemove": "Sertifikayı kaldır", "certCount": "{n} sertifika",
                "group": "Ekip grubu", "groupHint": "Sitede ekip organizasyon şemasındaki bölüm.", "founder": "Kurucu", "founderHint": "Kurucu, yönetim bölümünün üstünde ayrı satırda gösterilir.",
                "groups": { "management": "Yönetim", "creators": "Yayıncı Yöneticileri", "events": "Etkinlik Yöneticileri", "social": "Sosyal Medya" }
            },
            "awards": {
                "label": "Ödül", "new": "Ödül ekle", "year": "Yıl", "yearHint": "Boş = Tarihsiz grubu (sitede en sonda)", "undated": "Tarihsiz",
                "imageHint": "Kare görsel, en az 800×800.", "title": "Başlık", "meta": "Alt bilgi", "description": "Açıklama", "count": "{n} ödül"
            },
            "courses": { "new": "Ders ekle", "title": "Başlık", "text": "Metin" },
            "faq": { "new": "Soru ekle", "question": "Soru", "answer": "Cevap" },
            "toast": { "loadError": "İçerik yüklenemedi", "saved": "Kaydedildi", "saveError": "Kaydedilemedi", "deleted": "Silindi", "uploadError": "Görsel yüklenemedi (yalnız resim)" }
        },
        "settings": {
            "title": "Site Ayarları",
            "hint": "Başvuru durumu, üst şerit, iletişim, sosyal medya, sayaçlar ve videolar. Tek düğmeyle kaydedilir; site 5 dakika içinde günceller.",
            "save": "Kaydet ve yayınla",
            "unsaved": "Kaydedilmemiş değişiklik var",
            "publishNote": "Kaydet ve yayınla: site en geç 5 dakika içinde yeni ayarları gösterir.",
            "sections": { "applications": "Başvuru", "ticker": "Üst şerit", "contact": "İletişim", "social": "Sosyal medya", "stats": "Ana sayfa sayaçları", "videos": "Videolar", "links": "Bağlantılar" },
            "applications": { "open": "Başvurular açık", "hint": "Kapatınca üst şeritte \"Başvurular kapalı\" yazar, başvuru formu yerine mesaj gösterilir.", "closedMessage": "Kapalıyken mesaj" },
            "ticker": { "hint": "Başvuru durumundan sonra akan maddeler.", "add": "+ Madde ekle" },
            "contact": { "phoneDisplay": "Telefon (görünen)", "phoneHref": "Telefon (aranacak, tel:)", "email": "E-posta", "address": "Adres", "directions": "Yol tarifi bağlantısı", "whatsappDisplay": "WhatsApp (görünen numara)", "whatsappHref": "WhatsApp bağlantısı (wa.me)", "workingHours": "Çalışma saatleri", "whatsappHint": "WhatsApp boş bırakılırsa sitedeki WhatsApp kartı ve başvuru sonrası WhatsApp yönlendirmesi görünmez." },
            "social": { "hint": "Boş bırakılan hesap sitede görünmez.", "youtubeVideos": "YouTube videolar sayfası" },
            "stats": { "hint": "Ana sayfadaki dört sayaç. \"Canlı\" işaretli sayaç TAP'taki yönetilen yayıncı sayısından üretilir (1.388 → 1.300+).", "value": "Değer", "live": "Canlı", "liveValue": "TAP'tan", "liveHint": "Değer TAP'taki aktif yayıncı sayısından otomatik gelir", "add": "+ Sayaç ekle" },
            "videos": { "hint": "Biz Kimiz sayfasındaki YouTube slotları; boşsa kanala giden yer tutucu gösterilir.", "about": "Hakkımızda", "mission": "Misyon", "vision": "Vizyon" },
            "links": { "panel": "Panel (Backstage) adresi", "appStore": "App Store bağlantısı" },
            "toast": { "loadError": "Ayarlar yüklenemedi", "saved": "Ayarlar kaydedildi; site birkaç dakika içinde güncellenir", "saveError": "Ayarlar kaydedilemedi" }
        }
    },
    "siteApplications": {
        "title": "Site Başvuruları",
        "hint": "haymenagency.com başvuru ve iletişim formundan gelen kayıtlar. Yeni gelen 'Yeni' durumunda; arayınca 'Arandı', sonucuna göre 'Kabul' ya da 'Ret'. Satıra tıklayınca mesaj ve not açılır.",
        "all": "Tümü",
        "search": "Ad, e-posta, telefon veya TikTok ara",
        "empty": "Bu filtrede başvuru yok.",
        "column": { "date": "Tarih", "applicant": "Başvuran", "category": "Kategori", "accounts": "Hesap", "status": "Durum", "type": "Tür" },
        "status": { "NEW": "Yeni", "CONTACTED": "Arandı", "ACCEPTED": "Kabul", "REJECTED": "Ret" },
        "type": { "APPLICATION": "Başvuru", "CONTACT": "İletişim" },
        "action": { "contacted": "Arandı", "accept": "Kabul", "reject": "Ret" },
        "detail": { "message": "Mesaj", "previousAgency": "Önceki ajans", "followers": "Takipçi aralığı", "mailed": "E-posta", "mailedYes": "gönderildi", "mailedNo": "gönderilmedi (alıcı tanımsız)", "handled": "Son işlem", "note": "Not (ekip içi)" },
        "toast": { "loadError": "Başvurular yüklenemedi", "updated": "Güncellendi", "updateError": "Güncellenemedi" }
    },
    "wallet": { "requestWithdrawal": "Para çekme talebi oluştur" },
    "partners": {
        "nav": {
            "find": "Yayıncı bul",
            "creators": "Yayıncılarım",
            "earnings": "Kazancım",
            "admin": "İş ortakları"
        },
        "off": {
            "title": "Bu bölüm bu ajansta kapalı",
            "body": "İş ortağı ekranları bu ajansta şu an kullanılamıyor. Bir şey yanlış görünüyorsa ajans yöneticinle konuş."
        },
        "unit": {
            "DIAMOND": "Elmas",
            "USD": "Dolar"
        },
        "status": {
            "INVITED": "Davet gönderildi",
            "ACTIVE": "Aktif",
            "SUSPENDED": "Askıda"
        },
        "payout": {
            "INVOICE": "Fatura ile",
            "WALLET": "Uygulama cüzdanına"
        },
        "task": {
            "ACTIVENESS": "Aktiflik",
            "RANK_UP": "Seviye yükseltme",
            "INCREMENTAL_REVENUE": "Kademeli artan gelir",
            "REGIONAL": "Bölgesel geçerli yayın",
            "COMMISSION": "Bölgesel / komisyon görevi",
            "OTHER": "Diğer görevler",
            "ROOKIE_MILESTONE": "Çaylak hedefi"
        },
        "taskHint": {
            "ACTIVENESS": "Aşamalı görev, yayıncı bazında",
            "RANK_UP": "Yükselme ve koruma, yayıncı bazında",
            "INCREMENTAL_REVENUE": "TikTok her yayıncı için ajansa ayrı ödüyor",
            "REGIONAL": "Kohort bazında",
            "ROOKIE_MILESTONE": "Yeni yayıncı hedefi"
        },
        "find": {
            "title": "Yayıncı bul",
            "desc": "TikTok kullanıcı adını yaz, sorgula. Uygunsa referans ver.",
            "username": "TikTok kullanıcı adı",
            "placeholder": "kullanici.adi",
            "check": "Sorgula",
            "checking": "Sorgulanıyor…",
            "hint": "Sorgu TikTok'a gider, birkaç saniye sürebilir.",
            "refer": "Referans ver",
            "phoneLabel": "Adayın telefonu (isteğe bağlı)",
            "phoneHint": "Girersen ajans {name} ile bu numaradan iletişime geçebilir. Boş bırakabilirsin; referansın yine onaya gider.",
            "referNote": "Referans verdiğinde ajansın onayına gider. Onaylanınca {name} senin adına kaydedilir; ajansa katıldığı aydan itibaren payın başlar.",
            "referred": "{name} için referansın ajansın onayına gönderildi.",
            "referError": "Referans verilemedi. Biraz sonra tekrar dene.",
            "checkError": "Sorgu yapılamadı. Biraz sonra tekrar dene.",
            "inviteType": "Davet türü",
            "state": "Durum",
            "checkedAt": "Sorgulandı",
            "recent": "Son sorguların",
            "recentEmpty": "Henüz sorgu yapmadın.",
            "recheck": "Tekrar sorgula",
            "alreadyReferred": "Referans verildi",
            "col": {
                "nickname": "Takma ad",
                "username": "Kullanıcı adı",
                "result": "Sonuç",
                "time": "Zaman"
            },
            "status": {
                "ELIGIBLE": "Uygun",
                "NEEDS_TRIAL": "Deneme gerekiyor",
                "INVITED_PENDING": "Davet bekliyor",
                "IN_OTHER_AGENCY": "Başka ajansta",
                "INVITE_DISABLED": "Davet kapalı",
                "MULTI_ACCOUNT": "Birden çok hesap",
                "NOT_FOUND": "Bulunamadı",
                "OTHER": "Referans verilemez",
                "IN_OUR_AGENCY": "Zaten ajansımızda",
                "ALREADY_REFERRED": "Başkası referans vermiş",
                "AWAITING_APPROVAL": "Onay bekliyor",
                "ALREADY_REFERRED_BY_YOU": "Sen referans vermişsin",
                "ALREADY_REFERRED_PENDING": "Referans bekliyor"
            }
        },
        "creators": {
            "title": "Yayıncılarım",
            "desc": "Referans verdiğin yayıncılar ve her birinden bu ay alacağın pay.",
            "tab": {
                "AWAITING_APPROVAL": "Onay bekliyor",
                "REJECTED": "Reddedildi",
                "ALL": "Tümü",
                "ACTIVE": "Ajansta",
                "PENDING": "Bekliyor",
                "EXPIRED": "Pay bitti"
            },
            "status": {
                "AWAITING_APPROVAL": "Onay bekliyor",
                "REJECTED": "Reddedildi",
                "ACTIVE": "Ajansta",
                "PENDING": "Bekliyor",
                "EXPIRED": "Pay bitti"
            },
            "stat": {
                "active": "Ajansta",
                "activeSub": "Payı süren yayıncı",
                "pending": "Bekliyor",
                "pendingSub": "Henüz ajansa girmedi",
                "expired": "Pay bitti",
                "expiredSub": "{n} ay doldu",
                "expiredSubNoPlan": "Pay süresi doldu",
                "month": "Bu ay payım",
                "monthSub": "Tahmini, ay sürüyor"
            },
            "search": "Yayıncı ara",
            "col": {
                "creator": "Yayıncı",
                "status": "Durum",
                "referred": "Referans",
                "phone": "Adayın telefonu",
                "joined": "Katılış",
                "window": "Pay süresi",
                "diamonds": "Bu ay elmas",
                "amount": "Bu ay payım"
            },
            "waiting": "Ajansa girmesi bekleniyor",
            "awaiting": "Ajansın onayı bekleniyor",
            "rejected": "Ajans reddetti",
            "window": "{n} / {total} ay",
            "windowOpen": "{n}. ay",
            "empty": "Bu listede yayıncı yok.",
            "foot": "Referansın önce ajansın onayına gider; onaylanınca Bekliyor olur, yayıncı ajansa katılınca Ajansta. Pay, katıldığı aydan başlar ve planındaki süre kadar sürer. Ay bitmeden gösterilen tutarlar tahminidir. Reddedilen yayıncıya tekrar referans verebilirsin."
        },
        "earnings": {
            "title": "Kazancım",
            "desc": "Ay ay payın, ödemelerin ve cüzdanın.",
            "walletTx": "Cüzdan hareketleri",
            "plan": "Pay planın",
            "duration": "Süre",
            "durationMonths": "Her yayıncı için {n} ay",
            "cap": "Yayıncı başına aylık üst sınır",
            "payout": "Ödeme",
            "note": "Not",
            "totalLabel": "Toplam",
            "months": "Aylar",
            "empty": "Henüz kazanç oluşmadı.",
            "pick": "Soldan bir ay seç.",
            "status": {
                "PROJECTED": "Tahmini",
                "CONFIRMED": "Onaylandı",
                "PAID": "Ödendi"
            },
            "noteProjected": "Ay sürüyor, değişebilir",
            "noteConfirmed": "Ödeme bekliyor",
            "invoice": "Fatura {no}",
            "detailTitle": "{month} dökümü",
            "detailSub": "{n} yayıncı · toplam",
            "more": "+ {n} yayıncı daha",
            "col": {
                "yours": "Payın"
            },
            "foot": "Ay kapanıp TikTok ödemesi kesinleşince tutar Onaylandı olur; geçmiş aylar sonradan değişmez."
        },
        "admin": {
            "title": "İş ortakları",
            "desc": "Ajansa yayıncı getiren kişi ve firmalar.",
            "tabPartners": "İş ortakları",
            "tabPlans": "Pay planları",
            "tabAwaiting": "Onay bekleyenler",
            "awaiting": {
                "title": "Onay bekleyen referanslar",
                "desc": "İş ortaklarının verdiği referanslar onaylanmadan sayılmaz. Onayladığında yayıncı iş ortağının listesine \"Bekliyor\" olarak geçer; ajansa katıldığı aydan payı başlar.",
                "foot": "Onayla'ya bastığında yayıncıya bu arada başka bir referans verilip verilmediği yeniden kontrol edilir. Ajansa davet her zamanki gibi ayrıca gönderilir.",
                "empty": "Onay bekleyen referans yok.",
                "col": { "creator": "Yayıncı", "partner": "Referans veren", "result": "Sorgu sonucu", "phone": "Adayın telefonu", "date": "Tarih" },
                "partnerTag": "İş ortağı",
                "eligible": "Uygun",
                "approve": "Onayla",
                "reject": "Reddet",
                "approved": "{'@'}{username} onaylandı · {partner} listesinde \"Bekliyor\"",
                "rejected": "{'@'}{username} için referans reddedildi",
                "error": "İşlem yapılamadı. Biraz sonra tekrar dene.",
                "rejectTitle": "Referansı reddet",
                "rejectText": "{'@'}{username} için {partner} tarafından verilen referans reddedilecek. Referans hiç sayılmaz, pay oluşmaz.",
                "reason": "Neden",
                "reasonPlaceholder": "İsteğe bağlı",
                "reasonHint": "İş ortağı bu metni Yayıncılarım'da görür.",
                "cancel": "Vazgeç"
            }
        },
        "list": {
            "add": "İş ortağı ekle",
            "search": "Ad veya e-posta ile ara",
            "filter": { "group": "İş ortağı", "status": "Durum", "plan": "Pay planı" },
            "empty": "Henüz iş ortağı yok.",
            "suspended": "{n} askıda",
            "invited": "{n} davet bekliyor",
            "stat": {
                "active": "Aktif iş ortağı",
                "creators": "Getirdikleri yayıncı",
                "creatorsSub": "{n} tanesi henüz ajansta değil",
                "payable": "Bu ay ödenecek",
                "payableSub": "Tahmini, ay sürüyor",
                "net": "Bu yayıncılardan ajansa kalan",
                "netSub": "İş ortağı payı düşülmüş"
            },
            "col": {
                "partner": "İş ortağı",
                "active": "Ajansta",
                "pending": "Bekliyor",
                "plan": "Pay planı",
                "status": "Durum"
            }
        },
        "detail": {
            "title": "İş ortağı",
            "since": "{date}'den beri",
            "suspend": "Askıya al",
            "activate": "Etkinleştir",
            "edit": "Düzenle",
            "notFound": "İş ortağı bulunamadı.",
            "stat": {
                "month": "Bu ay pay",
                "paid": "Toplam ödenen",
                "paidSub": "Ödendi olarak işaretlenenler"
            },
            "tab": {
                "creators": "Yayıncılar",
                "payouts": "Ödemeler",
                "plan": "Pay planı",
                "conflicts": "Çakışmalar"
            },
            "col": {
                "month": "Ay",
                "creators": "Yayıncı",
                "net": "Ajansa kalan",
                "amount": "İş ortağı payı"
            },
            "markPaid": "Ödendi olarak işaretle",
            "markPaidTitle": "{month} ödemesi",
            "invoiceNo": "Fatura no",
            "invoicePlaceholder": "Örn. DM-2026-08",
            "walletNote": "Cüzdana yatırılacak, fatura no gerekmez",
            "paidDone": "Ödeme işaretlendi.",
            "confirmsAtEnd": "Ay sonunda kesinleşir",
            "openPlan": "Planı aç",
            "noPlan": "Bu iş ortağına henüz plan atanmamış.",
            "conflicts": "Çakışmalar",
            "noConflicts": "Çakışma yok.",
            "conflictText": "Adaylar listesinde {manager} adlı yöneticiye atanmış. {partner} {date} tarihinde referans verdi.",
            "conflictHint": "Aynı kişiyi hem bir yönetici hem bir iş ortağı getirmeye çalışırsa karar burada verilir.",
            "keepPartner": "İş ortağında kalsın",
            "giveManager": "Yöneticiye ver",
            "resolved": "Karar kaydedildi."
        },
        "drawer": {
            "planPlaceholder": "Plan seç",
            "addTitle": "İş ortağı ekle",
            "editTitle": "İş ortağını düzenle",
            "who": "Kim?",
            "name": "Firma ya da kişi adı",
            "contact": "Yetkili kişi",
            "email": "E-posta",
            "phone": "Telefon",
            "inviteNote": "Kaydedince e-postasına davet gider. Panele normal giriş sayfasından, kendi belirlediği şifreyle girer; yalnız kendi ekranlarını görür.",
            "plan": "Pay planı",
            "months": "{n} ay",
            "custom": "Özel · {name}",
            "partnerCount": "{n} iş ortağı",
            "noPlans": "Henüz plan yok. Aşağıdan bu iş ortağına özel bir plan yapabilirsin.",
            "makeCustom": "Bu iş ortağına özel plan yap",
            "access": "Erişim ve ödeme",
            "showDiamonds": "Yayıncının elmasını görsün",
            "showDiamondsHint": "Yayıncılarım listesinde \"Bu ay elmas\" sütunu",
            "showTasks": "Görev görev dökümü görsün",
            "showTasksHint": "Kazancım'da aktiflik, seviye, kademeli ayrımı",
            "mfaRequired": "İki adımlı doğrulama zorunlu",
            "mfaRequiredHint": "Açıkken iş ortağı girişte ikinci adım kodu girer",
            "payout": "Ödeme şekli",
            "payoutInvoice": "Ay sonu, fatura ile",
            "payoutWallet": "Uygulama cüzdanına",
            "account": "Hesap",
            "resend": "Daveti tekrar gönder",
            "resent": "Davet tekrar gönderildi.",
            "suspendConfirm": "{name} askıya alınsın mı? Giriş yapamaz ve yeni referans veremez.",
            "saveInvite": "Kaydet ve davet et",
            "saved": "Kaydedildi.",
            "invited": "İş ortağı eklendi, davet gönderildi.",
            "saveError": "Kaydedilemedi. Alanları kontrol edip tekrar dene."
        },
        "plans": {
            "add": "Plan ekle",
            "empty": "Henüz pay planı yok.",
            "search": "Plan adı ara",
            "filter": { "group": "Plan", "owner": "Kime ait" },
            "template": "Şablon",
            "custom": "Özel",
            "col": {
                "name": "Plan",
                "owner": "Kime ait",
                "partners": "İş ortağı",
                "from": "Geçerlilik",
                "duration": "Süre",
                "cap": "Aylık üst sınır",
                "tasks": "Görevler"
            }
        },
        "plan": {
            "title": "Pay planı",
            "newName": "Yeni plan",
            "name": "Plan adı",
            "validity": "Geçerlilik",
            "validFrom": "{month} ayından itibaren",
            "validNext": "Kaydedince bir sonraki açık aydan başlar",
            "validHint": "Değişiklik bir sonraki açık aydan başlar, geçmiş aylar değişmez.",
            "usedBy": "{n} iş ortağı bu planı kullanıyor: {names}",
            "forPartner": "Bu plan yalnız bu iş ortağına özel olacak.",
            "copy": "Kopyala",
            "saved": "Kaydedildi. Yeni sürüm {month} ayından başlar.",
            "created": "Plan oluşturuldu.",
            "copied": "Plan kopyalandı.",
            "tasks": "Görevler",
            "tasksHint": "Her görev için iş ortağının alacağı oran. \"Ajansa kalan\": TikTok'un ajansa ödediğinden yayıncıya verdiğin pay düşülür.",
            "col": {
                "include": "Dahil",
                "task": "Görev",
                "base": "Taban",
                "rate": "Oran"
            },
            "base": {
                "NET": "Ajansa kalan",
                "GROSS": "Brüt"
            },
            "excluded": "Plana dahil değil",
            "activenessNote": "Bugün yayıncıya %100 verildiği için ajansa kalan 0; bu satır şimdilik pay üretmez.",
            "rules": "Koşullar",
            "rulesHint": "\"Oranı yap\" koşullarından uyan ilk uygulanır; \"Oran ekle\" koşulları uyuyorsa üstüne eklenir. Hiçbiri uymazsa görev tablosundaki oran geçerli.",
            "if": "EĞER",
            "then": "İSE",
            "min": "en az",
            "max": "en çok",
            "allTasks": "Tüm görevler",
            "addRule": "Koşul ekle",
            "removeRule": "Koşulu sil",
            "moveUp": "Yukarı taşı",
            "moveDown": "Aşağı taşı",
            "delete": "Sil",
            "deleteConfirm": "\"{name}\" planı silinsin mi? Geçmiş sürümler ve kazançlar korunur, yalnız listeden kalkar.",
            "deleted": "Plan silindi.",
            "tryPick": "Yayıncı ara",
            "tryPickPh": "Ad, kullanıcı adı…",
            "condOptions": "Koşul seçenekleri: yayıncının ajanstaki ayı, yayıncının aylık elması, görevde ulaşılan aşama, yayıncının seviyesi, iş ortağının ajanstaki yayıncı sayısı.",
            "cond": {
                "MONTHS_IN_AGENCY": "Yayıncının ajanstaki ayı",
                "CREATOR_MONTHLY_DIAMONDS": "Yayıncının aylık elması",
                "TASK_STAGE": "Görevde ulaşılan aşama",
                "CREATOR_LEVEL": "Yayıncının seviyesi",
                "PARTNER_ACTIVE_CREATORS": "İş ortağının ajanstaki yayıncı sayısı"
            },
            "action": {
                "SET": "Oranı yap",
                "ADD": "Oran ekle"
            },
            "unitMonth": "ay",
            "unitDiamond": "elmas",
            "unitStage": "aşama",
            "unitCreators": "yayıncı",
            "durationCap": "Süre ve sınır",
            "duration": "Her yayıncı için pay süresi",
            "unlimited": "Süresiz",
            "durationHint": "Yayıncının katıldığı aydan itibaren sayılır.",
            "cap": "Yayıncı başına aylık üst sınır",
            "capHint": "Boş bırakırsan sınır yok.",
            "capApplied": "Yayıncı başına aylık üst sınır uygulandı.",
            "try": "Dene",
            "tryHint": "Gerçek bir yayıncının bir ayıyla planı sına. Kaydetmeden, ekrandaki haliyle hesaplanır.",
            "tryCreator": "Yayıncı",
            "tryMonth": "Ay",
            "tryRun": "Dene",
            "simError": "Hesaplanamadı. Kullanıcı adını ve ayı kontrol et.",
            "simMonths": "Ajanstaki {n}. ayı",
            "simActive": "{n} aktif yayıncı",
            "sim": {
                "income": "TikTok → ajans",
                "creator": "Yayıncıya",
                "base": "Kalan",
                "amount": "Pay",
                "total": "Toplam",
                "stage": "{n}. aşama",
                "applied": "Uygulanan koşul",
                "noRule": "Yok, görev oranı geçerli",
                "keeps": "Ajansta kalan"
            }
        }
    }
}
